export type ModCategory =
  | "Tech"
  | "Magic"
  | "World"
  | "QoL"
  | "Performance"
  | "Adventure"
  | "Library"
  | "Resource Pack"
  | "Shader"

export type ModContentType = 'Mods' | 'Resource Packs' | 'Shaders'

export interface Mod {
  name: string
  category: ModCategory
  contentType: ModContentType
  projectId: number
  fileId: number
  fileName: string
  author: string
  url: string
  downloadUrl: string
  thumbnailUrl: string
  fileDate: string
  fileSizeBytes: number
  gameVersions: string[]
  dependencyCount: number
  sha1: string
  md5: string
  blurb: string
}

export const modCategories: ModCategory[] = [
  "Tech",
  "Magic",
  "World",
  "QoL",
  "Performance",
  "Adventure",
  "Library",
  "Resource Pack",
  "Shader",
]

// Generated from the local CurseForge Uliunai profile on 2026-06-15.
// Source: C:\\Users\\georg\\curseforge\\minecraft\\Instances\\Uliunai\\minecraftinstance.json
export const mods: Mod[] = [
  {
    name: "[BUB] Gender",
    category: "QoL",
    contentType: "Mods",
    projectId: 1497835,
    fileId: 8247079,
    fileName: "genderbub-neoforge-2.0.7.jar",
    author: "bebub",
    url: "https://www.curseforge.com/minecraft/mc-mods/genderbub",
    downloadUrl: "https://edge.forgecdn.net/files/8247/79/genderbub-neoforge-2.0.7.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1778/762/256/256/639128890690445739.png",
    fileDate: "2026-06-14T12:33:02.39Z",
    fileSizeBytes: 103696,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "9b7b7203efb1311a9df392cce8c7a289857f76ce",
    md5: "e8a4453c28b4bce7855ec180493a88ab",
    blurb: "Mod by bebub. Installed file: genderbub-neoforge-2.0.7.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Accessories",
    category: "QoL",
    contentType: "Mods",
    projectId: 938917,
    fileId: 7583320,
    fileName: "accessories-neoforge-1.1.0-beta.53+1.21.1.jar",
    author: "Blodhgarm",
    url: "https://www.curseforge.com/minecraft/mc-mods/accessories",
    downloadUrl: "https://edge.forgecdn.net/files/7583/320/accessories-neoforge-1.1.0-beta.53%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/948/913/256/256/638436487112587498.png",
    fileDate: "2026-02-06T07:37:53.473Z",
    fileSizeBytes: 1078697,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "77d75c2e13cfdf56a45cdd29806c1c97c3d250fc",
    md5: "f826cbb52d4d05e069eecda4cff65e30",
    blurb: "Mod by Blodhgarm. Installed file: accessories-neoforge-1.1.0-beta.53+1.21.1.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Ace's Spell Utils",
    category: "Magic",
    contentType: "Mods",
    projectId: 1299492,
    fileId: 8079666,
    fileName: "aces_spell_utils-1.2.6.1-1.21.1.jar",
    author: "Ace_The_Eldritch_King",
    url: "https://www.curseforge.com/minecraft/mc-mods/aces-spell-utils",
    downloadUrl: "https://edge.forgecdn.net/files/8079/666/aces_spell_utils-1.2.6.1-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1340/967/256/256/638871626769449390.png",
    fileDate: "2026-05-12T20:31:41.02Z",
    fileSizeBytes: 243160,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "6cad17fe69b70ac13c2d31cd6e2cad15e21998e8",
    md5: "784c42cbf04b5315e8e57e093c447137",
    blurb: "Mod by Ace_The_Eldritch_King. Installed file: aces_spell_utils-1.2.6.1-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "AI Improvements",
    category: "Performance",
    contentType: "Mods",
    projectId: 233019,
    fileId: 5426792,
    fileName: "AI-Improvements-1.21-0.5.3.jar",
    author: "QueenOfMissiles",
    url: "https://www.curseforge.com/minecraft/mc-mods/ai-improvements",
    downloadUrl: "https://edge.forgecdn.net/files/5426/792/AI-Improvements-1.21-0.5.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/21/699/256/256/635731173265581096.png",
    fileDate: "2024-06-14T06:55:01.61Z",
    fileSizeBytes: 28984,
    gameVersions: ["1.21","Client","1.21.4","NeoForge","1.21.3","1.21.1","Server","1.21.2"],
    dependencyCount: 0,
    sha1: "b4a8e11384454bcc341043b251db7fb5afdfdf45",
    md5: "fd80ae9f154ac230e60fb138f9b5453f",
    blurb: "Mod by QueenOfMissiles. Installed file: AI-Improvements-1.21-0.5.3.jar. Game versions: 1.21, Client, 1.21.4, NeoForge, 1.21.3, 1.21.1, Server, 1.21.2.",
  },
  {
    name: "AmbientSounds 6",
    category: "QoL",
    contentType: "Mods",
    projectId: 254284,
    fileId: 8043019,
    fileName: "AmbientSounds_NEOFORGE_v6.3.8_mc1.21.1.jar",
    author: "CreativeMD",
    url: "https://www.curseforge.com/minecraft/mc-mods/ambientsounds",
    downloadUrl: "https://edge.forgecdn.net/files/8043/19/AmbientSounds_NEOFORGE_v6.3.8_mc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/65/45/256/256/636158453613581226.png",
    fileDate: "2026-05-05T12:27:30.767Z",
    fileSizeBytes: 84811632,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "c79ab328b2c46068effebdcb3f26e98dc4404cb0",
    md5: "fdd3f4054a8a2716cb4057d81e61a0c7",
    blurb: "Mod by CreativeMD. Installed file: AmbientSounds_NEOFORGE_v6.3.8_mc1.21.1.jar. Game versions: Client, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Animals Plus",
    category: "Adventure",
    contentType: "Mods",
    projectId: 465386,
    fileId: 5868856,
    fileName: "animalplus neoforge 1.21.1 (1.0.1v.).jar",
    author: "noxgame1230",
    url: "https://www.curseforge.com/minecraft/mc-mods/animals-plus",
    downloadUrl: "https://edge.forgecdn.net/files/5868/856/animalplus%20neoforge%201.21.1%20(1.0.1v.).jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/765/550/256/256/638101560890386270.png",
    fileDate: "2024-11-02T17:43:14.64Z",
    fileSizeBytes: 201156,
    gameVersions: ["1.21.1-Snapshot","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "1e4c44ad69fa020442885ec49648bf3e422ddc5d",
    md5: "505d48a70278b409165ac04e9f6225b3",
    blurb: "Mod by noxgame1230. Installed file: animalplus neoforge 1.21.1 (1.0.1v.).jar. Game versions: 1.21.1-Snapshot, NeoForge, 1.21.1.",
  },
  {
    name: "Antique Trading Ship",
    category: "World",
    contentType: "Mods",
    projectId: 1034045,
    fileId: 6445160,
    fileName: "antiquetradingship-1.4.0-neoforge-1.21.1.jar",
    author: "SuperWarioModTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/antique-trading-ship",
    downloadUrl: "https://edge.forgecdn.net/files/6445/160/antiquetradingship-1.4.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1086/497/256/256/638628729014366294.jpg",
    fileDate: "2025-04-20T19:28:32.23Z",
    fileSizeBytes: 24458,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "7eb7f2255a37d43788103a00f5076d7bc20423c9",
    md5: "b98e053a1b3505df6aff5984d8fe5051",
    blurb: "Mod by SuperWarioModTeam. Installed file: antiquetradingship-1.4.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "AnvilCore 🔨",
    category: "Library",
    contentType: "Mods",
    projectId: 1470821,
    fileId: 7771419,
    fileName: "anvilcore-10.1 Release-neoforge-1.21.1.jar",
    author: "SmartStreamLabs",
    url: "https://www.curseforge.com/minecraft/mc-mods/anvilcore",
    downloadUrl: "https://edge.forgecdn.net/files/7771/419/anvilcore-10.1%20Release-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1694/142/256/256/639075385327421876.png",
    fileDate: "2026-03-17T13:19:32.58Z",
    fileSizeBytes: 104557,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "d807fa23228c5260aa85413c4eab03a577cdd255",
    md5: "bb2247cfcf5517a223f2b35669b5075c",
    blurb: "Mod by SmartStreamLabs. Installed file: anvilcore-10.1 Release-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "AppleSkin",
    category: "QoL",
    contentType: "Mods",
    projectId: 248787,
    fileId: 7854442,
    fileName: "appleskin-neoforge-mc1.21-3.0.9.jar",
    author: "squeek502",
    url: "https://www.curseforge.com/minecraft/mc-mods/appleskin",
    downloadUrl: "https://edge.forgecdn.net/files/7854/442/appleskin-neoforge-mc1.21-3.0.9.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/47/527/256/256/636066936394500688.png",
    fileDate: "2026-04-01T04:44:43.28Z",
    fileSizeBytes: 75804,
    gameVersions: ["1.21","1.21.1","NeoForge","1.21.2"],
    dependencyCount: 0,
    sha1: "81cf0e668f991f83ac8820c386fbd6c9c3602246",
    md5: "db5fe7619d502cf5b9bc972a955cd3bc",
    blurb: "Mod by squeek502. Installed file: appleskin-neoforge-mc1.21-3.0.9.jar. Game versions: 1.21, 1.21.1, NeoForge, 1.21.2.",
  },
  {
    name: "Architectury API",
    category: "Library",
    contentType: "Mods",
    projectId: 419699,
    fileId: 5786327,
    fileName: "architectury-13.0.8-neoforge.jar",
    author: "shedaniel",
    url: "https://www.curseforge.com/minecraft/mc-mods/architectury-api",
    downloadUrl: "https://edge.forgecdn.net/files/5786/327/architectury-13.0.8-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/313/420/256/256/637408811378175814.png",
    fileDate: "2024-10-05T19:24:07.34Z",
    fileSizeBytes: 584004,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "6ca11d3cc136bf69bb8f4d56982481eb85b5100b",
    md5: "7a45a948b525c031ca85d221dfdbed85",
    blurb: "Mod by shedaniel. Installed file: architectury-13.0.8-neoforge.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Armor Set Bonuses (NeoForge /Forge)",
    category: "Adventure",
    contentType: "Mods",
    projectId: 549892,
    fileId: 7744114,
    fileName: "Armor-Set-Bonuses-1.21.1-NeoForge-1.0.1.jar",
    author: "SpaceCat_97",
    url: "https://www.curseforge.com/minecraft/mc-mods/armor-set-bonuses",
    downloadUrl: "https://edge.forgecdn.net/files/7744/114/Armor-Set-Bonuses-1.21.1-NeoForge-1.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1693/523/256/256/639074832951534212.png",
    fileDate: "2026-03-11T19:08:32.04Z",
    fileSizeBytes: 91545,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "044197a70b9a42085ea2c39809ed64e5ee00d942",
    md5: "5945106248cdeaae0e7ae69167e42496",
    blurb: "Mod by SpaceCat_97. Installed file: Armor-Set-Bonuses-1.21.1-NeoForge-1.0.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Atlas Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 463826,
    fileId: 5449009,
    fileName: "Atlas-Lib-1.21.0-1.1.14.jar",
    author: "smileycorp",
    url: "https://www.curseforge.com/minecraft/mc-mods/atlas-lib",
    downloadUrl: "https://edge.forgecdn.net/files/5449/9/Atlas-Lib-1.21.0-1.1.14.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/544/923/256/256/637877302202441012.png",
    fileDate: "2024-06-20T15:03:51.873Z",
    fileSizeBytes: 93183,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "8aa32c7595496206dcab266705489914565cc8f7",
    md5: "4b505b34372f6d9f3b39a5e091097ab8",
    blurb: "Mod by smileycorp. Installed file: Atlas-Lib-1.21.0-1.1.14.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Autumnity",
    category: "World",
    contentType: "Mods",
    projectId: 365045,
    fileId: 7118591,
    fileName: "autumnity-1.21.1-6.0.1.jar",
    author: "TeamAbnormals",
    url: "https://www.curseforge.com/minecraft/mc-mods/autumnity",
    downloadUrl: "https://edge.forgecdn.net/files/7118/591/autumnity-1.21.1-6.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/311/847/256/256/637403908563202563.png",
    fileDate: "2025-10-17T22:01:03.127Z",
    fileSizeBytes: 1261462,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "3863fa0d77f89955b04ecaad9a3a9c91f76937d8",
    md5: "396be769f1106f99c2902348aff82d1b",
    blurb: "Mod by TeamAbnormals. Installed file: autumnity-1.21.1-6.0.1.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "AzureLib Armor",
    category: "Adventure",
    contentType: "Mods",
    projectId: 912767,
    fileId: 7797728,
    fileName: "azurelibarmor-neo-1.21.1-3.1.3.jar",
    author: "AzureDoomC",
    url: "https://www.curseforge.com/minecraft/mc-mods/azurelib-armor",
    downloadUrl: "https://edge.forgecdn.net/files/7797/728/azurelibarmor-neo-1.21.1-3.1.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/877/171/256/256/638302030446177319.png",
    fileDate: "2026-03-23T01:39:04.35Z",
    fileSizeBytes: 574146,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "953b10bcad39f5932ed5f1a2621a070946bc4c13",
    md5: "cb6419355f109bc6ed93dcc5f58d036d",
    blurb: "Mod by AzureDoomC. Installed file: azurelibarmor-neo-1.21.1-3.1.3.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Bagus Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 866533,
    fileId: 7612281,
    fileName: "bagus_lib-1.21.1-13.25.1.jar",
    author: "baguchiMC",
    url: "https://www.curseforge.com/minecraft/mc-mods/bagus-lib",
    downloadUrl: "https://edge.forgecdn.net/files/7612/281/bagus_lib-1.21.1-13.25.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/823/493/256/256/638207839618102494.png",
    fileDate: "2026-02-12T01:09:46.43Z",
    fileSizeBytes: 224874,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "d4251434fe01daff0879e93199c952d1456b5819",
    md5: "d83535bf3ff32fcf820ebe03d586093d",
    blurb: "Mod by baguchiMC. Installed file: bagus_lib-1.21.1-13.25.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Balm",
    category: "Library",
    contentType: "Mods",
    projectId: 531761,
    fileId: 7420963,
    fileName: "balm-neoforge-1.21.1-21.0.56.jar",
    author: "BlayTheNinth",
    url: "https://www.curseforge.com/minecraft/mc-mods/balm",
    downloadUrl: "https://edge.forgecdn.net/files/7420/963/balm-neoforge-1.21.1-21.0.56.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1107/117/256/256/638657111836546584.png",
    fileDate: "2026-01-05T13:50:26.647Z",
    fileSizeBytes: 739709,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "c1c1d4859c7943c7d1c181c07fa7273a1d56df15",
    md5: "7ab16721c9a8bb96666233d8ef46b47d",
    blurb: "Mod by BlayTheNinth. Installed file: balm-neoforge-1.21.1-21.0.56.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Bamboo Everything",
    category: "QoL",
    contentType: "Mods",
    projectId: 331723,
    fileId: 7170711,
    fileName: "bambooeverything-neoforge-21.1.2+mc1.21.1.jar",
    author: "Gaz_",
    url: "https://www.curseforge.com/minecraft/mc-mods/bamboo-everything",
    downloadUrl: "https://edge.forgecdn.net/files/7170/711/bambooeverything-neoforge-21.1.2%2bmc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/425/424/256/256/637654319432130352.png",
    fileDate: "2025-10-31T15:26:02.753Z",
    fileSizeBytes: 159095,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "55805b9d85964a1e0a2ce30955d55d969573de9e",
    md5: "bb0f7c012d8b29a32bff3b05f7910d64",
    blurb: "Mod by Gaz_. Installed file: bambooeverything-neoforge-21.1.2+mc1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Better Keep Inventory",
    category: "QoL",
    contentType: "Mods",
    projectId: 1189399,
    fileId: 6152711,
    fileName: "keep_inventory-neoforge-1.21-0.1.0.jar",
    author: "CubicNexus",
    url: "https://www.curseforge.com/minecraft/mc-mods/better-keep-inventory",
    downloadUrl: "https://edge.forgecdn.net/files/6152/711/keep_inventory-neoforge-1.21-0.1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1167/66/256/256/638737517171696690.png",
    fileDate: "2025-02-03T05:43:32.107Z",
    fileSizeBytes: 884706,
    gameVersions: ["1.21","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "d66b974e20a0874c3b5f9c4587207e7f58a5c112",
    md5: "d552b8c97d0cc0c55fad82dad801351f",
    blurb: "Mod by CubicNexus. Installed file: keep_inventory-neoforge-1.21-0.1.0.jar. Game versions: 1.21, NeoForge, 1.21.1, Server.",
  },
  {
    name: "better mob : jungle expansion",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1543656,
    fileId: 8108250,
    fileName: "better_mob_jungle_expansion-1.2.0-neoforge-1.21.1.jar",
    author: "bettergame",
    url: "https://www.curseforge.com/minecraft/mc-mods/better-mob-jungle-expansion",
    downloadUrl: "https://edge.forgecdn.net/files/8108/250/better_mob_jungle_expansion-1.2.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1808/841/256/256/639144315053790657.png",
    fileDate: "2026-05-18T10:33:13.143Z",
    fileSizeBytes: 4781771,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "944455050ffee3c2e7d27fbdafe0f26f418bb3dd",
    md5: "65066fc2fc66274f64cad890194861e2",
    blurb: "Mod by bettergame. Installed file: better_mob_jungle_expansion-1.2.0-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "better mob : savana exspansion",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1534682,
    fileId: 8108255,
    fileName: "better_mob__savana_expansion-1.2.0-neoforge-1.21.1.jar",
    author: "bettergame",
    url: "https://www.curseforge.com/minecraft/mc-mods/better-mob-savana-exspansion",
    downloadUrl: "https://edge.forgecdn.net/files/8108/255/better_mob__savana_expansion-1.2.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1792/921/256/256/639135905228967061.png",
    fileDate: "2026-05-18T10:33:39.393Z",
    fileSizeBytes: 4459487,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "0d5d181ccbcb78d0c7ca9057d1b2285827832d6e",
    md5: "1075eba65056c6d1464d421bbeab959f",
    blurb: "Mod by bettergame. Installed file: better_mob__savana_expansion-1.2.0-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge.",
  },
  {
    name: "Biome Replacer",
    category: "World",
    contentType: "Mods",
    projectId: 910274,
    fileId: 6807125,
    fileName: "biomereplacer-2.1-hippo-neo.jar",
    author: "werdei",
    url: "https://www.curseforge.com/minecraft/mc-mods/biome-replacer",
    downloadUrl: "https://edge.forgecdn.net/files/6807/125/biomereplacer-2.1-hippo-neo.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1201/699/256/256/638778511305728771.png",
    fileDate: "2025-07-24T15:22:48.323Z",
    fileSizeBytes: 212926,
    gameVersions: ["1.21","1.20.5","NeoForge","1.20.6","1.21.1"],
    dependencyCount: 0,
    sha1: "b367cdee6ba5732a0de829e915f4be42b973d705",
    md5: "5308c2ecae06169e0fea540eaec3901e",
    blurb: "Mod by werdei. Installed file: biomereplacer-2.1-hippo-neo.jar. Game versions: 1.21, 1.20.5, NeoForge, 1.20.6, 1.21.1.",
  },
  {
    name: "Biomes O' Plenty",
    category: "World",
    contentType: "Mods",
    projectId: 220318,
    fileId: 7251965,
    fileName: "BiomesOPlenty-neoforge-1.21.1-21.1.0.13.jar",
    author: "Forstride",
    url: "https://www.curseforge.com/minecraft/mc-mods/biomes-o-plenty",
    downloadUrl: "https://edge.forgecdn.net/files/7251/965/BiomesOPlenty-neoforge-1.21.1-21.1.0.13.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/477/194/256/256/637771671789296797.png",
    fileDate: "2025-11-23T04:05:05.193Z",
    fileSizeBytes: 22338081,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "a0dec78a9c1bb7e0167e5326aaf3c58a94f3aa86",
    md5: "5fffd607544c0c158957a5df7a510bd8",
    blurb: "Mod by Forstride. Installed file: BiomesOPlenty-neoforge-1.21.1-21.1.0.13.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Blueprint",
    category: "Library",
    contentType: "Mods",
    projectId: 382216,
    fileId: 8048607,
    fileName: "blueprint-1.21.1-8.1.0.jar",
    author: "TeamAbnormals",
    url: "https://www.curseforge.com/minecraft/mc-mods/blueprint",
    downloadUrl: "https://edge.forgecdn.net/files/8048/607/blueprint-1.21.1-8.1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/312/201/256/256/637404991289658535.png",
    fileDate: "2026-05-06T15:37:43.18Z",
    fileSizeBytes: 1198111,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "980070b8bba4c0ddbeb1c665e48d9d74841ab35a",
    md5: "731ccc22724d390795c3151ec73b6d34",
    blurb: "Mod by TeamAbnormals. Installed file: blueprint-1.21.1-8.1.0.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Born in Chaos",
    category: "Adventure",
    contentType: "Mods",
    projectId: 686437,
    fileId: 7917953,
    fileName: "born_in_chaos_[Neoforge]_1.21.1_1.7.5.jar",
    author: "mongoose_artist",
    url: "https://www.curseforge.com/minecraft/mc-mods/born-in-chaos",
    downloadUrl: "https://edge.forgecdn.net/files/7917/953/born_in_chaos_%5bNeoforge%5d_1.21.1_1.7.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/778/486/256/256/638122554849559119.png",
    fileDate: "2026-04-12T21:18:59.59Z",
    fileSizeBytes: 11841361,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 4,
    sha1: "60d2ce7f9ce3f6e5da6a0bce0a84048fe3a0152e",
    md5: "f60d0ed7a52b341273f3ae82f7e284df",
    blurb: "Mod by mongoose_artist. Installed file: born_in_chaos_[Neoforge]_1.21.1_1.7.5.jar. Game versions: Client, 1.21.1, NeoForge, Server. 4 required dependencies.",
  },
  {
    name: "Bounty",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1472014,
    fileId: 7679082,
    fileName: "jonesbounty-1.0.1-neoforge-1.21.1.jar",
    author: "avatarfreak",
    url: "https://www.curseforge.com/minecraft/mc-mods/bounty",
    downloadUrl: "https://edge.forgecdn.net/files/7679/82/jonesbounty-1.0.1-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1695/817/256/256/639076599340987082.png",
    fileDate: "2026-02-25T23:46:24.993Z",
    fileSizeBytes: 102416,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "9e6ac30d34f59cb48e40a61f62d0036876c17270",
    md5: "3ad39695fb7a249c777ba1039d606822",
    blurb: "Mod by avatarfreak. Installed file: jonesbounty-1.0.1-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Brutal Bosses - Custom Bosses[Forge/Fabric]",
    category: "World",
    contentType: "Mods",
    projectId: 557999,
    fileId: 7662187,
    fileName: "brutalbosses-1.21.1-8.6.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/brutal-bosses-dungeon",
    downloadUrl: "https://edge.forgecdn.net/files/7662/187/brutalbosses-1.21.1-8.6.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/532/502/256/256/637856160336091283.png",
    fileDate: "2026-02-22T09:05:38.89Z",
    fileSizeBytes: 199019,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "47154ce207ca3bbcfba1bf56c6d2d6a58511a102",
    md5: "f70778a081ed4996d97a6a99f60ce7ec",
    blurb: "Mod by someaddon. Installed file: brutalbosses-1.21.1-8.6.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Bundle API",
    category: "Library",
    contentType: "Mods",
    projectId: 1189983,
    fileId: 7006149,
    fileName: "bundle-api-neoforge-1.1.0.jar",
    author: "TheRedBrain",
    url: "https://www.curseforge.com/minecraft/mc-mods/bundle-api",
    downloadUrl: "https://edge.forgecdn.net/files/7006/149/bundle-api-neoforge-1.1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1167/796/256/256/638738448698340699.png",
    fileDate: "2025-09-17T14:58:20.953Z",
    fileSizeBytes: 64124,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "49ea32e2872c9738363eb76a97ce0553bd2ff756",
    md5: "f80e6aca586952b984ac4397204190e9",
    blurb: "Mod by TheRedBrain. Installed file: bundle-api-neoforge-1.1.0.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Buzzier Bees",
    category: "QoL",
    contentType: "Mods",
    projectId: 355458,
    fileId: 6961149,
    fileName: "buzzier_bees-1.21.1-7.0.1.jar",
    author: "TeamAbnormals",
    url: "https://www.curseforge.com/minecraft/mc-mods/buzzier-bees",
    downloadUrl: "https://edge.forgecdn.net/files/6961/149/buzzier_bees-1.21.1-7.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/582/835/256/256/637949117785909406.png",
    fileDate: "2025-09-04T00:37:34.21Z",
    fileSizeBytes: 592651,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "4f81fb00557fa5bcca5fb732b02b7921b9e11731",
    md5: "9a3cb83fc09976a41c4cc34f70af90fb",
    blurb: "Mod by TeamAbnormals. Installed file: buzzier_bees-1.21.1-7.0.1.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Canned Goods :|",
    category: "QoL",
    contentType: "Mods",
    projectId: 643975,
    fileId: 6735275,
    fileName: "CannedGoods-1.21.1-3.jar",
    author: "Murdrbanna",
    url: "https://www.curseforge.com/minecraft/mc-mods/canned-goods",
    downloadUrl: "https://edge.forgecdn.net/files/6735/275/CannedGoods-1.21.1-3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/630/981/256/256/638031142700135813.png",
    fileDate: "2025-07-06T00:51:55.52Z",
    fileSizeBytes: 225025,
    gameVersions: ["NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "fa4a457907f838bb603bb8c053cd2de7a5035fa0",
    md5: "7d2dddd211bbaeba778ebe082991dff0",
    blurb: "Mod by Murdrbanna. Installed file: CannedGoods-1.21.1-3.jar. Game versions: NeoForge, 1.21.1, Server.",
  },
  {
    name: "Chat Heads",
    category: "QoL",
    contentType: "Mods",
    projectId: 407206,
    fileId: 8244448,
    fileName: "chat_heads-0.15.2-neoforge-1.21.jar",
    author: "dzwdz",
    url: "https://www.curseforge.com/minecraft/mc-mods/chat-heads",
    downloadUrl: "https://edge.forgecdn.net/files/8244/448/chat_heads-0.15.2-neoforge-1.21.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/299/225/256/256/637352537610256484.png",
    fileDate: "2026-06-13T22:21:31.627Z",
    fileSizeBytes: 89325,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "86abc08fbfa8eb3e2a41aa4403a6bd52543ea665",
    md5: "89af3740560775899e9a5f6a7e9cc050",
    blurb: "Mod by dzwdz. Installed file: chat_heads-0.15.2-neoforge-1.21.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Citadel (Unofficial Port)",
    category: "Library",
    contentType: "Mods",
    projectId: 1415723,
    fileId: 7982052,
    fileName: "citadel-1.21.1-2.7.6.jar",
    author: "Raguto",
    url: "https://www.curseforge.com/minecraft/mc-mods/citadel-1-21-1-port",
    downloadUrl: "https://edge.forgecdn.net/files/7982/52/citadel-1.21.1-2.7.6.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1585/203/256/256/639025963417433066.png",
    fileDate: "2026-04-25T11:58:32.843Z",
    fileSizeBytes: 3028943,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "e0392370117ec16a721f8d65728944398de77607",
    md5: "f489330f610335c782c61ce8815b16f1",
    blurb: "Mod by Raguto. Installed file: citadel-1.21.1-2.7.6.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Classic Pipes",
    category: "Tech",
    contentType: "Mods",
    projectId: 1351745,
    fileId: 8054942,
    fileName: "classicpipes-neoforge-1.21.1-1.1.5.jar",
    author: "Jagm11",
    url: "https://www.curseforge.com/minecraft/mc-mods/classic-pipes",
    downloadUrl: "https://edge.forgecdn.net/files/8054/942/classicpipes-neoforge-1.21.1-1.1.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1454/494/256/256/638944011641285523.png",
    fileDate: "2026-05-07T22:10:39.13Z",
    fileSizeBytes: 724131,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "68dc5eaa55ac4eb40595939ba294b2116aecd043",
    md5: "673d102bf5b66545690f836567ade744",
    blurb: "Mod by Jagm11. Installed file: classicpipes-neoforge-1.21.1-1.1.5.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Cloth Config API (Fabric/Forge/NeoForge)",
    category: "Library",
    contentType: "Mods",
    projectId: 348521,
    fileId: 5729127,
    fileName: "cloth-config-15.0.140-neoforge.jar",
    author: "shedaniel",
    url: "https://www.curseforge.com/minecraft/mc-mods/cloth-config",
    downloadUrl: "https://edge.forgecdn.net/files/5729/127/cloth-config-15.0.140-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/282/467/256/256/637289313020452406.png",
    fileDate: "2024-09-16T17:18:01.157Z",
    fileSizeBytes: 1163890,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "c3e5733ba4503b102589a026000fd5ce0212f6f2",
    md5: "4c3757160403fcccb8ad468c2ea22862",
    blurb: "Mod by shedaniel. Installed file: cloth-config-15.0.140-neoforge.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Cold Sweat",
    category: "QoL",
    contentType: "Mods",
    projectId: 506194,
    fileId: 8170896,
    fileName: "ColdSweat-2.4.1.jar",
    author: "Mikul",
    url: "https://www.curseforge.com/minecraft/mc-mods/cold-sweat",
    downloadUrl: "https://edge.forgecdn.net/files/8170/896/ColdSweat-2.4.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1108/699/256/256/638659111909074275.png",
    fileDate: "2026-05-30T18:00:49.13Z",
    fileSizeBytes: 2709796,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 26,
    sha1: "e5747f58e71bc910ece678ca5f58c38b4f89857c",
    md5: "f68c88f21a9ee9a15b3441dd2bbcbc5f",
    blurb: "Mod by Mikul. Installed file: ColdSweat-2.4.1.jar. Game versions: 1.21.1, NeoForge. 26 required dependencies.",
  },
  {
    name: "Collective",
    category: "Library",
    contentType: "Mods",
    projectId: 342584,
    fileId: 8210988,
    fileName: "collective-1.21.1-8.25.jar",
    author: "Serilum",
    url: "https://www.curseforge.com/minecraft/mc-mods/collective",
    downloadUrl: "https://edge.forgecdn.net/files/8210/988/collective-1.21.1-8.25.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/975/602/256/256/638479075930399380.png",
    fileDate: "2026-06-07T14:05:29.073Z",
    fileSizeBytes: 988681,
    gameVersions: ["1.21","Client","Fabric","Forge","1.21.1","NeoForge","Server","Quilt"],
    dependencyCount: 0,
    sha1: "24a7868eb9b461f9fb6d92481ab08ceaf95ef6b4",
    md5: "897eb7ff6f64e1f6f91b26ac812fd228",
    blurb: "Mod by Serilum. Installed file: collective-1.21.1-8.25.jar. Game versions: 1.21, Client, Fabric, Forge, 1.21.1, NeoForge, Server, Quilt.",
  },
  {
    name: "Comforts",
    category: "QoL",
    contentType: "Mods",
    projectId: 276951,
    fileId: 7515858,
    fileName: "comforts-neoforge-9.0.5+1.21.1.jar",
    author: "TheIllusiveC4",
    url: "https://www.curseforge.com/minecraft/mc-mods/comforts",
    downloadUrl: "https://edge.forgecdn.net/files/7515/858/comforts-neoforge-9.0.5%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/203/105/256/256/636930549407382137.png",
    fileDate: "2026-01-24T04:53:25.22Z",
    fileSizeBytes: 422658,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "21d6bee3821d62fe3356c51fb1d697871a3087ff",
    md5: "ba7a318dcf4190a27e017eacac47427e",
    blurb: "Mod by TheIllusiveC4. Installed file: comforts-neoforge-9.0.5+1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge.",
  },
  {
    name: "Common Network",
    category: "Library",
    contentType: "Mods",
    projectId: 806044,
    fileId: 7087488,
    fileName: "common-networking-neoforge-1.0.21-1.21.1.jar",
    author: "Mysticdrew",
    url: "https://www.curseforge.com/minecraft/mc-mods/common-network",
    downloadUrl: "https://edge.forgecdn.net/files/7087/488/common-networking-neoforge-1.0.21-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/751/391/256/256/638089800628605531.png",
    fileDate: "2025-10-09T17:41:44.703Z",
    fileSizeBytes: 26016,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "276fbf912ace90281f5faec987c735019884dbe4",
    md5: "5ee03cea153e841ca0003311f46b3f07",
    blurb: "Mod by Mysticdrew. Installed file: common-networking-neoforge-1.0.21-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Compat API",
    category: "Library",
    contentType: "Mods",
    projectId: 1393220,
    fileId: 7767181,
    fileName: "compatapi-1.0.3.jar",
    author: "FixerLink1",
    url: "https://www.curseforge.com/minecraft/mc-mods/compat-api",
    downloadUrl: "https://edge.forgecdn.net/files/7767/181/compatapi-1.0.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1538/104/256/256/638998657241456239.png",
    fileDate: "2026-03-16T15:18:57.14Z",
    fileSizeBytes: 150007,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "219b6757bb564d1718b9c5a05ae91f6c31cd327a",
    md5: "2504e47ef75047c4f96cec11d6bcd52f",
    blurb: "Mod by FixerLink1. Installed file: compatapi-1.0.3.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Compat Structure",
    category: "World",
    contentType: "Mods",
    projectId: 1248133,
    fileId: 7768220,
    fileName: "compatstructures-1.0.3.jar",
    author: "FixerLink1",
    url: "https://www.curseforge.com/minecraft/mc-mods/compat-structure",
    downloadUrl: "https://edge.forgecdn.net/files/7768/220/compatstructures-1.0.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1232/596/256/256/638808174303801609.png",
    fileDate: "2026-03-16T19:20:00.037Z",
    fileSizeBytes: 3771506,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "cf114a7f0aa08115af0317750f44434808ed5a0e",
    md5: "da2e720d134c397458974c06b31c92af",
    blurb: "Mod by FixerLink1. Installed file: compatstructures-1.0.3.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Connectivity",
    category: "Performance",
    contentType: "Mods",
    projectId: 470193,
    fileId: 7367221,
    fileName: "connectivity-1.21.1-7.6.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/connectivity",
    downloadUrl: "https://edge.forgecdn.net/files/7367/221/connectivity-1.21.1-7.6.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/532/325/256/256/637855720922086407.png",
    fileDate: "2025-12-22T22:30:30.77Z",
    fileSizeBytes: 114165,
    gameVersions: ["1.21","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "6adebe84f745dec8fa33bc3982383bc1cc24d49e",
    md5: "f2d38f850688eefa338b807801df2b4b",
    blurb: "Mod by someaddon. Installed file: connectivity-1.21.1-7.6.jar. Game versions: 1.21, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Controlling",
    category: "QoL",
    contentType: "Mods",
    projectId: 250398,
    fileId: 6368976,
    fileName: "Controlling-neoforge-1.21.1-19.0.5.jar",
    author: "Jaredlll08",
    url: "https://www.curseforge.com/minecraft/mc-mods/controlling",
    downloadUrl: "https://edge.forgecdn.net/files/6368/976/Controlling-neoforge-1.21.1-19.0.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/49/603/256/256/636079972364045115.png",
    fileDate: "2025-03-30T23:44:28.983Z",
    fileSizeBytes: 77555,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "8a34424fc1428778be2fdbfa4da67b21b70bcbfe",
    md5: "7141c2d0bb774dc6e4481be32b685179",
    blurb: "Mod by Jaredlll08. Installed file: Controlling-neoforge-1.21.1-19.0.5.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "CorgiLib",
    category: "Library",
    contentType: "Mods",
    projectId: 693313,
    fileId: 7773534,
    fileName: "Corgilib-NeoForge-1.21.1-5.0.0.9.jar",
    author: "Corgi_Taco",
    url: "https://www.curseforge.com/minecraft/mc-mods/corgilib",
    downloadUrl: "https://edge.forgecdn.net/files/7773/534/Corgilib-NeoForge-1.21.1-5.0.0.9.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1693/756/256/256/639075035147145509.png",
    fileDate: "2026-03-17T21:19:30.813Z",
    fileSizeBytes: 309763,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "6699f876f9e10f936910055f7fe1a283d8bb9e0f",
    md5: "c03b02005b735e2221438a5346d8c77f",
    blurb: "Mod by Corgi_Taco. Installed file: Corgilib-NeoForge-1.21.1-5.0.0.9.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "CoroUtil",
    category: "QoL",
    contentType: "Mods",
    projectId: 237749,
    fileId: 7796187,
    fileName: "coroutil-neoforge-1.21.0-1.3.9.jar",
    author: "Corosus",
    url: "https://www.curseforge.com/minecraft/mc-mods/coroutil",
    downloadUrl: "https://edge.forgecdn.net/files/7796/187/coroutil-neoforge-1.21.0-1.3.9.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/52/497/256/256/636115233396260155.png",
    fileDate: "2026-03-22T18:53:05.607Z",
    fileSizeBytes: 65716,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "0f5a6309ce8394721b97740e6f3e45665f13b8de",
    md5: "741721a51d325dfccf1b74f0a792bd88",
    blurb: "Mod by Corosus. Installed file: coroutil-neoforge-1.21.0-1.3.9.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Create",
    category: "Tech",
    contentType: "Mods",
    projectId: 328085,
    fileId: 7963363,
    fileName: "create-1.21.1-6.0.10.jar",
    author: "simibubi",
    url: "https://www.curseforge.com/minecraft/mc-mods/create",
    downloadUrl: "https://edge.forgecdn.net/files/7963/363/create-1.21.1-6.0.10.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1065/184/256/256/638598725500886388.png",
    fileDate: "2026-04-21T22:20:00.503Z",
    fileSizeBytes: 19123767,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "0e97e49837bed766e6f28a4c95b04885d6acc353",
    md5: "179189c52b45a469e683570be4e77188",
    blurb: "Mod by simibubi. Installed file: create-1.21.1-6.0.10.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Create Aeronautics",
    category: "Tech",
    contentType: "Mods",
    projectId: 676721,
    fileId: 8240058,
    fileName: "create-aeronautics-bundled-1.21.1-1.3.0.jar",
    author: "ryanhcode",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-aeronautics",
    downloadUrl: "https://edge.forgecdn.net/files/8240/58/create-aeronautics-bundled-1.21.1-1.3.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1761/312/256/256/639120354691921005.png",
    fileDate: "2026-06-13T03:13:23.787Z",
    fileSizeBytes: 33120013,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 2,
    sha1: "a2b08963ebc9f331f52c626aebcd65013e100d69",
    md5: "27e0597b184778e49f1b4d5351bedc60",
    blurb: "Mod by ryanhcode. Installed file: create-aeronautics-bundled-1.21.1-1.3.0.jar. Game versions: Client, 1.21.1, NeoForge, Server. 2 required dependencies.",
  },
  {
    name: "Create Big Cannons",
    category: "Tech",
    contentType: "Mods",
    projectId: 646668,
    fileId: 8208458,
    fileName: "createbigcannons-5.11.6+mc.1.21.1.jar",
    author: "rbasamoyai",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-big-cannons",
    downloadUrl: "https://edge.forgecdn.net/files/8208/458/createbigcannons-5.11.6%2bmc.1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1072/200/256/256/638608031487115551.png",
    fileDate: "2026-06-07T01:41:16.317Z",
    fileSizeBytes: 3767934,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "b209fe9879b27e74b742db9127a1b88d49323abe",
    md5: "3256aa09148f26c4505286d152428bec",
    blurb: "Mod by rbasamoyai. Installed file: createbigcannons-5.11.6+mc.1.21.1.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Create Crafts & Additions",
    category: "Tech",
    contentType: "Mods",
    projectId: 439890,
    fileId: 8188476,
    fileName: "createaddition-1.6.0.jar",
    author: "MRHminer",
    url: "https://www.curseforge.com/minecraft/mc-mods/createaddition",
    downloadUrl: "https://edge.forgecdn.net/files/8188/476/createaddition-1.6.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/405/250/256/256/637616939209778882.png",
    fileDate: "2026-06-02T21:49:29.26Z",
    fileSizeBytes: 1661802,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 2,
    sha1: "87b539d41ed238e98b26c607c0c81a973323147e",
    md5: "f401e28d795486a83db6dd714486d3e2",
    blurb: "Mod by MRHminer. Installed file: createaddition-1.6.0.jar. Game versions: Client, 1.21.1, NeoForge, Server. 2 required dependencies.",
  },
  {
    name: "Create Encased",
    category: "Tech",
    contentType: "Mods",
    projectId: 829380,
    fileId: 8132852,
    fileName: "Create Encased-1.21.1-1.8.1-ht1.jar",
    author: "iglee42",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-encased",
    downloadUrl: "https://edge.forgecdn.net/files/8132/852/Create%20Encased-1.21.1-1.8.1-ht1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1071/505/256/256/638607067577017369.png",
    fileDate: "2026-05-23T13:53:20.73Z",
    fileSizeBytes: 2574837,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 4,
    sha1: "5ca3d7674676dda5dd472b0433505a54d5e920d0",
    md5: "62a18441af5100cb05951ec877f1fe81",
    blurb: "Mod by iglee42. Installed file: Create Encased-1.21.1-1.8.1-ht1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 4 required dependencies.",
  },
  {
    name: "Create Goggles (Create Plus)",
    category: "Tech",
    contentType: "Mods",
    projectId: 377835,
    fileId: 6776826,
    fileName: "creategoggles-1.21.1-6.1.1-[NEOFORGE].jar",
    author: "Robocraft999",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-goggles",
    downloadUrl: "https://edge.forgecdn.net/files/6776/826/creategoggles-1.21.1-6.1.1-%5bNEOFORGE%5d.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1068/188/256/256/638602681717064214.png",
    fileDate: "2025-07-16T22:03:40.037Z",
    fileSizeBytes: 180932,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 3,
    sha1: "e0285c31a2d2501439264c33c965409c422cd5b1",
    md5: "9d8f25a3de56e8106502ab0e0ca17925",
    blurb: "Mod by Robocraft999. Installed file: creategoggles-1.21.1-6.1.1-[NEOFORGE].jar. Game versions: NeoForge, 1.21.1. 3 required dependencies.",
  },
  {
    name: "Create Nuclear",
    category: "Tech",
    contentType: "Mods",
    projectId: 989797,
    fileId: 7329038,
    fileName: "createnuclear-1.3.2-beta.3-neoforge.jar",
    author: "CreateNuclearTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/createnuclear",
    downloadUrl: "https://edge.forgecdn.net/files/7329/38/createnuclear-1.3.2-beta.3-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1174/771/256/256/638746897312681600.png",
    fileDate: "2025-12-13T17:49:06.86Z",
    fileSizeBytes: 1842160,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 4,
    sha1: "c4349006fd07e614b0de3c5982d7f0d0a818c98c",
    md5: "baae69947ce29825799e565a00bdc842",
    blurb: "Mod by CreateNuclearTeam. Installed file: createnuclear-1.3.2-beta.3-neoforge.jar. Game versions: Client, 1.21.1, NeoForge, Server. 4 required dependencies.",
  },
  {
    name: "Create Optical",
    category: "Tech",
    contentType: "Mods",
    projectId: 1007714,
    fileId: 8036048,
    fileName: "create_optical-0.4.2.jar",
    author: "lpcamors",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-optical",
    downloadUrl: "https://edge.forgecdn.net/files/8036/48/create_optical-0.4.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1696/851/256/256/639077356357448185.png",
    fileDate: "2026-05-04T03:24:25.47Z",
    fileSizeBytes: 8003762,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "d39b4d193b0c326159e9e3bfa7d5113bc19384a8",
    md5: "f43712a04bcc2e5916b15e3dd714ac87",
    blurb: "Mod by lpcamors. Installed file: create_optical-0.4.2.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create Stuff 'N Additions",
    category: "Tech",
    contentType: "Mods",
    projectId: 466792,
    fileId: 8100852,
    fileName: "create-stuff-additions1.21.1_v2.1.3.jar",
    author: "Furti_Two",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-stuff-additions",
    downloadUrl: "https://edge.forgecdn.net/files/8100/852/create-stuff-additions1.21.1_v2.1.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1158/714/256/256/638727221391013276.png",
    fileDate: "2026-05-16T22:56:49.173Z",
    fileSizeBytes: 1325365,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "d0af683c92f8c1e9f5f3fb0249fa91ec76982b44",
    md5: "7f17155946b7918765af8169ba1661ca",
    blurb: "Mod by Furti_Two. Installed file: create-stuff-additions1.21.1_v2.1.3.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create Train Parts",
    category: "Tech",
    contentType: "Mods",
    projectId: 1294279,
    fileId: 8054109,
    fileName: "create_train_parts-0.4.0-1.21.1-6.0.9-216.jar",
    author: "tiestoettoet08",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-train-parts",
    downloadUrl: "https://edge.forgecdn.net/files/8054/109/create_train_parts-0.4.0-1.21.1-6.0.9-216.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1440/77/256/256/638933719593176449.png",
    fileDate: "2026-05-07T18:10:15.717Z",
    fileSizeBytes: 3505210,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "545cffbaf747fe9da8429df19560a3dde408d572",
    md5: "fb329c658d1079a829ef8d982d2fc93a",
    blurb: "Mod by tiestoettoet08. Installed file: create_train_parts-0.4.0-1.21.1-6.0.9-216.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Create: Aquatic Ambitions",
    category: "Tech",
    contentType: "Mods",
    projectId: 1005676,
    fileId: 7192082,
    fileName: "create_aquatic_ambitions-1.21.1-2.0.2.jar",
    author: "DaviO",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-aquatic-ambitions",
    downloadUrl: "https://edge.forgecdn.net/files/7192/82/create_aquatic_ambitions-1.21.1-2.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1196/46/256/256/638771655701162572.png",
    fileDate: "2025-11-06T13:29:47.78Z",
    fileSizeBytes: 1041906,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "39945d25188f3cb8feb74d09b78d7f7f7a74aaa7",
    md5: "563ce9a5f7a0aeb9a0ff2681239ee478",
    blurb: "Mod by DaviO. Installed file: create_aquatic_ambitions-1.21.1-2.0.2.jar. Game versions: Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Create: Better Create",
    category: "Tech",
    contentType: "Mods",
    projectId: 1217628,
    fileId: 6289346,
    fileName: "better_create-1.0.0-neoforge-1.21.1.jar",
    author: "yuriotavio",
    url: "https://www.curseforge.com/minecraft/mc-mods/betther-create",
    downloadUrl: "https://edge.forgecdn.net/files/6289/346/better_create-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1196/494/256/256/638772280925196557.png",
    fileDate: "2025-03-10T18:29:20.063Z",
    fileSizeBytes: 2253387,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 2,
    sha1: "4a529724c077c1c08527a2cc739f2152e4ff0801",
    md5: "f39d77451164ae1ef9eb2b6ec3a2b528",
    blurb: "Mod by yuriotavio. Installed file: better_create-1.0.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1. 2 required dependencies.",
  },
  {
    name: "Create: Cold Sweat",
    category: "Tech",
    contentType: "Mods",
    projectId: 1184450,
    fileId: 7214552,
    fileName: "create_cold_sweat-1.1.2.jar",
    author: "TheOrionPax",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-cold-sweat",
    downloadUrl: "https://edge.forgecdn.net/files/7214/552/create_cold_sweat-1.1.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1164/761/256/256/638734585834044832.png",
    fileDate: "2025-11-12T15:24:29.45Z",
    fileSizeBytes: 214958,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "58326378dac966d664ae827dcc76e4b3a284d747",
    md5: "d6d9b75fb61715bbb5e6347dd4ee53bc",
    blurb: "Mod by TheOrionPax. Installed file: create_cold_sweat-1.1.2.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Create: Connected",
    category: "Tech",
    contentType: "Mods",
    projectId: 947914,
    fileId: 8221350,
    fileName: "create_connected-1.2.2-mc1.21.1.jar",
    author: "Lysine",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-connected",
    downloadUrl: "https://edge.forgecdn.net/files/8221/350/create_connected-1.2.2-mc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/922/162/256/256/638387242479713653.png",
    fileDate: "2026-06-09T12:32:20.833Z",
    fileSizeBytes: 6643731,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "d9b3d62c537beb18f4e9edf129d9b95709197777",
    md5: "f435da5ffd49cac36901e5921f09f697",
    blurb: "Mod by Lysine. Installed file: create_connected-1.2.2-mc1.21.1.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Create: Create O' Plenty (Create + Biomes O' Plenty Mod compat)",
    category: "Tech",
    contentType: "Mods",
    projectId: 1351997,
    fileId: 7476105,
    fileName: "CreateOPlenty-NeoForge-Create+6.0.7-3.0.jar",
    author: "Eggmain",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-o-plenty",
    downloadUrl: "https://edge.forgecdn.net/files/7476/105/CreateOPlenty-NeoForge-Create%2b6.0.7-3.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1451/649/256/256/638941776563772660.png",
    fileDate: "2026-01-17T16:25:50.883Z",
    fileSizeBytes: 45837,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 2,
    sha1: "9c636f52e9354fdccc0b53201c22dfb5887f0589",
    md5: "f6cdcd99da07652b27bfc858a2393b88",
    blurb: "Mod by Eggmain. Installed file: CreateOPlenty-NeoForge-Create+6.0.7-3.0.jar. Game versions: Client, 1.21.1, NeoForge, Server. 2 required dependencies.",
  },
  {
    name: "Create: Creator Sword",
    category: "Tech",
    contentType: "Mods",
    projectId: 1269043,
    fileId: 8234485,
    fileName: "creatorsword-0.2.8b.jar",
    author: "EricXCY",
    url: "https://www.curseforge.com/minecraft/mc-mods/creator-sword",
    downloadUrl: "https://edge.forgecdn.net/files/8234/485/creatorsword-0.2.8b.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1280/108/256/256/638832491477041107.png",
    fileDate: "2026-06-12T00:51:50.823Z",
    fileSizeBytes: 415210,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "eef6792174aa8d52f786d18e9a0cb14737d43c40",
    md5: "bf78d7a0cdd002812a8fff3cd0558ee7",
    blurb: "Mod by EricXCY. Installed file: creatorsword-0.2.8b.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Create: Deep Dark",
    category: "Tech",
    contentType: "Mods",
    projectId: 1020173,
    fileId: 7624342,
    fileName: "create_deep_dark-3.0.2-neoforge-1.21.1.jar",
    author: "robinfrt",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-deep-dark",
    downloadUrl: "https://edge.forgecdn.net/files/7624/342/create_deep_dark-3.0.2-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1100/253/256/256/638647467653539244.png",
    fileDate: "2026-02-14T16:20:22.377Z",
    fileSizeBytes: 254417,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "41a8c7f2f096555355214c55031ade1a84ef4058",
    md5: "c3e7c668402ef85825c13203ba3ad8cb",
    blurb: "Mod by robinfrt. Installed file: create_deep_dark-3.0.2-neoforge-1.21.1.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Diesel Generators",
    category: "Tech",
    contentType: "Mods",
    projectId: 869316,
    fileId: 8195615,
    fileName: "createdieselgenerators-1.21.1-1.3.13.jar",
    author: "George_VI",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-diesel-generators",
    downloadUrl: "https://edge.forgecdn.net/files/8195/615/createdieselgenerators-1.21.1-1.3.13.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1065/563/256/256/638599261172976487.png",
    fileDate: "2026-06-04T12:20:39.813Z",
    fileSizeBytes: 3142529,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "76b2ce52ab285f3fc44916c0a49e29687b3f8e0e",
    md5: "86c7f82e9093ba012413d84f8fa14fbe",
    blurb: "Mod by George_VI. Installed file: createdieselgenerators-1.21.1-1.3.13.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Create: Dragons Plus",
    category: "Tech",
    contentType: "Mods",
    projectId: 1216624,
    fileId: 8219463,
    fileName: "CreateDragonsPlus-1.11.2b.jar",
    author: "DragonsPlus",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-dragons-plus",
    downloadUrl: "https://edge.forgecdn.net/files/8219/463/CreateDragonsPlus-1.11.2b.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1195/420/256/256/638771027943462603.png",
    fileDate: "2026-06-09T01:53:52.117Z",
    fileSizeBytes: 1006723,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "c0427a7f657f583694e485186621bdeda16ca8dd",
    md5: "95d1e63668c74dc9831c3fb880c43581",
    blurb: "Mod by DragonsPlus. Installed file: CreateDragonsPlus-1.11.2b.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Easy Structures",
    category: "Tech",
    contentType: "Mods",
    projectId: 949158,
    fileId: 6344382,
    fileName: "create_easy_structures-0.2a-neoforge-1.21.1.jar",
    author: "M_Productions",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-easy-structures",
    downloadUrl: "https://edge.forgecdn.net/files/6344/382/create_easy_structures-0.2a-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1191/411/256/256/638766223397631835.png",
    fileDate: "2025-03-25T13:56:46.593Z",
    fileSizeBytes: 469490,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "5878bdf8facd954cce7da3a55ab1d5274fe4ef6d",
    md5: "183f48dd9ec8a62cf2d2654172cceb05",
    blurb: "Mod by M_Productions. Installed file: create_easy_structures-0.2a-neoforge-1.21.1.jar. Game versions: Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Create: Enchantment Industry",
    category: "Magic",
    contentType: "Mods",
    projectId: 688768,
    fileId: 8241347,
    fileName: "create-enchantment-industry-2.4.2.jar",
    author: "DragonsPlus",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-enchantment-industry",
    downloadUrl: "https://edge.forgecdn.net/files/8241/347/create-enchantment-industry-2.4.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1224/199/256/256/638802282774958966.png",
    fileDate: "2026-06-13T10:31:57.45Z",
    fileSizeBytes: 1283517,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 2,
    sha1: "4ad5c181c805a548e15892500b07c0c0f88f0734",
    md5: "4bf7e32d49403b73f0782f6f2d80f000",
    blurb: "Mod by DragonsPlus. Installed file: create-enchantment-industry-2.4.2.jar. Game versions: Client, 1.21.1, NeoForge, Server. 2 required dependencies.",
  },
  {
    name: "Create: Hypertubes",
    category: "Tech",
    contentType: "Mods",
    projectId: 1281336,
    fileId: 8207248,
    fileName: "create_hypertube-0.4.0-SABLE-COMPAT-NEOFORGE.jar",
    author: "Rokzin",
    url: "https://www.curseforge.com/minecraft/mc-mods/hypertubes",
    downloadUrl: "https://edge.forgecdn.net/files/8207/248/create_hypertube-0.4.0-SABLE-COMPAT-NEOFORGE.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1304/374/256/256/638848167351949326.png",
    fileDate: "2026-06-06T20:03:30.1Z",
    fileSizeBytes: 438363,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "bd06f6dd344b93a77c1ea0720b6961ffc1dfb9b8",
    md5: "bb97b1586c0ccfec52bfd1faec90c9f7",
    blurb: "Mod by Rokzin. Installed file: create_hypertube-0.4.0-SABLE-COMPAT-NEOFORGE.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Let The Adventure Begin",
    category: "Tech",
    contentType: "Mods",
    projectId: 1007872,
    fileId: 8176177,
    fileName: "create_ltab-4.0.2.jar",
    author: "Not_Juno",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-let-the-adventure-begin",
    downloadUrl: "https://edge.forgecdn.net/files/8176/177/create_ltab-4.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1158/135/256/256/638726420331721627_animated.gif",
    fileDate: "2026-05-31T17:56:16.44Z",
    fileSizeBytes: 2857303,
    gameVersions: ["Client","Fabric","1.20.1","Forge","1.21.1","NeoForge","Server","Quilt"],
    dependencyCount: 1,
    sha1: "6ce52066d7cb76e2965ac557615a9a03a1a7d47b",
    md5: "f8f1760e88197c239e67846ed9d1ee78",
    blurb: "Mod by Not_Juno. Installed file: create_ltab-4.0.2.jar. Game versions: Client, Fabric, 1.20.1, Forge, 1.21.1, NeoForge, Server, Quilt. 1 required dependency.",
  },
  {
    name: "Create: Mob Spawners",
    category: "Tech",
    contentType: "Mods",
    projectId: 1175578,
    fileId: 7342352,
    fileName: "create_mob_spawners-1.0.0.jar",
    author: "3xpl01t",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-mob-spawners",
    downloadUrl: "https://edge.forgecdn.net/files/7342/352/create_mob_spawners-1.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1161/980/256/256/638730865016705374.png",
    fileDate: "2025-12-17T00:34:45.983Z",
    fileSizeBytes: 252732,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 3,
    sha1: "43f6627a7670c0053f76127eac51d0ff2985ce9e",
    md5: "aca9bf51c732cdcc37de0241a54e3a83",
    blurb: "Mod by 3xpl01t. Installed file: create_mob_spawners-1.0.0.jar. Game versions: 1.21.1, NeoForge. 3 required dependencies.",
  },
  {
    name: "Create: No Touching - Aeronautics",
    category: "Tech",
    contentType: "Mods",
    projectId: 1179503,
    fileId: 8221371,
    fileName: "create_no_touching-1.0.8Neo-Aeronautics.jar",
    author: "Huwng",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-no-touching",
    downloadUrl: "https://edge.forgecdn.net/files/8221/371/create_no_touching-1.0.8Neo-Aeronautics.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1421/948/256/256/638921275418721339.png",
    fileDate: "2026-06-09T12:38:08.48Z",
    fileSizeBytes: 277692,
    gameVersions: ["1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "967d82b0ca44c30b5a8b25b8b6f967e868776dde",
    md5: "23138424e95448dbe573ff3995762d17",
    blurb: "Mod by Huwng. Installed file: create_no_touching-1.0.8Neo-Aeronautics.jar. Game versions: 1.21.1, NeoForge, Server.",
  },
  {
    name: "Create: Pillager Arise",
    category: "Tech",
    contentType: "Mods",
    projectId: 1094958,
    fileId: 7593447,
    fileName: "create_pillagers_arise-132.32 Release-neoforge-1.21.1.jar",
    author: "SmartStreamLabs",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-pillager-arise",
    downloadUrl: "https://edge.forgecdn.net/files/7593/447/create_pillagers_arise-132.32%20Release-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1506/780/256/256/638978635155283036.png",
    fileDate: "2026-02-08T10:12:58.72Z",
    fileSizeBytes: 1806941,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 6,
    sha1: "efe39f96957c3b5eebb3dc8a85f64c0f882afb60",
    md5: "65760321e124123d7837d5f961bc882d",
    blurb: "Mod by SmartStreamLabs. Installed file: create_pillagers_arise-132.32 Release-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 6 required dependencies.",
  },
  {
    name: "Create: Power Loader",
    category: "Tech",
    contentType: "Mods",
    projectId: 936020,
    fileId: 8126570,
    fileName: "create_power_loader-2.0.5-mc1.21.1.jar",
    author: "Lysine",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-power-loader",
    downloadUrl: "https://edge.forgecdn.net/files/8126/570/create_power_loader-2.0.5-mc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/903/443/256/256/638352779105838214.png",
    fileDate: "2026-05-22T08:06:33.957Z",
    fileSizeBytes: 442369,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "5bd3ecef6fc66985e6fdf416706c98fb774ba03d",
    md5: "db072c13031f5144d140335206fdad89",
    blurb: "Mod by Lysine. Installed file: create_power_loader-2.0.5-mc1.21.1.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Create: Rustic Structures",
    category: "Tech",
    contentType: "Mods",
    projectId: 1232975,
    fileId: 8122033,
    fileName: "create_rustic_structures-1.0.1-neoforge-1.21.1.jar",
    author: "robinfrt",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-rustic-structures",
    downloadUrl: "https://edge.forgecdn.net/files/8122/33/create_rustic_structures-1.0.1-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1212/509/256/256/638790501713629564.png",
    fileDate: "2026-05-21T07:15:52.993Z",
    fileSizeBytes: 758491,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "f8f8dea6a23f697c3f27196627bdf77d9147b8e4",
    md5: "dcd2c9236f8f21e3a723e4febd063c6f",
    blurb: "Mod by robinfrt. Installed file: create_rustic_structures-1.0.1-neoforge-1.21.1.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Sophisticated Backpacks Compat",
    category: "Tech",
    contentType: "Mods",
    projectId: 1320115,
    fileId: 6844021,
    fileName: "create_sophback_compat-1.0.jar",
    author: "Blizzor",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-sophisticated-backpacks-compat",
    downloadUrl: "https://edge.forgecdn.net/files/6844/21/create_sophback_compat-1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1385/457/256/256/638898431217060186.png",
    fileDate: "2025-08-03T18:42:23.01Z",
    fileSizeBytes: 679850,
    gameVersions: ["Client","NeoForge","1.20.1","Forge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "401e8b83ab79c13bf71ba6209f4c8c487c001b38",
    md5: "bbea1fe1a3532a6f6243af8f4d349c4e",
    blurb: "Mod by Blizzor. Installed file: create_sophback_compat-1.0.jar. Game versions: Client, NeoForge, 1.20.1, Forge, 1.21.1, Server.",
  },
  {
    name: "Create: Structures Arise",
    category: "Tech",
    contentType: "Mods",
    projectId: 1010066,
    fileId: 8138502,
    fileName: "create_structures_arise-176.49.48 NeoForge 1.21.1.jar",
    author: "SmartStreamLabs",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-structures-arise",
    downloadUrl: "https://edge.forgecdn.net/files/8138/502/create_structures_arise-176.49.48%20NeoForge%201.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1067/516/256/256/638601854484952136.png",
    fileDate: "2026-05-24T15:26:48.46Z",
    fileSizeBytes: 1817379,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 4,
    sha1: "48f22eb339299d832f66d39fecee2ca26880b574",
    md5: "a85ea6fc50da12f0e6aad16bde7158e2",
    blurb: "Mod by SmartStreamLabs. Installed file: create_structures_arise-176.49.48 NeoForge 1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 4 required dependencies.",
  },
  {
    name: "Create: Transmission!",
    category: "Tech",
    contentType: "Mods",
    projectId: 1354280,
    fileId: 8186085,
    fileName: "createtransmission-1.2.1+neoforge-create6-1.21.1.jar",
    author: "SerpensSolida",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-transmission",
    downloadUrl: "https://edge.forgecdn.net/files/8186/85/createtransmission-1.2.1%2bneoforge-create6-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1456/551/256/256/638945490120463350.png",
    fileDate: "2026-06-02T10:11:04.937Z",
    fileSizeBytes: 249368,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "86587d4f086206a94dbacfaa0d7e146f1d781aca",
    md5: "d1aabd125d7f5a60550d3b308d0f25a6",
    blurb: "Mod by SerpensSolida. Installed file: createtransmission-1.2.1+neoforge-create6-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Ultimate Factory",
    category: "Tech",
    contentType: "Mods",
    projectId: 978125,
    fileId: 8038954,
    fileName: "create_ultimate_factory-2.2.4-neoforge-1.21.1.jar",
    author: "robinfrt",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-ultimate-factory",
    downloadUrl: "https://edge.forgecdn.net/files/8038/954/create_ultimate_factory-2.2.4-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1101/579/256/256/638649476880609820.png",
    fileDate: "2026-05-04T16:47:49Z",
    fileSizeBytes: 235239,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "ed0ff71df9bfe3b66b97c51a2834031084300a65",
    md5: "1c7d2f2c8ff0c2c99f9bcfaf8aa0c97c",
    blurb: "Mod by robinfrt. Installed file: create_ultimate_factory-2.2.4-neoforge-1.21.1.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Create: Vibrant Vaults",
    category: "Tech",
    contentType: "Mods",
    projectId: 1251719,
    fileId: 6463890,
    fileName: "create_vibrant_vaults-0.3.2.jar",
    author: "ZLT",
    url: "https://www.curseforge.com/minecraft/mc-mods/create-vibrant-vaults",
    downloadUrl: "https://edge.forgecdn.net/files/6463/890/create_vibrant_vaults-0.3.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1241/110/256/256/638811984875891856.png",
    fileDate: "2025-04-25T17:44:10.77Z",
    fileSizeBytes: 2687938,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "d0dbdde6318c4dd4ede1d2c091f1a64896ba872a",
    md5: "8fe767bf30e682d1156a379d6bdaeea2",
    blurb: "Mod by ZLT. Installed file: create_vibrant_vaults-0.3.2.jar. Game versions: Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "CreativeCore",
    category: "Library",
    contentType: "Mods",
    projectId: 257814,
    fileId: 8190065,
    fileName: "CreativeCore_NEOFORGE_v2.13.41_mc1.21.1.jar",
    author: "CreativeMD",
    url: "https://www.curseforge.com/minecraft/mc-mods/creativecore",
    downloadUrl: "https://edge.forgecdn.net/files/8190/65/CreativeCore_NEOFORGE_v2.13.41_mc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/86/225/256/256/636207446427836220.png",
    fileDate: "2026-06-03T07:13:19.997Z",
    fileSizeBytes: 1218640,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "4b666b4668b77fdc1ac34a183aae58a432999970",
    md5: "610093f21cea33b34f911bca97aa294f",
    blurb: "Mod by CreativeMD. Installed file: CreativeCore_NEOFORGE_v2.13.41_mc1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Cristel Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 856996,
    fileId: 8241767,
    fileName: "cristellib-neoforge-1.21.1-3.1.7.jar",
    author: "Cristelknight",
    url: "https://www.curseforge.com/minecraft/mc-mods/cristel-lib",
    downloadUrl: "https://edge.forgecdn.net/files/8241/767/cristellib-neoforge-1.21.1-3.1.7.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/812/326/256/256/638185606434483161.jpeg",
    fileDate: "2026-06-13T12:27:40.903Z",
    fileSizeBytes: 583525,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "d250804b7ecea365bc736ec36ec6fc3f933917f1",
    md5: "6433ae895a143e145165e97beea07077",
    blurb: "Mod by Cristelknight. Installed file: cristellib-neoforge-1.21.1-3.1.7.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Critter Armory",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1198794,
    fileId: 8173368,
    fileName: "critterarmory-1.21.1-0.6.5-neoforge.jar",
    author: "jahirtrap",
    url: "https://www.curseforge.com/minecraft/mc-mods/critter-armory",
    downloadUrl: "https://edge.forgecdn.net/files/8173/368/critterarmory-1.21.1-0.6.5-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1177/1/256/256/638749425155987958.png",
    fileDate: "2026-05-31T06:53:57.693Z",
    fileSizeBytes: 230231,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "849387b1c4c1b676a69d2094b9b9e74e907852ce",
    md5: "77e86a32b16eec02fd0a827e1d8bf79d",
    blurb: "Mod by jahirtrap. Installed file: critterarmory-1.21.1-0.6.5-neoforge.jar. Game versions: 1.21, 1.21.1, NeoForge.",
  },
  {
    name: "Critters and Companions",
    category: "Adventure",
    contentType: "Mods",
    projectId: 574913,
    fileId: 7147511,
    fileName: "crittersandcompanions-neoforge-1.21.1-2.3.4.jar",
    author: "joosh_7889",
    url: "https://www.curseforge.com/minecraft/mc-mods/critters-and-companions",
    downloadUrl: "https://edge.forgecdn.net/files/7147/511/crittersandcompanions-neoforge-1.21.1-2.3.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/728/545/256/256/638081057334527379.png",
    fileDate: "2025-10-25T09:48:52.237Z",
    fileSizeBytes: 1398478,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "c32ae5df533d081f845a153ab67c8d1c61cf339f",
    md5: "d43ddb1b038a75d940f1a35156eb02f1",
    blurb: "Mod by joosh_7889. Installed file: crittersandcompanions-neoforge-1.21.1-2.3.4.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Cupboard",
    category: "Library",
    contentType: "Mods",
    projectId: 326652,
    fileId: 8217735,
    fileName: "cupboard-1.21-3.7.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/cupboard",
    downloadUrl: "https://edge.forgecdn.net/files/8217/735/cupboard-1.21-3.7.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/852/567/256/256/638255508280634753.png",
    fileDate: "2026-06-08T18:38:19.893Z",
    fileSizeBytes: 28655,
    gameVersions: ["1.21","Client","1.21.5","1.21.4","1.21.1","1.21.3","NeoForge","Server","1.21.2"],
    dependencyCount: 0,
    sha1: "428c992f2c01bb84f3da14db244728695117b0a0",
    md5: "c00a8169a3bc20fdad2ca0b59e0e240e",
    blurb: "Mod by someaddon. Installed file: cupboard-1.21-3.7.jar. Game versions: 1.21, Client, 1.21.5, 1.21.4, 1.21.1, 1.21.3, NeoForge, Server, 1.21.2.",
  },
  {
    name: "Curios API (Forge/NeoForge)",
    category: "Library",
    contentType: "Mods",
    projectId: 309927,
    fileId: 6529130,
    fileName: "curios-neoforge-9.5.1+1.21.1.jar",
    author: "TheIllusiveC4",
    url: "https://www.curseforge.com/minecraft/mc-mods/curios",
    downloadUrl: "https://edge.forgecdn.net/files/6529/130/curios-neoforge-9.5.1%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/195/772/256/256/636881112930494939.png",
    fileDate: "2025-05-14T13:34:49.793Z",
    fileSizeBytes: 410690,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "418fcd42e3a7844c9bdc71c9b6401fdb3894e0c4",
    md5: "e8f0a3574264bb202c153b90293dc84c",
    blurb: "Mod by TheIllusiveC4. Installed file: curios-neoforge-9.5.1+1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Cut Through",
    category: "QoL",
    contentType: "Mods",
    projectId: 969423,
    fileId: 5731913,
    fileName: "CutThrough-v21.1.0-1.21.1-NeoForge.jar",
    author: "Fuzs",
    url: "https://www.curseforge.com/minecraft/mc-mods/cut-through",
    downloadUrl: "https://edge.forgecdn.net/files/5731/913/CutThrough-v21.1.0-1.21.1-NeoForge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1856/702/256/256/639166727136035558.png",
    fileDate: "2024-09-17T16:36:50.717Z",
    fileSizeBytes: 51371,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 2,
    sha1: "550f272c140566f0961c1bb3fdfb1a6272be30dd",
    md5: "c859ab15948f1f7fc6c22a6cedcd31c5",
    blurb: "Mod by Fuzs. Installed file: CutThrough-v21.1.0-1.21.1-NeoForge.jar. Game versions: NeoForge, 1.21.1. 2 required dependencies.",
  },
  {
    name: "Data Anchor",
    category: "QoL",
    contentType: "Mods",
    projectId: 1203668,
    fileId: 7942434,
    fileName: "Data_Anchor-neoforge-1.21.1-2.0.0.14.jar",
    author: "Corgi_Taco",
    url: "https://www.curseforge.com/minecraft/mc-mods/data-anchor",
    downloadUrl: "https://edge.forgecdn.net/files/7942/434/Data_Anchor-neoforge-1.21.1-2.0.0.14.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1182/5/256/256/638755421016469847.png",
    fileDate: "2026-04-17T23:44:54.927Z",
    fileSizeBytes: 119163,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "2d2d109fa328bec52527d3469f8036af72066fd4",
    md5: "1bbcc2cd9470ee2be3e6c9102b5a574c",
    blurb: "Mod by Corgi_Taco. Installed file: Data_Anchor-neoforge-1.21.1-2.0.0.14.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Desert Pillager Wall",
    category: "QoL",
    contentType: "Mods",
    projectId: 1354248,
    fileId: 7037285,
    fileName: "desert_pillager_wall-1.0.0-neoforge-1.21.1.jar",
    author: "SuperWarioModTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/desert-pillager-wall",
    downloadUrl: "https://edge.forgecdn.net/files/7037/285/desert_pillager_wall-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1456/414/256/256/638945374494949431.png",
    fileDate: "2025-09-27T02:38:54.337Z",
    fileSizeBytes: 19800,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "0c22e931496fb2e581625543812e3c250e25bfb4",
    md5: "23e368124249817755a226f0c09fb40f",
    blurb: "Mod by SuperWarioModTeam. Installed file: desert_pillager_wall-1.0.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Destructive Moon",
    category: "QoL",
    contentType: "Mods",
    projectId: 1400952,
    fileId: 7939675,
    fileName: "destructive_moon-1.1.6-1.21.1.jar",
    author: "Smallfireworks",
    url: "https://www.curseforge.com/minecraft/mc-mods/destructive-moon",
    downloadUrl: "https://edge.forgecdn.net/files/7939/675/destructive_moon-1.1.6-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1554/336/256/256/639008658790762707.png",
    fileDate: "2026-04-17T12:12:32.513Z",
    fileSizeBytes: 9352807,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 3,
    sha1: "344659a9294eb1bc9eb8e8cb361292a5ba137ea8",
    md5: "c622b45c55e520905d7aede9a584f731",
    blurb: "Mod by Smallfireworks. Installed file: destructive_moon-1.1.6-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 3 required dependencies.",
  },
  {
    name: "Double Doors",
    category: "QoL",
    contentType: "Mods",
    projectId: 348831,
    fileId: 7143842,
    fileName: "doubledoors-1.21.1-7.2.jar",
    author: "Serilum",
    url: "https://www.curseforge.com/minecraft/mc-mods/double-doors",
    downloadUrl: "https://edge.forgecdn.net/files/7143/842/doubledoors-1.21.1-7.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/233/519/256/256/637072440646369425.png",
    fileDate: "2025-10-24T10:34:04.757Z",
    fileSizeBytes: 75041,
    gameVersions: ["1.21","Fabric","NeoForge","Forge","1.21.1","Quilt"],
    dependencyCount: 1,
    sha1: "73ddb685749a0ae9223e9b827af5fd3e19ac732c",
    md5: "bc5d5a4d5edfed10d09f149e173ec600",
    blurb: "Mod by Serilum. Installed file: doubledoors-1.21.1-7.2.jar. Game versions: 1.21, Fabric, NeoForge, Forge, 1.21.1, Quilt. 1 required dependency.",
  },
  {
    name: "Dungeon Crawl",
    category: "World",
    contentType: "Mods",
    projectId: 324973,
    fileId: 7887320,
    fileName: "DungeonCrawl-NeoForge-1.21-2.3.17.jar",
    author: "xiroc_",
    url: "https://www.curseforge.com/minecraft/mc-mods/dungeon-crawl",
    downloadUrl: "https://edge.forgecdn.net/files/7887/320/DungeonCrawl-NeoForge-1.21-2.3.17.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/410/569/256/256/637627452553277521.png",
    fileDate: "2026-04-06T22:39:23.707Z",
    fileSizeBytes: 738480,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "3abb84c4fcf1229fced0cc5e88fa6e9baa0aa4a7",
    md5: "f83e5bd800367a0b2843a3ad4c574945",
    blurb: "Mod by xiroc_. Installed file: DungeonCrawl-NeoForge-1.21-2.3.17.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Dungeons and Taverns",
    category: "World",
    contentType: "Mods",
    projectId: 853794,
    fileId: 5768823,
    fileName: "dungeons-and-taverns-v4.4.4 [NeoForge].jar",
    author: "Nova_Wostra",
    url: "https://www.curseforge.com/minecraft/mc-mods/dungeon-and-taverns",
    downloadUrl: "https://edge.forgecdn.net/files/5768/823/dungeons-and-taverns-v4.4.4%20%5bNeoForge%5d.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1030/440/256/256/638552847053422154.png",
    fileDate: "2024-09-29T20:19:43.373Z",
    fileSizeBytes: 24859622,
    gameVersions: ["1.21","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "249a5bdd0e8622b8a11f88758e6f5fd5fda036a3",
    md5: "8360a41ea1d5ee450c9018a693f0e6f3",
    blurb: "Mod by Nova_Wostra. Installed file: dungeons-and-taverns-v4.4.4 [NeoForge].jar. Game versions: 1.21, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Dynamic Trees",
    category: "World",
    contentType: "Mods",
    projectId: 252818,
    fileId: 8227322,
    fileName: "dynamictrees-neoforge-1.21.1-1.7.2.jar",
    author: "MaxHyper",
    url: "https://www.curseforge.com/minecraft/mc-mods/dynamictrees",
    downloadUrl: "https://edge.forgecdn.net/files/8227/322/dynamictrees-neoforge-1.21.1-1.7.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/111/638/256/256/636389419656399314.png",
    fileDate: "2026-06-10T16:29:20.79Z",
    fileSizeBytes: 3399913,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "c16fae939c0f305af46ad585150a33565a06129e",
    md5: "e17f18713dab161a0ff00522e5939353",
    blurb: "Mod by MaxHyper. Installed file: dynamictrees-neoforge-1.21.1-1.7.2.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Easier Sleeping",
    category: "QoL",
    contentType: "Mods",
    projectId: 388364,
    fileId: 8028886,
    fileName: "EasierSleeping-1.21.1-4.0.1.jar",
    author: "GeheimagentNr1",
    url: "https://www.curseforge.com/minecraft/mc-mods/easier-sleeping",
    downloadUrl: "https://edge.forgecdn.net/files/8028/886/EasierSleeping-1.21.1-4.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/340/950/256/256/637483323502178820.png",
    fileDate: "2026-05-02T20:30:11.13Z",
    fileSizeBytes: 59589,
    gameVersions: ["Client","1.21.8","1.21.5","1.21.4","1.21.1","1.21.6","1.21.3","1.21.7","NeoForge","Server","1.21.2","1.21.9","1.21.10"],
    dependencyCount: 0,
    sha1: "b0c76a9cf98c810d4c3498acfacb4d29a0ca2d80",
    md5: "bc7ce6f24bb4451d937eb0a067442f22",
    blurb: "Mod by GeheimagentNr1. Installed file: EasierSleeping-1.21.1-4.0.1.jar. Game versions: Client, 1.21.8, 1.21.5, 1.21.4, 1.21.1, 1.21.6, 1.21.3, 1.21.7, NeoForge, Server, 1.21.2, 1.21.9, 1.21.10.",
  },
  {
    name: "Easy NPC",
    category: "QoL",
    contentType: "Mods",
    projectId: 559312,
    fileId: 8250316,
    fileName: "easy_npc_bundle-neoforge-1.21.1-6.20.0.jar",
    author: "Kaworru",
    url: "https://www.curseforge.com/minecraft/mc-mods/easy-npc",
    downloadUrl: "https://edge.forgecdn.net/files/8250/316/easy_npc_bundle-neoforge-1.21.1-6.20.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1720/924/256/256/639094548004185039.png",
    fileDate: "2026-06-15T00:46:22.893Z",
    fileSizeBytes: 25214,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "b07170641f6eb5e29f405bad6c085019150f810f",
    md5: "215879fa6728a5a62830c4ca1f8b047a",
    blurb: "Mod by Kaworru. Installed file: easy_npc_bundle-neoforge-1.21.1-6.20.0.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Easy NPC: Config UI",
    category: "QoL",
    contentType: "Mods",
    projectId: 1214728,
    fileId: 8250313,
    fileName: "easy_npc_config_ui-neoforge-1.21.1-6.20.0.jar",
    author: "Kaworru",
    url: "https://www.curseforge.com/minecraft/mc-mods/easy-npc-config-ui",
    downloadUrl: "https://edge.forgecdn.net/files/8250/313/easy_npc_config_ui-neoforge-1.21.1-6.20.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1720/923/256/256/639094547819825352.png",
    fileDate: "2026-06-15T00:46:00.223Z",
    fileSizeBytes: 915965,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "bb5199efe130e94388777c37329a405d01269d45",
    md5: "c6a15d470a2a697629c55e68f54517c6",
    blurb: "Mod by Kaworru. Installed file: easy_npc_config_ui-neoforge-1.21.1-6.20.0.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Easy NPC: Core",
    category: "Library",
    contentType: "Mods",
    projectId: 1308987,
    fileId: 8250309,
    fileName: "easy_npc-neoforge-1.21.1-6.20.0.jar",
    author: "Kaworru",
    url: "https://www.curseforge.com/minecraft/mc-mods/easy-npc-core",
    downloadUrl: "https://edge.forgecdn.net/files/8250/309/easy_npc-neoforge-1.21.1-6.20.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1720/921/256/256/639094547572505488.png",
    fileDate: "2026-06-15T00:45:35.823Z",
    fileSizeBytes: 2118218,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "9cf48aaf4c6876001c283ffb054ac5394c56e1d2",
    md5: "3c23adde61813831ab6ebce4b2b90ee6",
    blurb: "Mod by Kaworru. Installed file: easy_npc-neoforge-1.21.1-6.20.0.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Eating Animation [Neo/Forge]",
    category: "QoL",
    contentType: "Mods",
    projectId: 570544,
    fileId: 5567664,
    fileName: "eatinganimation-1.21.0-6.0.1.jar",
    author: "matyrobbrt",
    url: "https://www.curseforge.com/minecraft/mc-mods/eating-animation-forge",
    downloadUrl: "https://edge.forgecdn.net/files/5567/664/eatinganimation-1.21.0-6.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/483/224/256/256/637782958702187625_animated.gif",
    fileDate: "2024-07-26T11:34:32.83Z",
    fileSizeBytes: 289863,
    gameVersions: ["1.21","Client","NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "68f276dc8cf57658b0afc2112c6ee63325989e02",
    md5: "9f413a8ab62a6d0a0641ac3335c3f41b",
    blurb: "Mod by matyrobbrt. Installed file: eatinganimation-1.21.0-6.0.1.jar. Game versions: 1.21, Client, NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Ecologics",
    category: "World",
    contentType: "Mods",
    projectId: 570463,
    fileId: 8104866,
    fileName: "ecologics-1.21.1-2.3.6.jar",
    author: "SameDifferent",
    url: "https://www.curseforge.com/minecraft/mc-mods/ecologics",
    downloadUrl: "https://edge.forgecdn.net/files/8104/866/ecologics-1.21.1-2.3.6.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/483/128/256/256/637782721029825410.png",
    fileDate: "2026-05-17T17:29:13.02Z",
    fileSizeBytes: 1886895,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "4b0588f0abb229b74dc9fef145487c6912a389e4",
    md5: "e056b23e99da4ec2367997489f694c2a",
    blurb: "Mod by SameDifferent. Installed file: ecologics-1.21.1-2.3.6.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Element Attribute Addon[NeoForge]",
    category: "QoL",
    contentType: "Mods",
    projectId: 1478333,
    fileId: 7775848,
    fileName: "elementattribute-addon-1.0.2.jar",
    author: "Itori",
    url: "https://www.curseforge.com/minecraft/mc-mods/element-attribute-addon-neoforge",
    downloadUrl: "https://edge.forgecdn.net/files/7775/848/elementattribute-addon-1.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1704/998/256/256/639083202655968941.png",
    fileDate: "2026-03-18T12:52:35.377Z",
    fileSizeBytes: 408186,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "57d916f7fa0a135d1c2c23df6b7701d286878f99",
    md5: "06a905a442da0551d97cc7f05bc7a2c8",
    blurb: "Mod by Itori. Installed file: elementattribute-addon-1.0.2.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Enhanced Boss Bars",
    category: "Magic",
    contentType: "Mods",
    projectId: 1063296,
    fileId: 7547171,
    fileName: "enhancedbossbars-1.0.0.jar",
    author: "Nakuring",
    url: "https://www.curseforge.com/minecraft/mc-mods/enhanced-boss-bars",
    downloadUrl: "https://edge.forgecdn.net/files/7547/171/enhancedbossbars-1.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1039/449/256/256/638564982213431593.png",
    fileDate: "2026-01-29T19:16:33.107Z",
    fileSizeBytes: 252820,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "812fa35e45f015661e8348c96d2ccc360723583b",
    md5: "a27338ca15c72b1726834c98d2c75795",
    blurb: "Mod by Nakuring. Installed file: enhancedbossbars-1.0.0.jar. Game versions: Client, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Enhanced Celestials - Blood, Blue, & Harvest (Super) Moons",
    category: "QoL",
    contentType: "Mods",
    projectId: 438447,
    fileId: 7093308,
    fileName: "Enhanced-Celestials-NeoForge-1.21.1-6.0.2.5.jar",
    author: "Corgi_Taco",
    url: "https://www.curseforge.com/minecraft/mc-mods/enhanced-celestials",
    downloadUrl: "https://edge.forgecdn.net/files/7093/308/Enhanced-Celestials-NeoForge-1.21.1-6.0.2.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1190/101/256/256/638764927492625008.png",
    fileDate: "2025-10-11T04:40:12.137Z",
    fileSizeBytes: 1611531,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 2,
    sha1: "120a2f2ad8f9fcbefebd087c60592b8057a834fc",
    md5: "405c4f3e246045f42343603cd155971f",
    blurb: "Mod by Corgi_Taco. Installed file: Enhanced-Celestials-NeoForge-1.21.1-6.0.2.5.jar. Game versions: Client, 1.21.1, NeoForge, Server. 2 required dependencies.",
  },
  {
    name: "Epic Structures: Villages ",
    category: "World",
    contentType: "Mods",
    projectId: 1308486,
    fileId: 7996778,
    fileName: "Epic Villages 1.3.0 (1.21+).jar",
    author: "ATii",
    url: "https://www.curseforge.com/minecraft/mc-mods/epic-villages",
    downloadUrl: "https://edge.forgecdn.net/files/7996/778/Epic%20Villages%201.3.0%20(1.21%2b).jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1736/742/256/256/639105579490187980.png",
    fileDate: "2026-04-26T20:15:30.053Z",
    fileSizeBytes: 3445547,
    gameVersions: ["1.21","Client","Fabric","1.21.8","1.21.5","1.21.4","Forge","1.21.1","1.21.6","1.21.3","1.21.7","NeoForge","Server","Quilt","1.21.2","1.21.9","1.21.10","1.21.11","26.1","26.1.1","26.1.2"],
    dependencyCount: 0,
    sha1: "c1a6a052425848c3c498c55ffe59adfbe316ec0f",
    md5: "076a285432d8b451f93407ae89194da1",
    blurb: "Mod by ATii. Installed file: Epic Villages 1.3.0 (1.21+).jar. Game versions: 1.21, Client, Fabric, 1.21.8, 1.21.5, 1.21.4, Forge, 1.21.1, 1.21.6, 1.21.3, 1.21.7, NeoForge, Server, Quilt, 1.21.2, 1.21.9, 1.21.10, 1.21.11, 26.1, 26.1.1, 26.1.2.",
  },
  {
    name: "Everything is Copper",
    category: "QoL",
    contentType: "Mods",
    projectId: 579545,
    fileId: 6958511,
    fileName: "everythingcopper-1.21.1-2.4.5.jar",
    author: "LobsterJonn",
    url: "https://www.curseforge.com/minecraft/mc-mods/everythingcopper",
    downloadUrl: "https://edge.forgecdn.net/files/6958/511/everythingcopper-1.21.1-2.4.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/493/221/256/256/637802781002490553.png",
    fileDate: "2025-09-03T08:59:01.547Z",
    fileSizeBytes: 620493,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "b1e47814467032ed8d24f5a2ce3f466e44be9239",
    md5: "fb896ae997e932fe5af9f2b17b60830c",
    blurb: "Mod by LobsterJonn. Installed file: everythingcopper-1.21.1-2.4.5.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "FancyMenu",
    category: "QoL",
    contentType: "Mods",
    projectId: 367706,
    fileId: 8089432,
    fileName: "fancymenu_neoforge_3.9.1_MC_1.21.1.jar",
    author: "Keksuccino",
    url: "https://www.curseforge.com/minecraft/mc-mods/fancymenu",
    downloadUrl: "https://edge.forgecdn.net/files/8089/432/fancymenu_neoforge_3.9.1_MC_1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/935/544/256/256/638412386316055428.png",
    fileDate: "2026-05-14T20:31:18.807Z",
    fileSizeBytes: 25346355,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "7d5be91bdc108df3cce5c68a10af7dd31dfc9e34",
    md5: "41e7769dc89dff4a2c123b6e5f3123de",
    blurb: "Mod by Keksuccino. Installed file: fancymenu_neoforge_3.9.1_MC_1.21.1.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "fix GPU memory leak[Forge/Fabric]",
    category: "Performance",
    contentType: "Mods",
    projectId: 882495,
    fileId: 5513549,
    fileName: "gpumemleakfix-1.21-1.8.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/fix-gpu-memory-leak",
    downloadUrl: "https://edge.forgecdn.net/files/5513/549/gpumemleakfix-1.21-1.8.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/841/827/256/256/638236647684351264.png",
    fileDate: "2024-07-08T12:10:50.6Z",
    fileSizeBytes: 6574,
    gameVersions: ["1.21","Client","1.21.4","NeoForge","1.21.3","1.21.1","1.21.2"],
    dependencyCount: 1,
    sha1: "1894d2f0dd0c275aea0f1a6265ebd5715569c208",
    md5: "96a47a7cff915294a949f73a5f2a8816",
    blurb: "Mod by someaddon. Installed file: gpumemleakfix-1.21-1.8.jar. Game versions: 1.21, Client, 1.21.4, NeoForge, 1.21.3, 1.21.1, 1.21.2. 1 required dependency.",
  },
  {
    name: "Flan (Forge, NeoForge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 493246,
    fileId: 8065248,
    fileName: "flan-1.21.1-1.12.7-neoforge.jar",
    author: "flemmli97",
    url: "https://www.curseforge.com/minecraft/mc-mods/flan-forge",
    downloadUrl: "https://edge.forgecdn.net/files/8065/248/flan-1.21.1-1.12.7-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/394/105/256/256/637590476523454362.png",
    fileDate: "2026-05-09T21:09:28.777Z",
    fileSizeBytes: 937692,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "9a4796a51a991e70d0234a203e0a2c417b809f38",
    md5: "39473e7482a6e364ff63d4f4bc30d9be",
    blurb: "Mod by flemmli97. Installed file: flan-1.21.1-1.12.7-neoforge.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "ForgeEndertech",
    category: "Tech",
    contentType: "Mods",
    projectId: 244844,
    fileId: 8205930,
    fileName: "ForgeEndertech-1.21.1-12.1.2.2-NeoForge-build.0879.jar",
    author: "EnderLanky",
    url: "https://www.curseforge.com/minecraft/mc-mods/forgeendertech",
    downloadUrl: "https://edge.forgecdn.net/files/8205/930/ForgeEndertech-1.21.1-12.1.2.2-NeoForge-build.0879.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/39/528/256/256/635982217182008015.png",
    fileDate: "2026-06-06T14:27:28.693Z",
    fileSizeBytes: 535552,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "71267bbe37cc2bf78fedb06b0f16643c9b22d16c",
    md5: "91333b1e9c8c7dfb5afbf62fc0aa780e",
    blurb: "Mod by EnderLanky. Installed file: ForgeEndertech-1.21.1-12.1.2.2-NeoForge-build.0879.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Forgified Fabric API",
    category: "Library",
    contentType: "Mods",
    projectId: 889079,
    fileId: 7658611,
    fileName: "forgified-fabric-api-0.116.7+2.2.4+1.21.1.jar",
    author: "Su5eD",
    url: "https://www.curseforge.com/minecraft/mc-mods/forgified-fabric-api",
    downloadUrl: "https://edge.forgecdn.net/files/7658/611/forgified-fabric-api-0.116.7%2b2.2.4%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1053/924/256/256/638584678951964920.png",
    fileDate: "2026-02-21T15:40:07.007Z",
    fileSizeBytes: 5569717,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "c0267082a59e166f47c3c64ba605faa778a29480",
    md5: "d0fee8a0321c9d8978943c72cf1cfb93",
    blurb: "Mod by Su5eD. Installed file: forgified-fabric-api-0.116.7+2.2.4+1.21.1.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Forgotten Church",
    category: "QoL",
    contentType: "Mods",
    projectId: 1365281,
    fileId: 7123463,
    fileName: "forgotten_church-1.0.0-neoforge-1.21.1.jar",
    author: "SuperWarioModTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/forgotten-church",
    downloadUrl: "https://edge.forgecdn.net/files/7123/463/forgotten_church-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1483/824/256/256/638964370600117433.png",
    fileDate: "2025-10-19T02:25:39.397Z",
    fileSizeBytes: 19234,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "10057b9650e5c56853f6fb24ecfd906ac51c964f",
    md5: "45beb1d8f504e41752260251f402d866",
    blurb: "Mod by SuperWarioModTeam. Installed file: forgotten_church-1.0.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Fragmentum [NeoForge Edition]",
    category: "QoL",
    contentType: "Mods",
    projectId: 1123977,
    fileId: 8141338,
    fileName: "fragmentum-neoforge-1.21.1-2.2.4.jar",
    author: "Obscuria",
    url: "https://www.curseforge.com/minecraft/mc-mods/fragmentum-neoforge",
    downloadUrl: "https://edge.forgecdn.net/files/8141/338/fragmentum-neoforge-1.21.1-2.2.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/1742/100/639109114911588915.webp",
    fileDate: "2026-05-25T01:52:46.76Z",
    fileSizeBytes: 1936521,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "bba9111b9029c272afde9f102d0dac7cf5a3c77b",
    md5: "51d682f632989515e40610659ee172b0",
    blurb: "Mod by Obscuria. Installed file: fragmentum-neoforge-1.21.1-2.2.4.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Friends&Foes (Forge/NeoForge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 602059,
    fileId: 8154530,
    fileName: "friendsandfoes-neoforge-4.0.26+mc1.21.1.jar",
    author: "Faboslav",
    url: "https://www.curseforge.com/minecraft/mc-mods/friends-and-foes-forge",
    downloadUrl: "https://edge.forgecdn.net/files/8154/530/friendsandfoes-neoforge-4.0.26%2bmc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1341/726/256/256/638872149406466393.png",
    fileDate: "2026-05-27T14:25:56.323Z",
    fileSizeBytes: 5211942,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "a8f70b74dc5166b657874d6decd7685fe5837a5c",
    md5: "52266549c8f7e541bdd5a8bd834de05d",
    blurb: "Mod by Faboslav. Installed file: friendsandfoes-neoforge-4.0.26+mc1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Gamma Creatures",
    category: "Adventure",
    contentType: "Mods",
    projectId: 952137,
    fileId: 6533252,
    fileName: "Gamma_creatures-1.2.2_neoforge_1.21.1.jar",
    author: "ALe96",
    url: "https://www.curseforge.com/minecraft/mc-mods/gamma-creatures",
    downloadUrl: "https://edge.forgecdn.net/files/6533/252/Gamma_creatures-1.2.2_neoforge_1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/921/696/256/256/638386311123016718_animated.gif",
    fileDate: "2025-05-15T19:19:32.327Z",
    fileSizeBytes: 61647814,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "8fc2a5a99c0dca41b42b3649beb3a1d4daf83a82",
    md5: "5c6304c6c40dd1d97a511b7028b8f8ca",
    blurb: "Mod by ALe96. Installed file: Gamma_creatures-1.2.2_neoforge_1.21.1.jar. Game versions: Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "GeckoLib",
    category: "Library",
    contentType: "Mods",
    projectId: 388172,
    fileId: 7707149,
    fileName: "geckolib-neoforge-1.21.1-4.8.4.jar",
    author: "Gecko",
    url: "https://www.curseforge.com/minecraft/mc-mods/geckolib",
    downloadUrl: "https://edge.forgecdn.net/files/7707/149/geckolib-neoforge-1.21.1-4.8.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1081/393/256/256/638621132937140582.png",
    fileDate: "2026-03-03T20:06:19.73Z",
    fileSizeBytes: 622582,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "eb854c8ec53ef922a5f3877a1aa4c1ce1352e0ce",
    md5: "f68322025b603faaaaa5a1b3c52dc2ae",
    blurb: "Mod by Gecko. Installed file: geckolib-neoforge-1.21.1-4.8.4.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "GlitchCore",
    category: "Library",
    contentType: "Mods",
    projectId: 955399,
    fileId: 8109792,
    fileName: "GlitchCore-neoforge-1.21.1-2.1.0.2.jar",
    author: "TheAdubbz",
    url: "https://www.curseforge.com/minecraft/mc-mods/glitchcore",
    downloadUrl: "https://edge.forgecdn.net/files/8109/792/GlitchCore-neoforge-1.21.1-2.1.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/925/423/256/256/638393995566142829.png",
    fileDate: "2026-05-18T17:16:01.96Z",
    fileSizeBytes: 90717,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "a31c3f36330f19aa538add3d727782a62c9c30ad",
    md5: "3bdf763d2461aa2731ed3515e0761d2f",
    blurb: "Mod by TheAdubbz. Installed file: GlitchCore-neoforge-1.21.1-2.1.0.2.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Golem Spawn Fix",
    category: "QoL",
    contentType: "Mods",
    projectId: 1217787,
    fileId: 6467851,
    fileName: "golem_spawn_fix-1.0.2-neoforge-1.21.1.jar",
    author: "bo_bo0",
    url: "https://www.curseforge.com/minecraft/mc-mods/golem-spawn-fix",
    downloadUrl: "https://edge.forgecdn.net/files/6467/851/golem_spawn_fix-1.0.2-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1197/20/256/256/638772998117052917.png",
    fileDate: "2025-04-26T18:23:13.96Z",
    fileSizeBytes: 152847,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "89cfa526bf3d883afbf5adf8be2921beced1857b",
    md5: "5ace62c728185c44ad47379d81063cef",
    blurb: "Mod by bo_bo0. Installed file: golem_spawn_fix-1.0.2-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Golems Are Friends Not Fodder",
    category: "QoL",
    contentType: "Mods",
    projectId: 684459,
    fileId: 6350914,
    fileName: "golemsarefriends-1.21.1-1.0.1.jar",
    author: "LobsterJonn",
    url: "https://www.curseforge.com/minecraft/mc-mods/golemsarefriends",
    downloadUrl: "https://edge.forgecdn.net/files/6350/914/golemsarefriends-1.21.1-1.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/617/706/256/256/638004334210647513.png",
    fileDate: "2025-03-26T11:07:24.763Z",
    fileSizeBytes: 10677,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "945cf668d4c2a45625b78d3a887c0d52505d811c",
    md5: "32325f5ba36d0d74f38182336ecdac8b",
    blurb: "Mod by LobsterJonn. Installed file: golemsarefriends-1.21.1-1.0.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "GraveStone Mod",
    category: "QoL",
    contentType: "Mods",
    projectId: 238551,
    fileId: 8056307,
    fileName: "gravestone-neoforge-1.21.1-1.0.37.jar",
    author: "henkelmax",
    url: "https://www.curseforge.com/minecraft/mc-mods/gravestone-mod",
    downloadUrl: "https://edge.forgecdn.net/files/8056/307/gravestone-neoforge-1.21.1-1.0.37.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/276/919/256/256/637267971739647681.png",
    fileDate: "2026-05-08T06:37:30.183Z",
    fileSizeBytes: 321955,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "4120452fb038e7781367774a10093c8767cc4c1b",
    md5: "0a71c92949bead5c7e8eeab71aed0be5",
    blurb: "Mod by henkelmax. Installed file: gravestone-neoforge-1.21.1-1.0.37.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "GroovyModLoader (GML)",
    category: "QoL",
    contentType: "Mods",
    projectId: 661517,
    fileId: 5902913,
    fileName: "gml-6.0.2.jar",
    author: "matyrobbrt",
    url: "https://www.curseforge.com/minecraft/mc-mods/gml",
    downloadUrl: "https://edge.forgecdn.net/files/5902/913/gml-6.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/591/684/256/256/637962788103373661.png",
    fileDate: "2024-11-14T17:43:10.357Z",
    fileSizeBytes: 10981280,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "29a8153c54b9b03a3b4b42be7d77fe4ac2459720",
    md5: "5770d4f9a8b6fd2482c0e1104e9210ee",
    blurb: "Mod by matyrobbrt. Installed file: gml-6.0.2.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Guard Villagers",
    category: "World",
    contentType: "Mods",
    projectId: 360203,
    fileId: 8230345,
    fileName: "guardvillagers-2.4.10-1.21.1.jar",
    author: "almightytallestred",
    url: "https://www.curseforge.com/minecraft/mc-mods/guard-villagers",
    downloadUrl: "https://edge.forgecdn.net/files/8230/345/guardvillagers-2.4.10-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/280/785/256/256/637283115951339629.png",
    fileDate: "2026-06-11T07:07:05.59Z",
    fileSizeBytes: 283467,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "3367fcfe8b72a2358cb4be83ac0b7f0470831a92",
    md5: "188b779ad507c7b0e11dd7e1ff7ba168",
    blurb: "Mod by almightytallestred. Installed file: guardvillagers-2.4.10-1.21.1.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Hey Berry! SHUT UP",
    category: "QoL",
    contentType: "Mods",
    projectId: 634227,
    fileId: 5517177,
    fileName: "heyberryshutup-1.21.0-2.0.4.jar",
    author: "LobsterJonn",
    url: "https://www.curseforge.com/minecraft/mc-mods/heyberryshutup",
    downloadUrl: "https://edge.forgecdn.net/files/5517/177/heyberryshutup-1.21.0-2.0.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/559/907/256/256/637910167263590605.png",
    fileDate: "2024-07-09T16:15:26.647Z",
    fileSizeBytes: 6186,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "a897b4ac33d0fc5a2a533d56381c272f1e49520b",
    md5: "395f1c098041c4a7752c1cd149d2bcf6",
    blurb: "Mod by LobsterJonn. Installed file: heyberryshutup-1.21.0-2.0.4.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Horses can Swim",
    category: "QoL",
    contentType: "Mods",
    projectId: 937337,
    fileId: 5427645,
    fileName: "horsescanswim-1.1.0.jar",
    author: "gohkenytp",
    url: "https://www.curseforge.com/minecraft/mc-mods/horses-can-swim",
    downloadUrl: "https://edge.forgecdn.net/files/5427/645/horsescanswim-1.1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/904/983/256/256/638355712677673066.png",
    fileDate: "2024-06-14T13:00:54.407Z",
    fileSizeBytes: 5049,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "169bd0f8aee1bea73550da89af6bc33e02453688",
    md5: "50b365e6a7c9409a4e4e3ee4f7e882e8",
    blurb: "Mod by gohkenytp. Installed file: horsescanswim-1.1.0.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Hunter'sReturn",
    category: "Adventure",
    contentType: "Mods",
    projectId: 318857,
    fileId: 8226520,
    fileName: "hunters_return-1.21.1-20.8.0.jar",
    author: "baguchiMC",
    url: "https://www.curseforge.com/minecraft/mc-mods/huntersreturn",
    downloadUrl: "https://edge.forgecdn.net/files/8226/520/hunters_return-1.21.1-20.8.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1598/338/256/256/639032938534590267.png",
    fileDate: "2026-06-10T13:15:39.023Z",
    fileSizeBytes: 565457,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "f0861c8828395b77dd8d412e35cc731745c1a423",
    md5: "ff0610a462df63f97ab3a151aa8cae87",
    blurb: "Mod by baguchiMC. Installed file: hunters_return-1.21.1-20.8.0.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Ice and Fire: Spellbooks",
    category: "Magic",
    contentType: "Mods",
    projectId: 977855,
    fileId: 8079745,
    fileName: "ice_and_fire_spellbooks-2.3.3-1.21.1.jar",
    author: "Ace_The_Eldritch_King",
    url: "https://www.curseforge.com/minecraft/mc-mods/ice-and-fire-spellbooks",
    downloadUrl: "https://edge.forgecdn.net/files/8079/745/ice_and_fire_spellbooks-2.3.3-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/951/866/256/256/638441590978803786.png",
    fileDate: "2026-05-12T20:51:06.117Z",
    fileSizeBytes: 173108,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 4,
    sha1: "27e2828594e2c1140c65f682a72f8cadfb1f5a34",
    md5: "940dc43b66d9fe4b263397b2d235b176",
    blurb: "Mod by Ace_The_Eldritch_King. Installed file: ice_and_fire_spellbooks-2.3.3-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 4 required dependencies.",
  },
  {
    name: "Ice Enchantments",
    category: "Magic",
    contentType: "Mods",
    projectId: 999684,
    fileId: 6303552,
    fileName: "frost_aspect_new-1.0.0-neoforge-1.21.1.jar",
    author: "chickenjockey4000",
    url: "https://www.curseforge.com/minecraft/mc-mods/ice-enchantments",
    downloadUrl: "https://edge.forgecdn.net/files/6303/552/frost_aspect_new-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/976/956/256/256/638481067442605068.png",
    fileDate: "2025-03-14T15:56:38.76Z",
    fileSizeBytes: 11806,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "e94065587b934511b0cd9eab1a7c2787730b9b11",
    md5: "c5e2326fcfa35df969e32aa197e36c38",
    blurb: "Mod by chickenjockey4000. Installed file: frost_aspect_new-1.0.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "IceAndFire Community Edition",
    category: "QoL",
    contentType: "Mods",
    projectId: 1040076,
    fileId: 7722420,
    fileName: "IceAndFireCE-2.0-beta.15-1.21.1-neoforge.jar",
    author: "IAFEnvoy",
    url: "https://www.curseforge.com/minecraft/mc-mods/iceandfire-ce",
    downloadUrl: "https://edge.forgecdn.net/files/7722/420/IceAndFireCE-2.0-beta.15-1.21.1-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1129/550/256/256/638688106588576091.jpg",
    fileDate: "2026-03-07T03:07:06.18Z",
    fileSizeBytes: 20933691,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 6,
    sha1: "c4d33745a8041465f2d12bb76fc048750288ce24",
    md5: "c287ce9b26ef55900a5f9d87c74c2447",
    blurb: "Mod by IAFEnvoy. Installed file: IceAndFireCE-2.0-beta.15-1.21.1-neoforge.jar. Game versions: Client, 1.21.1, NeoForge, Server. 6 required dependencies.",
  },
  {
    name: "iChunUtil",
    category: "QoL",
    contentType: "Mods",
    projectId: 229060,
    fileId: 6000439,
    fileName: "iChunUtil-1.21-NeoForge-1.0.3.jar",
    author: "iChun",
    url: "https://www.curseforge.com/minecraft/mc-mods/ichunutil",
    downloadUrl: "https://edge.forgecdn.net/files/6000/439/iChunUtil-1.21-NeoForge-1.0.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/19/167/256/256/635690971311763313.png",
    fileDate: "2024-12-18T00:58:03.477Z",
    fileSizeBytes: 688343,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "1f161c8b6288e6094fc57f4a9c10a6050df71081",
    md5: "6c671acf384a48cca55c3ad2298989b9",
    blurb: "Mod by iChun. Installed file: iChunUtil-1.21-NeoForge-1.0.3.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Illager Invasion",
    category: "Adventure",
    contentType: "Mods",
    projectId: 891324,
    fileId: 6492670,
    fileName: "IllagerInvasion-v21.1.6-1.21.1-NeoForge.jar",
    author: "Fuzs",
    url: "https://www.curseforge.com/minecraft/mc-mods/illager-invasion",
    downloadUrl: "https://edge.forgecdn.net/files/6492/670/IllagerInvasion-v21.1.6-1.21.1-NeoForge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/852/43/256/256/638254581220112832.png",
    fileDate: "2025-05-03T20:29:46.39Z",
    fileSizeBytes: 2361701,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 2,
    sha1: "48bea606f6e3f10e2100349de2c6c65c76c20786",
    md5: "38b505e1a2055b99a0fc9a7bd6caf0cc",
    blurb: "Mod by Fuzs. Installed file: IllagerInvasion-v21.1.6-1.21.1-NeoForge.jar. Game versions: NeoForge, 1.21.1. 2 required dependencies.",
  },
  {
    name: "Illager Viking Longship",
    category: "World",
    contentType: "Mods",
    projectId: 1253596,
    fileId: 6472299,
    fileName: "illager_viking_longship-1.0.0-neoforge-1.21.1.jar",
    author: "SuperWarioModTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/illager-viking-longship",
    downloadUrl: "https://edge.forgecdn.net/files/6472/299/illager_viking_longship-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1246/104/256/256/638813907647759964.png",
    fileDate: "2025-04-28T00:00:38.807Z",
    fileSizeBytes: 24597,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "4976f65e2e51cb147dbf8ffb24833d9d8e4d6d25",
    md5: "abf0432b3131d5ca589b5e207f553e0b",
    blurb: "Mod by SuperWarioModTeam. Installed file: illager_viking_longship-1.0.0-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Illager Warship",
    category: "Magic",
    contentType: "Mods",
    projectId: 1091632,
    fileId: 6561660,
    fileName: "illagerwarship-1.0.1-neoforge-1.21.1.jar",
    author: "SuperWarioModTeam",
    url: "https://www.curseforge.com/minecraft/mc-mods/illager-warship",
    downloadUrl: "https://edge.forgecdn.net/files/6561/660/illagerwarship-1.0.1-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1068/669/256/256/638603205947870356.png",
    fileDate: "2025-05-24T15:40:07.273Z",
    fileSizeBytes: 71280,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "538db7de4264f6d07ca2a5e7a947777ad8216225",
    md5: "a07970ca3211ff9a58e309730eb04df9",
    blurb: "Mod by SuperWarioModTeam. Installed file: illagerwarship-1.0.1-neoforge-1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Illagers Wear Armor",
    category: "Adventure",
    contentType: "Mods",
    projectId: 407488,
    fileId: 5552789,
    fileName: "illagersweararmor-1.21-2.3.1.jar",
    author: "almightytallestred",
    url: "https://www.curseforge.com/minecraft/mc-mods/illagers-wear-armor",
    downloadUrl: "https://edge.forgecdn.net/files/5552/789/illagersweararmor-1.21-2.3.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/299/548/256/256/637353816206157107.png",
    fileDate: "2024-07-21T22:11:17.453Z",
    fileSizeBytes: 70868,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "9477f607cc06fcd32db9ca2bc7778e3ccb4210e2",
    md5: "bd3df72874c4a9a5473f433c31cda929",
    blurb: "Mod by almightytallestred. Installed file: illagersweararmor-1.21-2.3.1.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "ImmediatelyFast",
    category: "Performance",
    contentType: "Mods",
    projectId: 686911,
    fileId: 7537795,
    fileName: "ImmediatelyFast-NeoForge-1.6.10+1.21.1.jar",
    author: "RaphiMC",
    url: "https://www.curseforge.com/minecraft/mc-mods/immediatelyfast",
    downloadUrl: "https://edge.forgecdn.net/files/7537/795/ImmediatelyFast-NeoForge-1.6.10%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/873/971/256/256/638294478643875692.png",
    fileDate: "2026-01-27T21:12:04.863Z",
    fileSizeBytes: 368598,
    gameVersions: ["1.21","Client","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "f1f5cccd7cb59d875f44566b2e557ccecc8c33fb",
    md5: "567bb6d9155070ad858740af12450c63",
    blurb: "Mod by RaphiMC. Installed file: ImmediatelyFast-NeoForge-1.6.10+1.21.1.jar. Game versions: 1.21, Client, 1.21.1, NeoForge.",
  },
  {
    name: "Incendium",
    category: "QoL",
    contentType: "Mods",
    projectId: 591388,
    fileId: 5962249,
    fileName: "Incendium_1.21.x_v5.4.4.jar",
    author: "Starmute",
    url: "https://www.curseforge.com/minecraft/mc-mods/incendium",
    downloadUrl: "https://edge.forgecdn.net/files/5962/249/Incendium_1.21.x_v5.4.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/506/247/256/256/637824451278245383.png",
    fileDate: "2024-12-04T14:16:22.867Z",
    fileSizeBytes: 4267528,
    gameVersions: ["1.21","Fabric","1.21.4","NeoForge","Forge","1.21.3","1.21.1","Quilt","1.21.2"],
    dependencyCount: 0,
    sha1: "40da6da25ec45c4d88447733255e4281b6f22fef",
    md5: "37793d374c89e38074bde664fe36df59",
    blurb: "Mod by Starmute. Installed file: Incendium_1.21.x_v5.4.4.jar. Game versions: 1.21, Fabric, 1.21.4, NeoForge, Forge, 1.21.3, 1.21.1, Quilt, 1.21.2.",
  },
  {
    name: "Inventory Essentials",
    category: "QoL",
    contentType: "Mods",
    projectId: 368825,
    fileId: 8019500,
    fileName: "inventoryessentials-neoforge-1.21.1-21.1.15.jar",
    author: "BlayTheNinth",
    url: "https://www.curseforge.com/minecraft/mc-mods/inventory-essentials",
    downloadUrl: "https://edge.forgecdn.net/files/8019/500/inventoryessentials-neoforge-1.21.1-21.1.15.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/256/58/256/256/637203881905177301.png",
    fileDate: "2026-05-01T06:46:04.91Z",
    fileSizeBytes: 189939,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "f37a1afbb03443f4bc385ec5ac5bb31daf5d054b",
    md5: "c3d51d9129065e29307b0e46b49b47ec",
    blurb: "Mod by BlayTheNinth. Installed file: inventoryessentials-neoforge-1.21.1-21.1.15.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Inventory Pets",
    category: "Adventure",
    contentType: "Mods",
    projectId: 229380,
    fileId: 7737858,
    fileName: "inventorypets-2.2.8.jar",
    author: "Purplicious_Cow_",
    url: "https://www.curseforge.com/minecraft/mc-mods/inventory-pets",
    downloadUrl: "https://edge.forgecdn.net/files/7737/858/inventorypets-2.2.8.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/16/156/256/256/635641892727436075.png",
    fileDate: "2026-03-10T09:52:08.953Z",
    fileSizeBytes: 7768014,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "2428b4551d5cb9e7b862cf1fa8c10c75a1d1f1c6",
    md5: "25673d8efe573a776e193deb797e72a9",
    blurb: "Mod by Purplicious_Cow_. Installed file: inventorypets-2.2.8.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Iris Shaders",
    category: "Performance",
    contentType: "Mods",
    projectId: 455508,
    fileId: 8242804,
    fileName: "iris-neoforge-1.8.14-beta.1+mc1.21.1.jar",
    author: "coderbot",
    url: "https://www.curseforge.com/minecraft/mc-mods/irisshaders",
    downloadUrl: "https://edge.forgecdn.net/files/8242/804/iris-neoforge-1.8.14-beta.1%2bmc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1002/450/256/256/638522657871453967.png",
    fileDate: "2026-06-13T15:58:55.503Z",
    fileSizeBytes: 2540723,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "1bd129cf7bce65d6b1c0543045f0620c98a0f885",
    md5: "6b68276a6718656ec476cfac69dfe013",
    blurb: "Mod by coderbot. Installed file: iris-neoforge-1.8.14-beta.1+mc1.21.1.jar. Game versions: Client, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Iron's Lib",
    category: "Magic",
    contentType: "Mods",
    projectId: 1492763,
    fileId: 8207094,
    fileName: "irons_lib-1.21.1-1.1.0.jar",
    author: "Iron431",
    url: "https://www.curseforge.com/minecraft/mc-mods/irons-lib",
    downloadUrl: "https://edge.forgecdn.net/files/8207/94/irons_lib-1.21.1-1.1.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1751/340/256/256/639114646834174687.png",
    fileDate: "2026-06-06T19:28:00.217Z",
    fileSizeBytes: 400168,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "8c275a6292f428fcf10f5bdcbb3df5a88ff0becc",
    md5: "a250c02914fd70fdc31cafae856417d6",
    blurb: "Mod by Iron431. Installed file: irons_lib-1.21.1-1.1.0.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Iron's Spells 'n Spellbooks",
    category: "Magic",
    contentType: "Mods",
    projectId: 855414,
    fileId: 8237097,
    fileName: "irons_spellbooks-1.21.1-3.16.1.jar",
    author: "Iron431",
    url: "https://www.curseforge.com/minecraft/mc-mods/irons-spells-n-spellbooks",
    downloadUrl: "https://edge.forgecdn.net/files/8237/97/irons_spellbooks-1.21.1-3.16.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/871/265/256/256/638288661913483053.png",
    fileDate: "2026-06-12T15:13:41.663Z",
    fileSizeBytes: 13789430,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 4,
    sha1: "9e6d200ebab6e4d321864655764870d878174a8f",
    md5: "a05b1b0f1d16b9f922ccd2fdaeba9259",
    blurb: "Mod by Iron431. Installed file: irons_spellbooks-1.21.1-3.16.1.jar. Game versions: 1.21.1, NeoForge. 4 required dependencies.",
  },
  {
    name: "It Takes a Pillage Continuation",
    category: "Library",
    contentType: "Mods",
    projectId: 1111063,
    fileId: 8249194,
    fileName: "takesapillage-neoforge-1.0.12+mc1.21.1.jar",
    author: "Faboslav",
    url: "https://www.curseforge.com/minecraft/mc-mods/it-takes-a-pillage-continuation",
    downloadUrl: "https://edge.forgecdn.net/files/8249/194/takesapillage-neoforge-1.0.12%2bmc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1088/404/256/256/638631273109179063.png",
    fileDate: "2026-06-14T19:57:04.843Z",
    fileSizeBytes: 2795307,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "8362c45471e934ecc714e66f746c757d81d49bea",
    md5: "b40e8bbe0e7e92f16726da09e1186949",
    blurb: "Mod by Faboslav. Installed file: takesapillage-neoforge-1.0.12+mc1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Jade 🔍",
    category: "QoL",
    contentType: "Mods",
    projectId: 324717,
    fileId: 7545219,
    fileName: "Jade-1.21.1-NeoForge-15.10.5.jar",
    author: "Snownee",
    url: "https://www.curseforge.com/minecraft/mc-mods/jade",
    downloadUrl: "https://edge.forgecdn.net/files/7545/219/Jade-1.21.1-NeoForge-15.10.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/207/323/256/256/636965628804677340.png",
    fileDate: "2026-01-29T11:11:45.407Z",
    fileSizeBytes: 725742,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "d5bf134b3dbde9f5258666823900e21341dc0a50",
    md5: "80f9186d25b02ebbfa5773416f5da410",
    blurb: "Mod by Snownee. Installed file: Jade-1.21.1-NeoForge-15.10.5.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "JourneyMap",
    category: "Tech",
    contentType: "Mods",
    projectId: 32274,
    fileId: 8250732,
    fileName: "journeymap-neoforge-1.21.1-6.0.0-beta.84.jar",
    author: "techbrew",
    url: "https://www.curseforge.com/minecraft/mc-mods/journeymap",
    downloadUrl: "https://edge.forgecdn.net/files/8250/732/journeymap-neoforge-1.21.1-6.0.0-beta.84.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/9/144/256/256/635421614078544069.png",
    fileDate: "2026-06-15T02:58:12.01Z",
    fileSizeBytes: 4128387,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "b9476e794097b32741b111af4b0c01d70dd3f53f",
    md5: "0a19423e5fa0d2579ea046cd969973c5",
    blurb: "Mod by techbrew. Installed file: journeymap-neoforge-1.21.1-6.0.0-beta.84.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Jupiter",
    category: "QoL",
    contentType: "Mods",
    projectId: 1072905,
    fileId: 7738312,
    fileName: "jupiter-2.3.7-1.21.1-neoforge.jar",
    author: "IAFEnvoy",
    url: "https://www.curseforge.com/minecraft/mc-mods/jupiter",
    downloadUrl: "https://edge.forgecdn.net/files/7738/312/jupiter-2.3.7-1.21.1-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/1634/296/639046854286073372.webp",
    fileDate: "2026-03-10T12:59:30.053Z",
    fileSizeBytes: 278988,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "569fb484ea5c8e8d690945ad4cd132131a719751",
    md5: "e9d3d142f366cfc1d33030d61f6a1fb2",
    blurb: "Mod by IAFEnvoy. Installed file: jupiter-2.3.7-1.21.1-neoforge.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Just Enough Items (JEI)",
    category: "QoL",
    contentType: "Mods",
    projectId: 238222,
    fileId: 7391682,
    fileName: "jei-1.21.1-neoforge-19.27.0.336.jar",
    author: "mezz",
    url: "https://www.curseforge.com/minecraft/mc-mods/jei",
    downloadUrl: "https://edge.forgecdn.net/files/7391/682/jei-1.21.1-neoforge-19.27.0.336.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/29/69/256/256/635838945588716414.jpeg",
    fileDate: "2025-12-29T08:39:17.3Z",
    fileSizeBytes: 1529192,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "d02c849e4e321e7b056a48e0242ec641560c2ab8",
    md5: "d3da422d1a44e31af8a8d036b3d338f7",
    blurb: "Mod by mezz. Installed file: jei-1.21.1-neoforge-19.27.0.336.jar. Game versions: 1.21, 1.21.1, NeoForge.",
  },
  {
    name: "Kobolds!",
    category: "QoL",
    contentType: "Mods",
    projectId: 484967,
    fileId: 8198851,
    fileName: "Kobolds-4.0.1.jar",
    author: "Jusey1",
    url: "https://www.curseforge.com/minecraft/mc-mods/kobolds",
    downloadUrl: "https://edge.forgecdn.net/files/8198/851/Kobolds-4.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/857/271/256/256/638261627227317411.png",
    fileDate: "2026-06-05T02:03:59.75Z",
    fileSizeBytes: 2303275,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "3f77ed5c2dc4e2b37c79578efffaf1d19e9f2ff4",
    md5: "35b59cb846a958e517516e75416ed40e",
    blurb: "Mod by Jusey1. Installed file: Kobolds-4.0.1.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Konkrete",
    category: "QoL",
    contentType: "Mods",
    projectId: 410295,
    fileId: 5453385,
    fileName: "konkrete_neoforge_1.9.9_MC_1.21.jar",
    author: "Keksuccino",
    url: "https://www.curseforge.com/minecraft/mc-mods/konkrete",
    downloadUrl: "https://edge.forgecdn.net/files/5453/385/konkrete_neoforge_1.9.9_MC_1.21.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1478/850/256/256/638961204478458770.png",
    fileDate: "2024-06-21T07:53:27.01Z",
    fileSizeBytes: 618842,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "97771eb287d5ac7fe667d1df9493d5e54c8ca1fa",
    md5: "6e77d08299ea1ec7756a299263bc469b",
    blurb: "Mod by Keksuccino. Installed file: konkrete_neoforge_1.9.9_MC_1.21.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "KubeJS",
    category: "QoL",
    contentType: "Mods",
    projectId: 238086,
    fileId: 8083208,
    fileName: "kubejs-neoforge-2101.7.2-build.368.jar",
    author: "LatvianModder",
    url: "https://www.curseforge.com/minecraft/mc-mods/kubejs",
    downloadUrl: "https://edge.forgecdn.net/files/8083/208/kubejs-neoforge-2101.7.2-build.368.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1053/159/256/256/638583716122159056.png",
    fileDate: "2026-05-13T15:17:34.293Z",
    fileSizeBytes: 2281720,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "cd8e1e392d642e4d0f1fbc099d93da105c263d0d",
    md5: "95792a5239ae2f1d478d2a674dcf557f",
    blurb: "Mod by LatvianModder. Installed file: kubejs-neoforge-2101.7.2-build.368.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Leaf's Copper Backport",
    category: "QoL",
    contentType: "Mods",
    projectId: 1313101,
    fileId: 6848605,
    fileName: "leafscopperbackport-1.2-neoforge-1.21.1.jar",
    author: "LeafsMatrix",
    url: "https://www.curseforge.com/minecraft/mc-mods/copper-backport",
    downloadUrl: "https://edge.forgecdn.net/files/6848/605/leafscopperbackport-1.2-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1369/919/256/256/638889465826411219.png",
    fileDate: "2025-08-04T21:59:24.803Z",
    fileSizeBytes: 641147,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "35e6ba626a0d7712c488132b8404e0bc0d914e76",
    md5: "a3408ff269cf3a1cd4998952e03e5a36",
    blurb: "Mod by LeafsMatrix. Installed file: leafscopperbackport-1.2-neoforge-1.21.1.jar. Game versions: Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Let Sleeping Dogs Lie (Forge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 334098,
    fileId: 5478504,
    fileName: "LetSleepingDogsLie-1.21-NeoForge-1.3.0.jar",
    author: "iChun",
    url: "https://www.curseforge.com/minecraft/mc-mods/let-sleeping-dogs-lie",
    downloadUrl: "https://edge.forgecdn.net/files/5478/504/LetSleepingDogsLie-1.21-NeoForge-1.3.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/217/402/256/256/637006968815525118.png",
    fileDate: "2024-06-27T03:47:39.687Z",
    fileSizeBytes: 269950,
    gameVersions: ["1.21","Client","NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "8f854de7ae2c3610211cdafbe3682db5081adefe",
    md5: "6ce5964d43c9ea452c6a823e5464d341",
    blurb: "Mod by iChun. Installed file: LetSleepingDogsLie-1.21-NeoForge-1.3.0.jar. Game versions: 1.21, Client, NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Let Your Friend Eating! (Can feed other player)",
    category: "QoL",
    contentType: "Mods",
    projectId: 1206957,
    fileId: 7544704,
    fileName: "LetYourFriendEating_1.1.4_1.21.1_NeoForge.jar",
    author: "TamKungZ_",
    url: "https://www.curseforge.com/minecraft/mc-mods/letyourfriendeating",
    downloadUrl: "https://edge.forgecdn.net/files/7544/704/LetYourFriendEating_1.1.4_1.21.1_NeoForge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1559/951/256/256/639012255626897899.jpg",
    fileDate: "2026-01-29T07:44:18.09Z",
    fileSizeBytes: 136649,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "a8e2a40cb50a337e33564ea1cb9dbf4148c0e242",
    md5: "9d8d2c6f5730f5017e1622cadef03de4",
    blurb: "Mod by TamKungZ_. Installed file: LetYourFriendEating_1.1.4_1.21.1_NeoForge.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Lexiconfig",
    category: "QoL",
    contentType: "Mods",
    projectId: 1019452,
    fileId: 8208839,
    fileName: "lexiconfig-neoforge-1.4.21-novel.jar",
    author: "CodinGlitch",
    url: "https://www.curseforge.com/minecraft/mc-mods/lexiconfig",
    downloadUrl: "https://edge.forgecdn.net/files/8208/839/lexiconfig-neoforge-1.4.21-novel.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1729/749/256/256/639100707648865443.png",
    fileDate: "2026-06-07T04:03:03.053Z",
    fileSizeBytes: 65316,
    gameVersions: ["1.21","Client","1.21.8","1.21.5","1.21.4","1.21.1","1.21.6","1.21.3","1.21.7","NeoForge","Server","1.21.2","1.21.9","1.21.10","1.21.11"],
    dependencyCount: 1,
    sha1: "f862c78f4d27938208913d1c3ee4d9be1a13d166",
    md5: "8fc009428b93671133dda22d0153c4bb",
    blurb: "Mod by CodinGlitch. Installed file: lexiconfig-neoforge-1.4.21-novel.jar. Game versions: 1.21, Client, 1.21.8, 1.21.5, 1.21.4, 1.21.1, 1.21.6, 1.21.3, 1.21.7, NeoForge, Server, 1.21.2, 1.21.9, 1.21.10, 1.21.11. 1 required dependency.",
  },
  {
    name: "Loot Integrations",
    category: "QoL",
    contentType: "Mods",
    projectId: 580689,
    fileId: 6640970,
    fileName: "lootintegrations-1.21.1-4.7.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations",
    downloadUrl: "https://edge.forgecdn.net/files/6640/970/lootintegrations-1.21.1-4.7.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/531/625/256/256/637853939577730031.png",
    fileDate: "2025-06-11T18:08:14.7Z",
    fileSizeBytes: 36966,
    gameVersions: ["NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "ba601fe630f444d974838bfd80a185a0e3e0309c",
    md5: "de033387fe1955841bea50360aec0315",
    blurb: "Mod by someaddon. Installed file: lootintegrations-1.21.1-4.7.jar. Game versions: NeoForge, 1.21.1, Server.",
  },
  {
    name: "Loot Integrations: ATi Structures, Epic Structures Villages & Witch Huts",
    category: "World",
    contentType: "Mods",
    projectId: 1420613,
    fileId: 7416794,
    fileName: "lootintegrations_ati-1.2.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations-ati-structures-epic-structures",
    downloadUrl: "https://edge.forgecdn.net/files/7416/794/lootintegrations_ati-1.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1595/136/256/256/639031349632895866.png",
    fileDate: "2026-01-04T14:51:12.14Z",
    fileSizeBytes: 5659,
    gameVersions: ["Fabric","1.21.8","1.21.5","1.21.4","1.20.1","Forge","1.21.1","1.21.6","1.21.7","1.19.2","NeoForge","Server","1.21.9","1.21.10","1.21.11"],
    dependencyCount: 1,
    sha1: "52897794d55f0eb74b72ee657028a25e018e94b0",
    md5: "39af89e1e811648787cbbbfbffb7d435",
    blurb: "Mod by someaddon. Installed file: lootintegrations_ati-1.2.jar. Game versions: Fabric, 1.21.8, 1.21.5, 1.21.4, 1.20.1, Forge, 1.21.1, 1.21.6, 1.21.7, 1.19.2, NeoForge, Server, 1.21.9, 1.21.10, 1.21.11. 1 required dependency.",
  },
  {
    name: "Loot Integrations: Dungeons and Taverns",
    category: "World",
    contentType: "Mods",
    projectId: 1139414,
    fileId: 7915316,
    fileName: "lootintegrations_dnt-2.5.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations-dungeons-and-taverns",
    downloadUrl: "https://edge.forgecdn.net/files/7915/316/lootintegrations_dnt-2.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1116/513/256/256/638671070829837728.png",
    fileDate: "2026-04-12T12:19:49.15Z",
    fileSizeBytes: 7633,
    gameVersions: ["1.21","Fabric","1.21.8","1.21.5","1.21.4","1.20.1","Forge","1.21.1","1.21.6","1.21.7","1.18.2","1.19.2","NeoForge","Server","1.21.10","1.21.11","26.1","26.1.1","26.1.2"],
    dependencyCount: 1,
    sha1: "77ee7e3e7611f7506c564dd598a98fa86903a1fe",
    md5: "fe8b483e5d85ea52c0918e08d442b0aa",
    blurb: "Mod by someaddon. Installed file: lootintegrations_dnt-2.5.jar. Game versions: 1.21, Fabric, 1.21.8, 1.21.5, 1.21.4, 1.20.1, Forge, 1.21.1, 1.21.6, 1.21.7, 1.18.2, 1.19.2, NeoForge, Server, 1.21.10, 1.21.11, 26.1, 26.1.1, 26.1.2. 1 required dependency.",
  },
  {
    name: "Loot Integrations: Ice and Fire",
    category: "QoL",
    contentType: "Mods",
    projectId: 1272782,
    fileId: 7920079,
    fileName: "lootintegrations_iceandfire-1.2.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations-ice-and-fire",
    downloadUrl: "https://edge.forgecdn.net/files/7920/79/lootintegrations_iceandfire-1.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1287/481/256/256/638837187159850577.png",
    fileDate: "2026-04-13T09:22:36.223Z",
    fileSizeBytes: 4763,
    gameVersions: ["1.21","Fabric","1.20.1","Forge","1.21.1","1.18.2","1.19.2","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "4760d3dfbe2bd81edb55c7745a1332db1eeaf849",
    md5: "c99add4e56ba9f429d2173b75ff7334e",
    blurb: "Mod by someaddon. Installed file: lootintegrations_iceandfire-1.2.jar. Game versions: 1.21, Fabric, 1.20.1, Forge, 1.21.1, 1.18.2, 1.19.2, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Loot Integrations: Integrated Dungeons, Villages & Strongholds & Cataclysm",
    category: "World",
    contentType: "Mods",
    projectId: 1149272,
    fileId: 7920258,
    fileName: "lootintegrations_integrated-1.5.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations-integrated-dungeons-villages",
    downloadUrl: "https://edge.forgecdn.net/files/7920/258/lootintegrations_integrated-1.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1126/239/256/256/638683941791600422.png",
    fileDate: "2026-04-13T10:32:39.94Z",
    fileSizeBytes: 7789,
    gameVersions: ["Fabric","1.20.1","Forge","1.21.1","1.18.2","1.19.2","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "12c262276385db1dc3188fbcb1aedff15550208b",
    md5: "467d62a29712ea5a97d7f500c6a7203b",
    blurb: "Mod by someaddon. Installed file: lootintegrations_integrated-1.5.jar. Game versions: Fabric, 1.20.1, Forge, 1.21.1, 1.18.2, 1.19.2, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Loot Integrations: When Dungeons Arise & Co",
    category: "World",
    contentType: "Mods",
    projectId: 1142880,
    fileId: 7925521,
    fileName: "lootintegration_wda-1.8.jar",
    author: "someaddon",
    url: "https://www.curseforge.com/minecraft/mc-mods/loot-integrations-when-dungeons-arise",
    downloadUrl: "https://edge.forgecdn.net/files/7925/521/lootintegration_wda-1.8.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1119/904/256/256/638674492936581599.png",
    fileDate: "2026-04-14T12:23:03.383Z",
    fileSizeBytes: 8134,
    gameVersions: ["Fabric","1.21.8","1.21.5","1.21.4","1.20.1","Forge","1.21.1","1.21.6","1.21.7","1.18.2","1.19.2","NeoForge","Server","1.21.10","1.21.11","26.1","26.1.1","26.1.2"],
    dependencyCount: 1,
    sha1: "d5b8cd7712e9c6db2202b77e3ce3c115640b8395",
    md5: "8396f2f642abcf501dd86bb221b5828f",
    blurb: "Mod by someaddon. Installed file: lootintegration_wda-1.8.jar. Game versions: Fabric, 1.21.8, 1.21.5, 1.21.4, 1.20.1, Forge, 1.21.1, 1.21.6, 1.21.7, 1.18.2, 1.19.2, NeoForge, Server, 1.21.10, 1.21.11, 26.1, 26.1.1, 26.1.2. 1 required dependency.",
  },
  {
    name: "LootJS: KubeJS Addon",
    category: "QoL",
    contentType: "Mods",
    projectId: 570630,
    fileId: 8009262,
    fileName: "lootjs-neoforge-1.21.1-3.7.0.jar",
    author: "Lytho",
    url: "https://www.curseforge.com/minecraft/mc-mods/lootjs",
    downloadUrl: "https://edge.forgecdn.net/files/8009/262/lootjs-neoforge-1.21.1-3.7.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/510/924/256/256/637828637727949352.png",
    fileDate: "2026-04-29T10:52:53.33Z",
    fileSizeBytes: 247689,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "54ffddd1763ae4af84e9bbcb22e4081a1e7f3556",
    md5: "21d3eda21b53344dd1f34759b4428634",
    blurb: "Mod by Lytho. Installed file: lootjs-neoforge-1.21.1-3.7.0.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Lootr (Forge & NeoForge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 361276,
    fileId: 8041234,
    fileName: "lootr-neoforge-1.21.1-1.11.37.120.jar",
    author: "Noobanidus",
    url: "https://www.curseforge.com/minecraft/mc-mods/lootr",
    downloadUrl: "https://edge.forgecdn.net/files/8041/234/lootr-neoforge-1.21.1-1.11.37.120.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1131/830/256/256/638691606432990450.png",
    fileDate: "2026-05-05T02:13:59Z",
    fileSizeBytes: 976023,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "a8acaf64fb3991526bfe7456189ccde247334265",
    md5: "c854cb36df6947d1a8bc222fec365359",
    blurb: "Mod by Noobanidus. Installed file: lootr-neoforge-1.21.1-1.11.37.120.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "LxRanks",
    category: "QoL",
    contentType: "Mods",
    projectId: 1539200,
    fileId: 8232111,
    fileName: "ranks-1.21.1-1.6.0.jar",
    author: "lxroma",
    url: "https://www.curseforge.com/minecraft/mc-mods/lxranks",
    downloadUrl: "https://edge.forgecdn.net/files/8232/111/ranks-1.21.1-1.6.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1800/854/256/256/639140083144898192.png",
    fileDate: "2026-06-11T15:07:59.25Z",
    fileSizeBytes: 65037,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "6befbb4caba9306ca1b4ca5ece23c60b3ae8f8a7",
    md5: "9c925e26d625d36073a0291a0c28713f",
    blurb: "Mod by lxroma. Installed file: ranks-1.21.1-1.6.0.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Macaw's Bridges",
    category: "QoL",
    contentType: "Mods",
    projectId: 351725,
    fileId: 7627896,
    fileName: "mcw-bridges-3.1.2-mc1.21.1neoforge.jar",
    author: "sketch_macaw",
    url: "https://www.curseforge.com/minecraft/mc-mods/macaws-bridges",
    downloadUrl: "https://edge.forgecdn.net/files/7627/896/mcw-bridges-3.1.2-mc1.21.1neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/237/234/256/256/637098539787193844.jpeg",
    fileDate: "2026-02-15T10:39:03.043Z",
    fileSizeBytes: 661387,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "71ece28129789a2123cf07e79938f488d8675bb2",
    md5: "d234155911dfd171acdd0b3b7f330448",
    blurb: "Mod by sketch_macaw. Installed file: mcw-bridges-3.1.2-mc1.21.1neoforge.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Melody",
    category: "QoL",
    contentType: "Mods",
    projectId: 938643,
    fileId: 5453382,
    fileName: "melody_neoforge_1.0.10_MC_1.21.jar",
    author: "Keksuccino",
    url: "https://www.curseforge.com/minecraft/mc-mods/melody",
    downloadUrl: "https://edge.forgecdn.net/files/5453/382/melody_neoforge_1.0.10_MC_1.21.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1479/762/256/256/638961722002206873.png",
    fileDate: "2024-06-21T07:52:59.533Z",
    fileSizeBytes: 36096,
    gameVersions: ["1.21","1.21.4","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "e83052a92c4ca0016bcfe7f0207273983dc84698",
    md5: "875f4a68f2cd7ee2cc135904653c93d4",
    blurb: "Mod by Keksuccino. Installed file: melody_neoforge_1.0.10_MC_1.21.jar. Game versions: 1.21, 1.21.4, NeoForge, 1.21.1.",
  },
  {
    name: "MmmMmmMmmMmm (Target Dummy)",
    category: "QoL",
    contentType: "Mods",
    projectId: 225738,
    fileId: 7943676,
    fileName: "dummmmmmy-1.21-2.0.12-neoforge.jar",
    author: "MehVahdJukaar",
    url: "https://www.curseforge.com/minecraft/mc-mods/mmmmmmmmmmmm",
    downloadUrl: "https://edge.forgecdn.net/files/7943/676/dummmmmmy-1.21-2.0.12-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/727/100/256/256/638080208599452100.png",
    fileDate: "2026-04-18T06:28:16.637Z",
    fileSizeBytes: 219158,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "0e69c2a8e4e51df42e45b2d6deb3a855bdf8dce6",
    md5: "5fd21edd5c504cf9303fa4ed3efb6310",
    blurb: "Mod by MehVahdJukaar. Installed file: dummmmmmy-1.21-2.0.12-neoforge.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Mo' Bends [MODERN PORT]",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1438637,
    fileId: 7752164,
    fileName: "MoBends-neoforge-1.21.1-5.1.7.jar",
    author: "ThatSoulyGuy",
    url: "https://www.curseforge.com/minecraft/mc-mods/mo-bends-unofficial-modern-port",
    downloadUrl: "https://edge.forgecdn.net/files/7752/164/MoBends-neoforge-1.21.1-5.1.7.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1630/983/256/256/639045482953119118.png",
    fileDate: "2026-03-13T17:39:52.767Z",
    fileSizeBytes: 1057598,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "0b8934f9365ad27e87d5fe6237721ba42718971a",
    md5: "b067d816871e7d3539b36728c3a241e4",
    blurb: "Mod by ThatSoulyGuy. Installed file: MoBends-neoforge-1.21.1-5.1.7.jar. Game versions: Client, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Moonlight Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 499980,
    fileId: 8215787,
    fileName: "moonlight-neoforge-1.21.1-3.0.17.jar",
    author: "MehVahdJukaar",
    url: "https://www.curseforge.com/minecraft/mc-mods/selene",
    downloadUrl: "https://edge.forgecdn.net/files/8215/787/moonlight-neoforge-1.21.1-3.0.17.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/402/662/256/256/637610797055895331.png",
    fileDate: "2026-06-08T11:22:21.493Z",
    fileSizeBytes: 1589156,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "fb9ff01231bc99aee1769b06a4b2987e6a6a518b",
    md5: "b26dd85935091adfcc4397042f4090f6",
    blurb: "Mod by MehVahdJukaar. Installed file: moonlight-neoforge-1.21.1-3.0.17.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "More Armor + | New Armors, Tools & Ores",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1431856,
    fileId: 8140240,
    fileName: "more_armor-1.0.5-neoforge-1.21.1.jar",
    author: "DoctorPhil2020",
    url: "https://www.curseforge.com/minecraft/mc-mods/more-armor-new-armors-tools-ores",
    downloadUrl: "https://edge.forgecdn.net/files/8140/240/more_armor-1.0.5-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1617/755/256/256/639041797455268725.png",
    fileDate: "2026-05-24T21:21:15.303Z",
    fileSizeBytes: 912724,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "066630a51dcd0b407ef7fb3405d618a98427a645",
    md5: "92064fffb4a07d9b21321c5c6715abd5",
    blurb: "Mod by DoctorPhil2020. Installed file: more_armor-1.0.5-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Mouse Tweaks",
    category: "QoL",
    contentType: "Mods",
    projectId: 60089,
    fileId: 5637846,
    fileName: "MouseTweaks-neoforge-mc1.21-2.26.1.jar",
    author: "YaLTeR",
    url: "https://www.curseforge.com/minecraft/mc-mods/mouse-tweaks",
    downloadUrl: "https://edge.forgecdn.net/files/5637/846/MouseTweaks-neoforge-mc1.21-2.26.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/467/691/256/256/637749969243449870.png",
    fileDate: "2024-08-17T15:55:16.403Z",
    fileSizeBytes: 73938,
    gameVersions: ["1.21","Client","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "6dae57f4f50f7808d2ed9a18f6cd1c0d4640c6bc",
    md5: "4ab6e808a59fdebecfbc92438b85b470",
    blurb: "Mod by YaLTeR. Installed file: MouseTweaks-neoforge-mc1.21-2.26.1.jar. Game versions: 1.21, Client, NeoForge, 1.21.1.",
  },
  {
    name: "Mowzie's Mobs",
    category: "Adventure",
    contentType: "Mods",
    projectId: 250498,
    fileId: 7760267,
    fileName: "mowziesmobs-1.21.1-1.8.2.jar",
    author: "bobmowzie",
    url: "https://www.curseforge.com/minecraft/mc-mods/mowzies-mobs",
    downloadUrl: "https://edge.forgecdn.net/files/7760/267/mowziesmobs-1.21.1-1.8.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/156/392/256/256/636639048661099951.png",
    fileDate: "2026-03-15T06:51:14.98Z",
    fileSizeBytes: 36042925,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "d64475cd77444b056ece6472c79d40293dc63c6c",
    md5: "5ca87731e5c0b4834a4a2e9a435a5cac",
    blurb: "Mod by bobmowzie. Installed file: mowziesmobs-1.21.1-1.8.2.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Naturalist",
    category: "QoL",
    contentType: "Mods",
    projectId: 627986,
    fileId: 8007879,
    fileName: "naturalist-1.0.2-neoforge-1.21.1.jar",
    author: "crispytwig",
    url: "https://www.curseforge.com/minecraft/mc-mods/naturalist",
    downloadUrl: "https://edge.forgecdn.net/files/8007/879/naturalist-1.0.2-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1198/547/256/256/638774805203022090.png",
    fileDate: "2026-04-29T01:27:04.597Z",
    fileSizeBytes: 5028168,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "d026c2c4ac66a9bc656e9b894683d1131054a80a",
    md5: "a8688bc45cb6bc02143e1652177ef60a",
    blurb: "Mod by crispytwig. Installed file: naturalist-1.0.2-neoforge-1.21.1.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Necronomicon API",
    category: "Library",
    contentType: "Mods",
    projectId: 586157,
    fileId: 5772683,
    fileName: "Necronomicon-NeoForge-1.6.0+1.21.jar",
    author: "ElocinDev",
    url: "https://www.curseforge.com/minecraft/mc-mods/necronomicon",
    downloadUrl: "https://edge.forgecdn.net/files/5772/683/Necronomicon-NeoForge-1.6.0%2b1.21.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/888/890/256/256/638327969824913874.png",
    fileDate: "2024-10-01T04:10:16.667Z",
    fileSizeBytes: 29865,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "4d81055810e07a94b68d16ab20ec298ad0d597a0",
    md5: "6250002ee6b5583f7db70564ecdd9fbe",
    blurb: "Mod by ElocinDev. Installed file: Necronomicon-NeoForge-1.6.0+1.21.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Nether Skeletons",
    category: "QoL",
    contentType: "Mods",
    projectId: 460954,
    fileId: 7904315,
    fileName: "netherskeletons-5.1-neoforge-1.21.1.jar",
    author: "GlitchedMastery",
    url: "https://www.curseforge.com/minecraft/mc-mods/nether-skeletons",
    downloadUrl: "https://edge.forgecdn.net/files/7904/315/netherskeletons-5.1-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/359/192/256/256/637521139057793093.png",
    fileDate: "2026-04-10T12:00:10.2Z",
    fileSizeBytes: 276471,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "6b9f96503f3713519101a1a5438ed571c1337437",
    md5: "83a5e5d3176e4b22972c8a5da4d55662",
    blurb: "Mod by GlitchedMastery. Installed file: netherskeletons-5.1-neoforge-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Nether Trials & Chambers",
    category: "QoL",
    contentType: "Mods",
    projectId: 1414295,
    fileId: 7445277,
    fileName: "HellishTrials-neoforge-1.0.5.jar",
    author: "Aureljz",
    url: "https://www.curseforge.com/minecraft/mc-mods/hellish-trials",
    downloadUrl: "https://edge.forgecdn.net/files/7445/277/HellishTrials-neoforge-1.0.5.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1583/263/256/256/639024893199070565.png",
    fileDate: "2026-01-11T07:18:19.967Z",
    fileSizeBytes: 581988,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "0c03bf04e99b3e8a310c9f5b6f3e7613e3b69528",
    md5: "5932b90300f103bb2d891da002126a69",
    blurb: "Mod by Aureljz. Installed file: HellishTrials-neoforge-1.0.5.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Nether Zombies",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1056462,
    fileId: 5937090,
    fileName: "nether_zombies-1.0-neoforge-1.21.1.jar",
    author: "GlitchedMastery",
    url: "https://www.curseforge.com/minecraft/mc-mods/nether-zombies",
    downloadUrl: "https://edge.forgecdn.net/files/5937/90/nether_zombies-1.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1032/739/256/256/638556015463538152.png",
    fileDate: "2024-11-25T19:41:30.927Z",
    fileSizeBytes: 126084,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "8f7b68ecc138805f9630b12629b19f5eb1583915",
    md5: "52650295e9ca10422f90c01566d28048",
    blurb: "Mod by GlitchedMastery. Installed file: nether_zombies-1.0-neoforge-1.21.1.jar. Game versions: Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "NeuroLib",
    category: "Library",
    contentType: "Mods",
    projectId: 1484243,
    fileId: 8060559,
    fileName: "neurolib-0.3.3-1.21.1.jar",
    author: "vomiter",
    url: "https://www.curseforge.com/minecraft/mc-mods/neurolib",
    downloadUrl: "https://edge.forgecdn.net/files/8060/559/neurolib-0.3.3-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1713/654/256/256/639089391462026440.png",
    fileDate: "2026-05-09T00:32:27.173Z",
    fileSizeBytes: 97871,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "f7da6f42e82851d9e7b7f48b112c152a92653749",
    md5: "2aa2d22848ffed17bb02e218c983aeea",
    blurb: "Mod by vomiter. Installed file: neurolib-0.3.3-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Nyf's Spiders",
    category: "QoL",
    contentType: "Mods",
    projectId: 686058,
    fileId: 7445048,
    fileName: "nyfsspiders-neoforge-1.21.1-3.0.1.jar",
    author: "Nyfaria",
    url: "https://www.curseforge.com/minecraft/mc-mods/nyfs-spiders",
    downloadUrl: "https://edge.forgecdn.net/files/7445/48/nyfsspiders-neoforge-1.21.1-3.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/618/872/256/256/638005062440412823.png",
    fileDate: "2026-01-11T05:19:32.35Z",
    fileSizeBytes: 186620,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "97a3b90f3566b4870c395a463f04961e2a6fa383",
    md5: "f84362d5dae111fca715802b0db37904",
    blurb: "Mod by Nyfaria. Installed file: nyfsspiders-neoforge-1.21.1-3.0.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "oωo (owo-lib)",
    category: "Library",
    contentType: "Mods",
    projectId: 532610,
    fileId: 6785734,
    fileName: "owo-lib-neoforge-0.12.15.5-beta.1+1.21.jar",
    author: "gliscowo",
    url: "https://www.curseforge.com/minecraft/mc-mods/owo-lib",
    downloadUrl: "https://edge.forgecdn.net/files/6785/734/owo-lib-neoforge-0.12.15.5-beta.1%2b1.21.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/439/260/256/256/637686200233061049.png",
    fileDate: "2025-07-19T00:45:21.91Z",
    fileSizeBytes: 1221583,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "48dda11a6710591cf162bdbedf982ea21dd1f2ed",
    md5: "4c8323c3d0493f7e82a2287e5ca9df7f",
    blurb: "Mod by gliscowo. Installed file: owo-lib-neoforge-0.12.15.5-beta.1+1.21.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Paladins & Priests (RPG Series)",
    category: "QoL",
    contentType: "Mods",
    projectId: 856548,
    fileId: 7742914,
    fileName: "paladins-neoforge-2.7.1+1.21.1.jar",
    author: "daedelus_dev",
    url: "https://www.curseforge.com/minecraft/mc-mods/paladins-and-priests",
    downloadUrl: "https://edge.forgecdn.net/files/7742/914/paladins-neoforge-2.7.1%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/811/802/256/256/638184759029816524.png",
    fileDate: "2026-03-11T14:25:48.937Z",
    fileSizeBytes: 2474189,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 6,
    sha1: "321898839cfcec923c543092c706ccdd3dec0a43",
    md5: "b719fb73cb97f28f182ec64c328fcbdc",
    blurb: "Mod by daedelus_dev. Installed file: paladins-neoforge-2.7.1+1.21.1.jar. Game versions: 1.21.1, NeoForge. 6 required dependencies.",
  },
  {
    name: "Panda's Falling Trees",
    category: "World",
    contentType: "Mods",
    projectId: 880630,
    fileId: 7858908,
    fileName: "fallingtrees-neoforge-1.21.1-0.14.0.jar",
    author: "ThePandaOliver",
    url: "https://www.curseforge.com/minecraft/mc-mods/pandas-falling-trees",
    downloadUrl: "https://edge.forgecdn.net/files/7858/908/fallingtrees-neoforge-1.21.1-0.14.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/843/222/256/256/638239257809194368.png",
    fileDate: "2026-04-01T23:36:13.4Z",
    fileSizeBytes: 4086627,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "070260f182d10bdc23de5e8e9297bec0231e2bec",
    md5: "5b592154394a7c33bde33cc0d46c18ae",
    blurb: "Mod by ThePandaOliver. Installed file: fallingtrees-neoforge-1.21.1-0.14.0.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "PandaLib",
    category: "Library",
    contentType: "Mods",
    projectId: 975460,
    fileId: 7858822,
    fileName: "pandalib-neoforge-1.21.1-0.6.0.jar",
    author: "ThePandaOliver",
    url: "https://www.curseforge.com/minecraft/mc-mods/pandalib",
    downloadUrl: "https://edge.forgecdn.net/files/7858/822/pandalib-neoforge-1.21.1-0.6.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/949/39/256/256/638436860735539267.png",
    fileDate: "2026-04-01T23:19:34.797Z",
    fileSizeBytes: 7903071,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "af13ba0a3e417e4218a57c835d184ad5c331c1c2",
    md5: "fee7f055bb0d20f8eb1cff4fc2dfd4c5",
    blurb: "Mod by ThePandaOliver. Installed file: pandalib-neoforge-1.21.1-0.6.0.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Patchouli",
    category: "QoL",
    contentType: "Mods",
    projectId: 306770,
    fileId: 7730942,
    fileName: "Patchouli-1.21.1-93-NEOFORGE.jar",
    author: "Vazkii",
    url: "https://www.curseforge.com/minecraft/mc-mods/patchouli",
    downloadUrl: "https://edge.forgecdn.net/files/7730/942/Patchouli-1.21.1-93-NEOFORGE.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/588/685/256/256/637958998949519797.png",
    fileDate: "2026-03-08T20:49:54.427Z",
    fileSizeBytes: 646777,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "5413bb9b8fc35ebe46b06b48bf9afafbd8471140",
    md5: "8178d65cd07dd7a646446729058ae2bf",
    blurb: "Mod by Vazkii. Installed file: Patchouli-1.21.1-93-NEOFORGE.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Piglin Proliferation",
    category: "QoL",
    contentType: "Mods",
    projectId: 657831,
    fileId: 8065411,
    fileName: "piglinproliferation-1.21.1-2.0.14.jar",
    author: "almightytallestred",
    url: "https://www.curseforge.com/minecraft/mc-mods/piglin-proliferation",
    downloadUrl: "https://edge.forgecdn.net/files/8065/411/piglinproliferation-1.21.1-2.0.14.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/993/246/256/256/638507996392134042.png",
    fileDate: "2026-05-09T21:57:07.77Z",
    fileSizeBytes: 2504236,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "8424ec300698507743abc6a6067a3fbde68b6a97",
    md5: "8ca5a0c904097a6a3220ee544defd4b2",
    blurb: "Mod by almightytallestred. Installed file: piglinproliferation-1.21.1-2.0.14.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Pillager Caravans",
    category: "QoL",
    contentType: "Mods",
    projectId: 1356772,
    fileId: 8241460,
    fileName: "caravans-neoforge-1.21.1-3.0.0.jar",
    author: "Obscuria",
    url: "https://www.curseforge.com/minecraft/mc-mods/pillager-caravans",
    downloadUrl: "https://edge.forgecdn.net/files/8241/460/caravans-neoforge-1.21.1-3.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/1811/439/639145563920660916.webp",
    fileDate: "2026-06-13T11:05:19.493Z",
    fileSizeBytes: 322676,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "0db482feb4a08c8b532b6dd56594b7925b0b065b",
    md5: "df366be6cb4296cbde44e1dab18dbb40",
    blurb: "Mod by Obscuria. Installed file: caravans-neoforge-1.21.1-3.0.0.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Placeable Items",
    category: "QoL",
    contentType: "Mods",
    projectId: 227951,
    fileId: 7279167,
    fileName: "placeableitems-4.8.3.jar",
    author: "Ferdz_",
    url: "https://www.curseforge.com/minecraft/mc-mods/placeable-items",
    downloadUrl: "https://edge.forgecdn.net/files/7279/167/placeableitems-4.8.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/479/888/256/256/637777842784643659.png",
    fileDate: "2025-11-30T18:49:47.163Z",
    fileSizeBytes: 538400,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "cd6f34c214e0771cf2d5a45aec0b90ca98d821d7",
    md5: "0f5c1b93f4db3d8208587bfb4878107a",
    blurb: "Mod by Ferdz_. Installed file: placeableitems-4.8.3.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Placebo",
    category: "QoL",
    contentType: "Mods",
    projectId: 283644,
    fileId: 6926281,
    fileName: "Placebo-1.21.1-9.9.1.jar",
    author: "Shadows_of_Fire",
    url: "https://www.curseforge.com/minecraft/mc-mods/placebo",
    downloadUrl: "https://edge.forgecdn.net/files/6926/281/Placebo-1.21.1-9.9.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/134/260/256/256/636490526725752670.png",
    fileDate: "2025-08-25T10:59:44.943Z",
    fileSizeBytes: 324056,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "1c2b8c38066d6f36209c5dadee25c184ef65202e",
    md5: "cc725fc5406d3af893484cfbba06f6ed",
    blurb: "Mod by Shadows_of_Fire. Installed file: Placebo-1.21.1-9.9.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Platform",
    category: "QoL",
    contentType: "Mods",
    projectId: 997634,
    fileId: 8075942,
    fileName: "Platform-neoforge-1.21.1-1.3.3.jar",
    author: "BlackGear",
    url: "https://www.curseforge.com/minecraft/mc-mods/platform",
    downloadUrl: "https://edge.forgecdn.net/files/8075/942/Platform-neoforge-1.21.1-1.3.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/980/992/256/256/638487478844304640.png",
    fileDate: "2026-05-12T01:08:22.633Z",
    fileSizeBytes: 489341,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "4132ad6809008698b7f489a878e5a33a3879bbfd",
    md5: "e20292cd105330fffaa36c65adfc4dcd",
    blurb: "Mod by BlackGear. Installed file: Platform-neoforge-1.21.1-1.3.3.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Player Trade - Secure Trading Between Players",
    category: "QoL",
    contentType: "Mods",
    projectId: 499619,
    fileId: 6844959,
    fileName: "playertrade-1.21.1-b.jar",
    author: "Zetal",
    url: "https://www.curseforge.com/minecraft/mc-mods/player-trade",
    downloadUrl: "https://edge.forgecdn.net/files/6844/959/playertrade-1.21.1-b.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/401/267/256/256/637607292283319469.png",
    fileDate: "2025-08-03T23:37:46.567Z",
    fileSizeBytes: 39908,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "d3449baf15a7699e4dbc69d7e444107608e32edd",
    md5: "e6eeadbd12acc0547e48c46804c9972c",
    blurb: "Mod by Zetal. Installed file: playertrade-1.21.1-b.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "playerAnimator",
    category: "Library",
    contentType: "Mods",
    projectId: 658587,
    fileId: 7389814,
    fileName: "player-animation-lib-forge-2.0.4+1.21.1.jar",
    author: "KosmX",
    url: "https://www.curseforge.com/minecraft/mc-mods/playeranimator",
    downloadUrl: "https://edge.forgecdn.net/files/7389/814/player-animation-lib-forge-2.0.4%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/588/418/256/256/637958435315527412.png",
    fileDate: "2025-12-28T21:00:20.25Z",
    fileSizeBytes: 203149,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "05be8ddcc78532b9a5520c718edc6c971cd0057c",
    md5: "ecb81c9479605db12a77bea774b88406",
    blurb: "Mod by KosmX. Installed file: player-animation-lib-forge-2.0.4+1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Pollution of the Realms",
    category: "QoL",
    contentType: "Mods",
    projectId: 269973,
    fileId: 8032528,
    fileName: "AdPother-1.21.1-9.1.7.1-NeoForge-build.0821.jar",
    author: "EnderLanky",
    url: "https://www.curseforge.com/minecraft/mc-mods/pollution-of-the-realms",
    downloadUrl: "https://edge.forgecdn.net/files/8032/528/AdPother-1.21.1-9.1.7.1-NeoForge-build.0821.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/152/474/256/256/636611875317714366.jpeg",
    fileDate: "2026-05-03T14:12:42.993Z",
    fileSizeBytes: 856233,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 26,
    sha1: "7310a59651cd518506473c04e0599fb2f21536a3",
    md5: "0e7bc2aff8c9e91614a5af5f37be6b53",
    blurb: "Mod by EnderLanky. Installed file: AdPother-1.21.1-9.1.7.1-NeoForge-build.0821.jar. Game versions: Client, 1.21.1, NeoForge, Server. 26 required dependencies.",
  },
  {
    name: "Puzzles Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 495476,
    fileId: 8168234,
    fileName: "PuzzlesLib-v21.1.51-1.21.1-NeoForge.jar",
    author: "Fuzs",
    url: "https://www.curseforge.com/minecraft/mc-mods/puzzles-lib",
    downloadUrl: "https://edge.forgecdn.net/files/8168/234/PuzzlesLib-v21.1.51-1.21.1-NeoForge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/776/232/256/256/638118144989284933.png",
    fileDate: "2026-05-30T07:23:45.847Z",
    fileSizeBytes: 1425185,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "035de52d3eb18ceeca4e4e63516af873c0975060",
    md5: "df7794a4853550b30cc451e99cc9ad19",
    blurb: "Mod by Fuzs. Installed file: PuzzlesLib-v21.1.51-1.21.1-NeoForge.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Reskillable Reimagined",
    category: "QoL",
    contentType: "Mods",
    projectId: 1170464,
    fileId: 7982937,
    fileName: "reskillable-3.3.0-1.21.1.jar",
    author: "Bandit_Bytes",
    url: "https://www.curseforge.com/minecraft/mc-mods/reskillable-reimagined",
    downloadUrl: "https://edge.forgecdn.net/files/7982/937/reskillable-3.3.0-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1147/609/256/256/638714388017274915.png",
    fileDate: "2026-04-25T14:47:31.193Z",
    fileSizeBytes: 251279,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "1a86a07bd1445e6a29dc6c2706152d01efd7ec43",
    md5: "ae06307d2a38460e7eeae293d2f4fdcd",
    blurb: "Mod by Bandit_Bytes. Installed file: reskillable-3.3.0-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Resourceful Lib",
    category: "Library",
    contentType: "Mods",
    projectId: 570073,
    fileId: 5973188,
    fileName: "resourcefullib-neoforge-1.21-3.0.12.jar",
    author: "ThatGravyBoat",
    url: "https://www.curseforge.com/minecraft/mc-mods/resourceful-lib",
    downloadUrl: "https://edge.forgecdn.net/files/5973/188/resourcefullib-neoforge-1.21-3.0.12.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/595/433/256/256/637970304404281534.png",
    fileDate: "2024-12-08T04:44:11.193Z",
    fileSizeBytes: 484332,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "24389c8e48ff0e8594e4686b750c494c66a5f8df",
    md5: "32da88903167d24bb20febeeb2c79225",
    blurb: "Mod by ThatGravyBoat. Installed file: resourcefullib-neoforge-1.21-3.0.12.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Responsive Shields",
    category: "QoL",
    contentType: "Mods",
    projectId: 557556,
    fileId: 5591264,
    fileName: "responsiveshields-2.4-neoforge-mc1.21.x.jar",
    author: "Revvilo",
    url: "https://www.curseforge.com/minecraft/mc-mods/responsive-shields",
    downloadUrl: "https://edge.forgecdn.net/files/5591/264/responsiveshields-2.4-neoforge-mc1.21.x.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/468/513/256/256/637752186474865485.jpeg",
    fileDate: "2024-08-03T00:47:30.327Z",
    fileSizeBytes: 64831,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 0,
    sha1: "88802fef082efe28a0dc3cc98be03adda27647e1",
    md5: "15a09bf2b4f793de2c73606797fdb7e9",
    blurb: "Mod by Revvilo. Installed file: responsiveshields-2.4-neoforge-mc1.21.x.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server.",
  },
  {
    name: "Rhino",
    category: "QoL",
    contentType: "Mods",
    projectId: 416294,
    fileId: 8218748,
    fileName: "rhino-2101.2.7-build.85.jar",
    author: "LatvianModder",
    url: "https://www.curseforge.com/minecraft/mc-mods/rhino",
    downloadUrl: "https://edge.forgecdn.net/files/8218/748/rhino-2101.2.7-build.85.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1053/155/256/256/638583713150199979.png",
    fileDate: "2026-06-08T22:08:39.857Z",
    fileSizeBytes: 882075,
    gameVersions: ["1.21","Fabric","1.21.4","Forge","1.21.1","1.21.3","NeoForge","1.21.2","26.1.2"],
    dependencyCount: 0,
    sha1: "370598a1d2321c8a705ce539eb970375f20150c3",
    md5: "f5df23fab1aef88b69f67776e0f79904",
    blurb: "Mod by LatvianModder. Installed file: rhino-2101.2.7-build.85.jar. Game versions: 1.21, Fabric, 1.21.4, Forge, 1.21.1, 1.21.3, NeoForge, 1.21.2, 26.1.2.",
  },
  {
    name: "Ritchie's Projectile Library",
    category: "Library",
    contentType: "Mods",
    projectId: 1279407,
    fileId: 7587771,
    fileName: "ritchiesprojectilelib-2.1.2-mc.1.21.1-neoforge.jar",
    author: "rbasamoyai",
    url: "https://www.curseforge.com/minecraft/mc-mods/ritchies-projectile-library",
    downloadUrl: "https://edge.forgecdn.net/files/7587/771/ritchiesprojectilelib-2.1.2-mc.1.21.1-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1300/796/256/256/638845530833208387.png",
    fileDate: "2026-02-07T05:45:34.217Z",
    fileSizeBytes: 76369,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "ec2e4996f8bee8714173e603e379fef8a6901765",
    md5: "1772f7d2ef79cdb3e77ff0335fe7f3f8",
    blurb: "Mod by rbasamoyai. Installed file: ritchiesprojectilelib-2.1.2-mc.1.21.1-neoforge.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "River Redux",
    category: "World",
    contentType: "Mods",
    projectId: 380548,
    fileId: 6983398,
    fileName: "riverredux-forge-0.4.0.jar",
    author: "Jasmine",
    url: "https://www.curseforge.com/minecraft/mc-mods/river-redux",
    downloadUrl: "https://edge.forgecdn.net/files/6983/398/riverredux-forge-0.4.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/269/36/256/256/637240495345086317.png",
    fileDate: "2025-09-10T15:46:55.63Z",
    fileSizeBytes: 53376,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "16f45009ba4458e39fe18d553d21957fededa090",
    md5: "31c80136628589f14fc843b593dffe53",
    blurb: "Mod by Jasmine. Installed file: riverredux-forge-0.4.0.jar. Game versions: Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "Rotten Creatures",
    category: "Adventure",
    contentType: "Mods",
    projectId: 371033,
    fileId: 6677062,
    fileName: "rottencreatures-neoforge-1.21.1-1.1.2.jar",
    author: "fusionstudiomc",
    url: "https://www.curseforge.com/minecraft/mc-mods/rotten-creatures",
    downloadUrl: "https://edge.forgecdn.net/files/6677/62/rottencreatures-neoforge-1.21.1-1.1.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/259/413/256/256/637211300896316007.jpeg",
    fileDate: "2025-06-21T01:46:14.977Z",
    fileSizeBytes: 2608616,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "c44de2c17018ffb8141ee68caaa4a71d979b96b2",
    md5: "8b07792ba873d523dd49e0b06e0f78ca",
    blurb: "Mod by fusionstudiomc. Installed file: rottencreatures-neoforge-1.21.1-1.1.2.jar. Game versions: Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "Runes",
    category: "QoL",
    contentType: "Mods",
    projectId: 775518,
    fileId: 7225381,
    fileName: "runes-neoforge-1.2.1+1.21.1.jar",
    author: "daedelus_dev",
    url: "https://www.curseforge.com/minecraft/mc-mods/rune-crafting",
    downloadUrl: "https://edge.forgecdn.net/files/7225/381/runes-neoforge-1.2.1%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/718/875/256/256/638074096126245621.png",
    fileDate: "2025-11-15T17:03:27.82Z",
    fileSizeBytes: 320254,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "c38b440097cc48f4ff7e0e783635a90d07c40974",
    md5: "6753d037de79850bc3feb00ddf4782f2",
    blurb: "Mod by daedelus_dev. Installed file: runes-neoforge-1.2.1+1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Sable",
    category: "QoL",
    contentType: "Mods",
    projectId: 1312371,
    fileId: 8242682,
    fileName: "sable-neoforge-1.21.1-2.0.1.jar",
    author: "ryanhcode",
    url: "https://www.curseforge.com/minecraft/mc-mods/sable",
    downloadUrl: "https://edge.forgecdn.net/files/8242/682/sable-neoforge-1.21.1-2.0.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1368/340/256/256/638888491505266312.png",
    fileDate: "2026-06-13T15:34:14.93Z",
    fileSizeBytes: 12888110,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 3,
    sha1: "1206068f3fba44d2df87509ddc3921b10379f8b5",
    md5: "44cdf70501481151cbb24f0ffb9cd691",
    blurb: "Mod by ryanhcode. Installed file: sable-neoforge-1.21.1-2.0.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 3 required dependencies.",
  },
  {
    name: "Searchables",
    category: "QoL",
    contentType: "Mods",
    projectId: 858542,
    fileId: 5831692,
    fileName: "Searchables-neoforge-1.21.1-1.0.2.jar",
    author: "Jaredlll08",
    url: "https://www.curseforge.com/minecraft/mc-mods/searchables",
    downloadUrl: "https://edge.forgecdn.net/files/5831/692/Searchables-neoforge-1.21.1-1.0.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/814/175/256/256/638189233295197018.png",
    fileDate: "2024-10-21T20:44:39.39Z",
    fileSizeBytes: 77326,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "5b8a0b43a474c066371b2e16f9bfb88622552a74",
    md5: "0a0a8665bb4d77e3f8139750cb98d9e4",
    blurb: "Mod by Jaredlll08. Installed file: Searchables-neoforge-1.21.1-1.0.2.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Server Perks",
    category: "QoL",
    contentType: "Mods",
    projectId: 1535777,
    fileId: 8049896,
    fileName: "cosmeticperks-1.0.0.jar",
    author: "kubenciusz1",
    url: "https://www.curseforge.com/minecraft/mc-mods/server-perks",
    downloadUrl: "https://edge.forgecdn.net/files/8049/896/cosmeticperks-1.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1794/839/256/256/639136975469628962.png",
    fileDate: "2026-05-06T20:53:01.03Z",
    fileSizeBytes: 37456,
    gameVersions: ["1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "fb1544cf90588fa25b45001bae71fa2021245f09",
    md5: "e57e82ba3126643ff1260e09e346c6bd",
    blurb: "Mod by kubenciusz1. Installed file: cosmeticperks-1.0.0.jar. Game versions: 1.21.1, NeoForge, Server.",
  },
  {
    name: "Shield API",
    category: "Library",
    contentType: "Mods",
    projectId: 1048720,
    fileId: 7156464,
    fileName: "shield_api-neoforge-2.2.0.jar",
    author: "TheRedBrain",
    url: "https://www.curseforge.com/minecraft/mc-mods/shield-api",
    downloadUrl: "https://edge.forgecdn.net/files/7156/464/shield_api-neoforge-2.2.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1026/250/256/256/638548606364133564.png",
    fileDate: "2025-10-27T15:39:32.277Z",
    fileSizeBytes: 45428,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "dfbb73a2a92bac5c06f6b0a747a6660a3e04ed0b",
    md5: "da46bf6501623b471f1109de9c089ba5",
    blurb: "Mod by TheRedBrain. Installed file: shield_api-neoforge-2.2.0.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Simple Flint Tools",
    category: "QoL",
    contentType: "Mods",
    projectId: 1132012,
    fileId: 5975823,
    fileName: "simple_flint_tools-1.1.0-neoforge-1.21.1.jar",
    author: "mooredesign13",
    url: "https://www.curseforge.com/minecraft/mc-mods/simple-flint-tools",
    downloadUrl: "https://edge.forgecdn.net/files/5975/823/simple_flint_tools-1.1.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1109/334/256/256/638660028802036492.jpg",
    fileDate: "2024-12-08T23:34:25.697Z",
    fileSizeBytes: 16615,
    gameVersions: ["Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "17b9e74cebc2e752078225ae9330177816cc7278",
    md5: "f6182ea4e1c554a5cdacbe1497836102",
    blurb: "Mod by mooredesign13. Installed file: simple_flint_tools-1.1.0-neoforge-1.21.1.jar. Game versions: Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "Simple Netherite Horse Armor",
    category: "Adventure",
    contentType: "Mods",
    projectId: 677675,
    fileId: 7022285,
    fileName: "netherite_horse_armor-neoforge-1.21.1-2.0a.jar",
    author: "JerryLu086",
    url: "https://www.curseforge.com/minecraft/mc-mods/simple-netherite-horse-armor",
    downloadUrl: "https://edge.forgecdn.net/files/7022/285/netherite_horse_armor-neoforge-1.21.1-2.0a.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1810/983/256/256/639145408208271237.png",
    fileDate: "2025-09-22T13:00:20.61Z",
    fileSizeBytes: 19602,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "0bd2749b22887192fb096ff5e83f96f0180893a8",
    md5: "3208bd7f3d37db6615438cac139f02e9",
    blurb: "Mod by JerryLu086. Installed file: netherite_horse_armor-neoforge-1.21.1-2.0a.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Simple Voice Chat",
    category: "QoL",
    contentType: "Mods",
    projectId: 416089,
    fileId: 8158511,
    fileName: "voicechat-neoforge-1.21.1-2.6.18.jar",
    author: "henkelmax",
    url: "https://www.curseforge.com/minecraft/mc-mods/simple-voice-chat",
    downloadUrl: "https://edge.forgecdn.net/files/8158/511/voicechat-neoforge-1.21.1-2.6.18.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/391/367/256/256/637584172062782791.png",
    fileDate: "2026-05-28T08:10:25.843Z",
    fileSizeBytes: 4902837,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "c9e638f5c049fc143dc043c585b13e9078a3f71d",
    md5: "b8560ea2d8f5c05a0d947dff55085d82",
    blurb: "Mod by henkelmax. Installed file: voicechat-neoforge-1.21.1-2.6.18.jar. Game versions: 1.21, 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "Simple Voice Radio",
    category: "QoL",
    contentType: "Mods",
    projectId: 820070,
    fileId: 8245161,
    fileName: "simpleradio-neoforge-1.21.1-4.4.7.9.jar",
    author: "CodinGlitch",
    url: "https://www.curseforge.com/minecraft/mc-mods/simple-voice-radio",
    downloadUrl: "https://edge.forgecdn.net/files/8245/161/simpleradio-neoforge-1.21.1-4.4.7.9.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1228/416/256/256/638805632556962162.png",
    fileDate: "2026-06-14T01:54:42.507Z",
    fileSizeBytes: 988623,
    gameVersions: ["1.21","Client","1.21.4","1.21.1","1.21.3","NeoForge","Server","1.21.2"],
    dependencyCount: 4,
    sha1: "8aaff4a20b2a7af3da6efff9f492d511b69a4e5b",
    md5: "f7c96ff9af17ada002eea5b655118c08",
    blurb: "Mod by CodinGlitch. Installed file: simpleradio-neoforge-1.21.1-4.4.7.9.jar. Game versions: 1.21, Client, 1.21.4, 1.21.1, 1.21.3, NeoForge, Server, 1.21.2. 4 required dependencies.",
  },
  {
    name: "Simply Light",
    category: "QoL",
    contentType: "Mods",
    projectId: 300331,
    fileId: 6219029,
    fileName: "simplylight-1.5.3+1.21.1-b4.jar",
    author: "Flanks255",
    url: "https://www.curseforge.com/minecraft/mc-mods/simply-light",
    downloadUrl: "https://edge.forgecdn.net/files/6219/29/simplylight-1.5.3%2b1.21.1-b4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/165/997/256/256/636695496359245657.png",
    fileDate: "2025-02-21T23:04:31.113Z",
    fileSizeBytes: 1103352,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "d85bfed3824cb66d258acf11c73edaf11d583223",
    md5: "b16de230f2d97bb791164277212091c5",
    blurb: "Mod by Flanks255. Installed file: simplylight-1.5.3+1.21.1-b4.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Smarter Farmers (farmers replant)",
    category: "QoL",
    contentType: "Mods",
    projectId: 491290,
    fileId: 7120722,
    fileName: "smarterfarmers-1.21-2.2.4-neoforge.jar",
    author: "MehVahdJukaar",
    url: "https://www.curseforge.com/minecraft/mc-mods/smarter-farmers-farmers-replant",
    downloadUrl: "https://edge.forgecdn.net/files/7120/722/smarterfarmers-1.21-2.2.4-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/428/322/256/256/637661339301860269.png",
    fileDate: "2025-10-18T13:10:34.497Z",
    fileSizeBytes: 65924,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "49e58b648cfe1e5d6623b1b2c3ce5aca0b8c08df",
    md5: "91f29b23db77eb67ef2366d05cc1cbd3",
    blurb: "Mod by MehVahdJukaar. Installed file: smarterfarmers-1.21-2.2.4-neoforge.jar. Game versions: 1.21, NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Sodium",
    category: "Performance",
    contentType: "Mods",
    projectId: 394468,
    fileId: 8242014,
    fileName: "sodium-neoforge-0.8.12-beta.1+mc1.21.1.jar",
    author: "JellySquid",
    url: "https://www.curseforge.com/minecraft/mc-mods/sodium",
    downloadUrl: "https://edge.forgecdn.net/files/8242/14/sodium-neoforge-0.8.12-beta.1%2bmc1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/284/773/256/256/637298471098686391.png",
    fileDate: "2026-06-13T13:24:45.527Z",
    fileSizeBytes: 1291422,
    gameVersions: ["Client","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "5f24c8cf07e40581210c020b54106e175f793e85",
    md5: "7034c36b4af79f8d73702a0bff7b90b3",
    blurb: "Mod by JellySquid. Installed file: sodium-neoforge-0.8.12-beta.1+mc1.21.1.jar. Game versions: Client, 1.21.1, NeoForge.",
  },
  {
    name: "Sophisticated Backpacks",
    category: "Tech",
    contentType: "Mods",
    projectId: 422301,
    fileId: 8249848,
    fileName: "sophisticatedbackpacks-1.21.1-3.25.63.1912.jar",
    author: "P3pp3rF1y",
    url: "https://www.curseforge.com/minecraft/mc-mods/sophisticated-backpacks",
    downloadUrl: "https://edge.forgecdn.net/files/8249/848/sophisticatedbackpacks-1.21.1-3.25.63.1912.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/375/56/256/256/637549610342642859.png",
    fileDate: "2026-06-14T22:32:05.14Z",
    fileSizeBytes: 1141190,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 8,
    sha1: "e7e8458e1bf2f52d457e0eb2efcd8c3194a653fa",
    md5: "bbd3be4ffa024d906c1d3e94531add6e",
    blurb: "Mod by P3pp3rF1y. Installed file: sophisticatedbackpacks-1.21.1-3.25.63.1912.jar. Game versions: 1.21.1, NeoForge. 8 required dependencies.",
  },
  {
    name: "Sophisticated Core",
    category: "Library",
    contentType: "Mods",
    projectId: 618298,
    fileId: 8249811,
    fileName: "sophisticatedcore-1.21.1-1.4.58.2026.jar",
    author: "P3pp3rF1y",
    url: "https://www.curseforge.com/minecraft/mc-mods/sophisticated-core",
    downloadUrl: "https://edge.forgecdn.net/files/8249/811/sophisticatedcore-1.21.1-1.4.58.2026.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/540/438/256/256/637866039314801108.png",
    fileDate: "2026-06-14T22:24:02.043Z",
    fileSizeBytes: 1648596,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "da2706b73728f935502a51752484c11117c06037",
    md5: "7ffdc233e9769bb4a4d0f281595665d0",
    blurb: "Mod by P3pp3rF1y. Installed file: sophisticatedcore-1.21.1-1.4.58.2026.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Sophisticated Storage",
    category: "Tech",
    contentType: "Mods",
    projectId: 619320,
    fileId: 8249877,
    fileName: "sophisticatedstorage-1.21.1-1.5.60.1851.jar",
    author: "P3pp3rF1y",
    url: "https://www.curseforge.com/minecraft/mc-mods/sophisticated-storage",
    downloadUrl: "https://edge.forgecdn.net/files/8249/877/sophisticatedstorage-1.21.1-1.5.60.1851.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/543/206/256/256/637872959580005837.png",
    fileDate: "2026-06-14T22:39:35.073Z",
    fileSizeBytes: 1716175,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 8,
    sha1: "f57483944090eb847d8e9af00f6dd4dae72dc276",
    md5: "e15ac83d2f3f0ecb651b5f71a67d51b4",
    blurb: "Mod by P3pp3rF1y. Installed file: sophisticatedstorage-1.21.1-1.5.60.1851.jar. Game versions: 1.21.1, NeoForge. 8 required dependencies.",
  },
  {
    name: "Sophisticated Storage in Motion",
    category: "Tech",
    contentType: "Mods",
    projectId: 1166930,
    fileId: 8220288,
    fileName: "sophisticatedstorageinmotion-1.21.1-0.10.30.276.jar",
    author: "P3pp3rF1y",
    url: "https://www.curseforge.com/minecraft/mc-mods/sophisticated-storage-in-motion",
    downloadUrl: "https://edge.forgecdn.net/files/8220/288/sophisticatedstorageinmotion-1.21.1-0.10.30.276.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1144/71/256/256/638709432241440364.png",
    fileDate: "2026-06-09T06:23:33.697Z",
    fileSizeBytes: 406631,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 3,
    sha1: "29ebd1dc14ff5a8a7e6286a18e4c6d06b18502d3",
    md5: "eacd0dfd96cfc2fb64a3af01ce203d40",
    blurb: "Mod by P3pp3rF1y. Installed file: sophisticatedstorageinmotion-1.21.1-0.10.30.276.jar. Game versions: 1.21.1, NeoForge. 3 required dependencies.",
  },
  {
    name: "Spawner Control",
    category: "QoL",
    contentType: "Mods",
    projectId: 1109365,
    fileId: 7314926,
    fileName: "SpawnerControl-NEOFORGE-1.21.[0-1]-v1.4.jar",
    author: "Dplayend",
    url: "https://www.curseforge.com/minecraft/mc-mods/spawner-control",
    downloadUrl: "https://edge.forgecdn.net/files/7314/926/SpawnerControl-NEOFORGE-1.21.%5b0-1%5d-v1.4.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1086/726/256/256/638628999754572621.jpeg",
    fileDate: "2025-12-10T07:14:36.66Z",
    fileSizeBytes: 20364,
    gameVersions: ["1.21","Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "6f26d1943f767038871bbdfc4e00e91f06309323",
    md5: "83bdef5509023bc2a110ae90b813db23",
    blurb: "Mod by Dplayend. Installed file: SpawnerControl-NEOFORGE-1.21.[0-1]-v1.4.jar. Game versions: 1.21, Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Spell Engine",
    category: "Magic",
    contentType: "Mods",
    projectId: 807653,
    fileId: 7789251,
    fileName: "spell_engine-neoforge-1.9.9+1.21.1.jar",
    author: "daedelus_dev",
    url: "https://www.curseforge.com/minecraft/mc-mods/spell-engine",
    downloadUrl: "https://edge.forgecdn.net/files/7789/251/spell_engine-neoforge-1.9.9%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/753/74/256/256/638091323857070135.png",
    fileDate: "2026-03-21T12:06:39.753Z",
    fileSizeBytes: 3785539,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 5,
    sha1: "0469717da1a4870641f70fdd19955fc97bb8ce97",
    md5: "05b150dd85bd37855300b0cdc7117d34",
    blurb: "Mod by daedelus_dev. Installed file: spell_engine-neoforge-1.9.9+1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 5 required dependencies.",
  },
  {
    name: "Spell Power Attributes",
    category: "Magic",
    contentType: "Mods",
    projectId: 771265,
    fileId: 7303957,
    fileName: "spell_power-neoforge-1.4.6+1.21.1.jar",
    author: "daedelus_dev",
    url: "https://www.curseforge.com/minecraft/mc-mods/spell-power",
    downloadUrl: "https://edge.forgecdn.net/files/7303/957/spell_power-neoforge-1.4.6%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/714/591/256/256/638073469671747453.png",
    fileDate: "2025-12-07T11:58:47.02Z",
    fileSizeBytes: 195485,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "2b8b01cffb2a5774b180b618630bd34cff2f9d54",
    md5: "de6c055cd7988903268762289439fb70",
    blurb: "Mod by daedelus_dev. Installed file: spell_power-neoforge-1.4.6+1.21.1.jar. Game versions: 1.21, 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Spoiled",
    category: "QoL",
    contentType: "Mods",
    projectId: 364918,
    fileId: 8011321,
    fileName: "Spoiled-neoforge-1.21.1-6.2.2.jar",
    author: "Mrbysco",
    url: "https://www.curseforge.com/minecraft/mc-mods/spoiled",
    downloadUrl: "https://edge.forgecdn.net/files/8011/321/Spoiled-neoforge-1.21.1-6.2.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/251/699/256/256/637185161092924064.png",
    fileDate: "2026-04-29T18:52:35.803Z",
    fileSizeBytes: 93760,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 5,
    sha1: "9d7985e401acb3f5669e0ed2590a07055e3e93a5",
    md5: "8fe187cb122e96de1c86bd601af13d30",
    blurb: "Mod by Mrbysco. Installed file: Spoiled-neoforge-1.21.1-6.2.2.jar. Game versions: Client, 1.21.1, NeoForge, Server. 5 required dependencies.",
  },
  {
    name: "StackablePotions [Forge]",
    category: "QoL",
    contentType: "Mods",
    projectId: 599436,
    fileId: 6771482,
    fileName: "Stackable Potions-neoforge-1.21.1-1.0.0.jar",
    author: "Cursed1nferno",
    url: "https://www.curseforge.com/minecraft/mc-mods/stackablepotions-forge",
    downloadUrl: "https://edge.forgecdn.net/files/6771/482/Stackable%20Potions-neoforge-1.21.1-1.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/519/43/256/256/637839649738448298.png",
    fileDate: "2025-07-15T11:55:33.433Z",
    fileSizeBytes: 7051,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "82b9a41b6b6c4395ee6bba68ed592c96de34456a",
    md5: "cb862877b83cf7916d666e03a39d16ba",
    blurb: "Mod by Cursed1nferno. Installed file: Stackable Potions-neoforge-1.21.1-1.0.0.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "Structure Pool API",
    category: "World",
    contentType: "Mods",
    projectId: 927915,
    fileId: 7145227,
    fileName: "structure_pool_api-neoforge-1.2.1+1.21.1.jar",
    author: "daedelus_dev",
    url: "https://www.curseforge.com/minecraft/mc-mods/structure-pool-api",
    downloadUrl: "https://edge.forgecdn.net/files/7145/227/structure_pool_api-neoforge-1.2.1%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/895/112/256/256/638339352039066360.png",
    fileDate: "2025-10-24T18:19:26.553Z",
    fileSizeBytes: 140459,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "5150191b29de8462705e5aa715c2554a5744dc7b",
    md5: "611a331200f31b9c971bad66c48c0fd6",
    blurb: "Mod by daedelus_dev. Installed file: structure_pool_api-neoforge-1.2.1+1.21.1.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "TerraBlender (NeoForge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 940057,
    fileId: 6054947,
    fileName: "TerraBlender-neoforge-1.21.1-4.1.0.8.jar",
    author: "TheAdubbz",
    url: "https://www.curseforge.com/minecraft/mc-mods/terrablender-neoforge",
    downloadUrl: "https://edge.forgecdn.net/files/6054/947/TerraBlender-neoforge-1.21.1-4.1.0.8.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/907/934/256/256/638359485944942119.png",
    fileDate: "2025-01-05T04:27:14.547Z",
    fileSizeBytes: 120364,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "2016eed89eac0eb0510d2190c3b0b80bf4346191",
    md5: "9510cef4ca24d7f6bc3144dbf6693f7d",
    blurb: "Mod by TheAdubbz. Installed file: TerraBlender-neoforge-1.21.1-4.1.0.8.jar. Game versions: NeoForge, 1.21.1.",
  },
  {
    name: "TerraFirmaCraft",
    category: "QoL",
    contentType: "Mods",
    projectId: 302973,
    fileId: 8249859,
    fileName: "TerraFirmaCraft-NeoForge-1.21.1-4.1.3.jar",
    author: "Dries007",
    url: "https://www.curseforge.com/minecraft/mc-mods/terrafirmacraft",
    downloadUrl: "https://edge.forgecdn.net/files/8249/859/TerraFirmaCraft-NeoForge-1.21.1-4.1.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/170/851/256/256/636725131874038399.png",
    fileDate: "2026-06-14T22:36:28.69Z",
    fileSizeBytes: 64695037,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 2,
    sha1: "02190d8024e07e66a983f958cd0e842660c93dc6",
    md5: "b6949e77121bfa44babdfaeca432312e",
    blurb: "Mod by Dries007. Installed file: TerraFirmaCraft-NeoForge-1.21.1-4.1.3.jar. Game versions: 1.21.1, NeoForge. 2 required dependencies.",
  },
  {
    name: "TFC Electric Fridge",
    category: "QoL",
    contentType: "Mods",
    projectId: 1564326,
    fileId: 8198674,
    fileName: "tfcfridge-1.1.1-1.21.1.jar",
    author: "Shebbn",
    url: "https://www.curseforge.com/minecraft/mc-mods/tfc-electric-fridge",
    downloadUrl: "https://edge.forgecdn.net/files/8198/674/tfcfridge-1.1.1-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1845/284/256/256/639161491611537537.png",
    fileDate: "2026-06-05T00:56:54.703Z",
    fileSizeBytes: 45919,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "f4a91606b000f6709b67d726b85fed9b295f1fcc",
    md5: "cd2ecaa73a63ae186ea8a3218d35fa00",
    blurb: "Mod by Shebbn. Installed file: tfcfridge-1.1.1-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "The Hordes",
    category: "Adventure",
    contentType: "Mods",
    projectId: 485779,
    fileId: 8143589,
    fileName: "The-Hordes-1.21.1-1.6.3c.jar",
    author: "smileycorp",
    url: "https://www.curseforge.com/minecraft/mc-mods/the-hordes",
    downloadUrl: "https://edge.forgecdn.net/files/8143/589/The-Hordes-1.21.1-1.6.3c.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1462/743/256/256/638949441421562925.png",
    fileDate: "2026-05-25T13:25:44.087Z",
    fileSizeBytes: 448653,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 3,
    sha1: "f579310dfb509e0b19382916a8f2b6d5fee75142",
    md5: "c3c80b4a354bf0cab532e9926bdad70a",
    blurb: "Mod by smileycorp. Installed file: The-Hordes-1.21.1-1.6.3c.jar. Game versions: Client, 1.21.1, NeoForge, Server. 3 required dependencies.",
  },
  {
    name: "The Twilight Forest",
    category: "QoL",
    contentType: "Mods",
    projectId: 227639,
    fileId: 7797302,
    fileName: "twilightforest-1.21.1-4.8.3345-universal.jar",
    author: "Benimatic",
    url: "https://www.curseforge.com/minecraft/mc-mods/the-twilight-forest",
    downloadUrl: "https://edge.forgecdn.net/files/7797/302/twilightforest-1.21.1-4.8.3345-universal.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/14/212/256/256/635589178760357568.png",
    fileDate: "2026-03-22T23:06:08.62Z",
    fileSizeBytes: 27154121,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "9cfd4154928433e2f1f6cfc3deb48c284debb580",
    md5: "c1e465c8b2855902368ff4679e1fc2e7",
    blurb: "Mod by Benimatic. Installed file: twilightforest-1.21.1-4.8.3345-universal.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Towns and Towers",
    category: "World",
    contentType: "Mods",
    projectId: 626761,
    fileId: 8130049,
    fileName: "t_and_t-neoforge-fabric-1.13.9+1.21.1.jar",
    author: "Biban_Auriu",
    url: "https://www.curseforge.com/minecraft/mc-mods/towns-and-towers",
    downloadUrl: "https://edge.forgecdn.net/files/8130/49/t_and_t-neoforge-fabric-1.13.9%2b1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/551/161/256/256/637888384577155054.png",
    fileDate: "2026-05-22T22:57:58.483Z",
    fileSizeBytes: 3597353,
    gameVersions: ["Client","Fabric","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "2390523f45dc5204e82cfb23ecf4f34dfcc25d1e",
    md5: "c3b46230060d91601503cf5b7ab6e4b7",
    blurb: "Mod by Biban_Auriu. Installed file: t_and_t-neoforge-fabric-1.13.9+1.21.1.jar. Game versions: Client, Fabric, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Undefeatables",
    category: "Adventure",
    contentType: "Mods",
    projectId: 417175,
    fileId: 7575423,
    fileName: "undefeatables-1.8.1.jar",
    author: "baranhan123",
    url: "https://www.curseforge.com/minecraft/mc-mods/the-undefeatables",
    downloadUrl: "https://edge.forgecdn.net/files/7575/423/undefeatables-1.8.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/310/566/256/256/637399275290178301.png",
    fileDate: "2026-02-04T14:48:46.073Z",
    fileSizeBytes: 268359,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "180e89c83c7ad2e975614bd356003d5e34a63b07",
    md5: "38ee6344df7ce649ef4e1ddc93358fef",
    blurb: "Mod by baranhan123. Installed file: undefeatables-1.8.1.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Untitled Duck Mod (Forge)",
    category: "QoL",
    contentType: "Mods",
    projectId: 451789,
    fileId: 7570039,
    fileName: "untitledduckmod-1.5.2-neoforge-1.21.1.jar",
    author: "Okabintaro",
    url: "https://www.curseforge.com/minecraft/mc-mods/untitled-duck-mod-forge",
    downloadUrl: "https://edge.forgecdn.net/files/7570/39/untitledduckmod-1.5.2-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/349/297/256/256/637501106278572747.png",
    fileDate: "2026-02-03T09:34:42.82Z",
    fileSizeBytes: 303088,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "afb5b127182ee1721bc7dc38db4fa379c071a778",
    md5: "5f6259b5e90e152c907bd5a04d55adcd",
    blurb: "Mod by Okabintaro. Installed file: untitledduckmod-1.5.2-neoforge-1.21.1.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Uranus",
    category: "QoL",
    contentType: "Mods",
    projectId: 1010827,
    fileId: 8008516,
    fileName: "uranus-2.4.1-1.21.1-neoforge.jar",
    author: "IAFEnvoy",
    url: "https://www.curseforge.com/minecraft/mc-mods/uranus",
    downloadUrl: "https://edge.forgecdn.net/files/8008/516/uranus-2.4.1-1.21.1-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/1640/733/639049163879705439.webp",
    fileDate: "2026-04-29T05:59:13.64Z",
    fileSizeBytes: 847732,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 0,
    sha1: "2d689d2d9e5861ea0a382a459fa8fb0a3e4b5091",
    md5: "70b7a87a2078ea22f6ea3781e9de48ea",
    blurb: "Mod by IAFEnvoy. Installed file: uranus-2.4.1-1.21.1-neoforge.jar. Game versions: Client, 1.21.1, NeoForge, Server.",
  },
  {
    name: "Villages&Pillages",
    category: "World",
    contentType: "Mods",
    projectId: 915531,
    fileId: 6266438,
    fileName: "villagesandpillages-neoforge-mc1.21.1-1.0.3.jar",
    author: "Faboslav",
    url: "https://www.curseforge.com/minecraft/mc-mods/villages-and-pillages",
    downloadUrl: "https://edge.forgecdn.net/files/6266/438/villagesandpillages-neoforge-mc1.21.1-1.0.3.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1452/92/256/256/638942184548049224.png",
    fileDate: "2025-03-05T08:32:45.4Z",
    fileSizeBytes: 241257,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "f587626ba0b421f976f4bd1141bcdc3ca9d21abb",
    md5: "09adc14e82f91e43721bb61d9ee7679f",
    blurb: "Mod by Faboslav. Installed file: villagesandpillages-neoforge-mc1.21.1-1.0.3.jar. Game versions: 1.21, NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "Waystones",
    category: "QoL",
    contentType: "Mods",
    projectId: 245755,
    fileId: 8163145,
    fileName: "waystones-neoforge-1.21.1-21.1.34.jar",
    author: "BlayTheNinth",
    url: "https://www.curseforge.com/minecraft/mc-mods/waystones",
    downloadUrl: "https://edge.forgecdn.net/files/8163/145/waystones-neoforge-1.21.1-21.1.34.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1107/108/256/256/638657104456838765.png",
    fileDate: "2026-05-29T06:30:23.75Z",
    fileSizeBytes: 878801,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 1,
    sha1: "6261985211f6484e0427e2de1a10e2f6f8dda1fa",
    md5: "c4e080fd9b472dca2546dd0d69d5dd9b",
    blurb: "Mod by BlayTheNinth. Installed file: waystones-neoforge-1.21.1-21.1.34.jar. Game versions: 1.21.1, NeoForge. 1 required dependency.",
  },
  {
    name: "Weaker day zombie",
    category: "Adventure",
    contentType: "Mods",
    projectId: 944090,
    fileId: 7196572,
    fileName: "weaker_day_zombie_neoforge-1.0.0-neoforge-1.21.1.jar",
    author: "Anteria_",
    url: "https://www.curseforge.com/minecraft/mc-mods/weaker-day-zombie",
    downloadUrl: "https://edge.forgecdn.net/files/7196/572/weaker_day_zombie_neoforge-1.0.0-neoforge-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/912/499/256/256/638367937432854145.png",
    fileDate: "2025-11-07T20:31:17.047Z",
    fileSizeBytes: 19977,
    gameVersions: ["1.21","1.21.5","Client","1.21.4","NeoForge","1.21.3","1.21.7","1.21.1","1.21.6","Server","1.21.2"],
    dependencyCount: 0,
    sha1: "e3c428c9253c9634289e3d0520dcebaabbb20361",
    md5: "741438aadcea13ae0ddc0587c8f77dc5",
    blurb: "Mod by Anteria_. Installed file: weaker_day_zombie_neoforge-1.0.0-neoforge-1.21.1.jar. Game versions: 1.21, 1.21.5, Client, 1.21.4, NeoForge, 1.21.3, 1.21.7, 1.21.1, 1.21.6, Server, 1.21.2.",
  },
  {
    name: "Welcome Back",
    category: "QoL",
    contentType: "Mods",
    projectId: 1428077,
    fileId: 7454257,
    fileName: "welcomeback-1.0.0.jar",
    author: "ElderVoyager",
    url: "https://www.curseforge.com/minecraft/mc-mods/welcome-back",
    downloadUrl: "https://edge.forgecdn.net/files/7454/257/welcomeback-1.0.0.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1610/295/256/256/639039008056414359.png",
    fileDate: "2026-01-13T11:34:20.043Z",
    fileSizeBytes: 23222,
    gameVersions: ["1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "e3a26da6900b9131c8fc66d5522f2885ce0b1a0d",
    md5: "95982c85cd939e5981ed82756087a4fb",
    blurb: "Mod by ElderVoyager. Installed file: welcomeback-1.0.0.jar. Game versions: 1.21.1, NeoForge.",
  },
  {
    name: "Welcome Screen (Modpack Utils Series)",
    category: "QoL",
    contentType: "Mods",
    projectId: 1193211,
    fileId: 6158681,
    fileName: "welcomescreen-neoforge-1.0.0-1.21.1.jar",
    author: "ElocinDev",
    url: "https://www.curseforge.com/minecraft/mc-mods/welcome-screen",
    downloadUrl: "https://edge.forgecdn.net/files/6158/681/welcomescreen-neoforge-1.0.0-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1171/137/256/256/638742332333817329.png",
    fileDate: "2025-02-04T22:00:41.313Z",
    fileSizeBytes: 14783,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 2,
    sha1: "90039ea64081f182cb8569a20c383e86e291c4a3",
    md5: "57889d8127c26824dee6a0799a0fd3d5",
    blurb: "Mod by ElocinDev. Installed file: welcomescreen-neoforge-1.0.0-1.21.1.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server. 2 required dependencies.",
  },
  {
    name: "When Dungeons Arise - Forge!",
    category: "World",
    contentType: "Mods",
    projectId: 442508,
    fileId: 7150870,
    fileName: "DungeonsArise-1.21.1-2.1.68-release.jar",
    author: "Aureljz",
    url: "https://www.curseforge.com/minecraft/mc-mods/when-dungeons-arise",
    downloadUrl: "https://edge.forgecdn.net/files/7150/870/DungeonsArise-1.21.1-2.1.68-release.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/405/21/256/256/637616382422917614.png",
    fileDate: "2025-10-26T05:49:36.423Z",
    fileSizeBytes: 11842679,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "c651339154da7b9e9cf47a80fdef22c4d59cad5c",
    md5: "8c803078cb52411a40201d6e69a23529",
    blurb: "Mod by Aureljz. Installed file: DungeonsArise-1.21.1-2.1.68-release.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "When Dungeons Arise - Seven Seas",
    category: "World",
    contentType: "Mods",
    projectId: 953637,
    fileId: 7142896,
    fileName: "DungeonsAriseSevenSeas-1.21.x-1.0.4-neoforge.jar",
    author: "Aureljz",
    url: "https://www.curseforge.com/minecraft/mc-mods/when-dungeons-arise-seven-seas",
    downloadUrl: "https://edge.forgecdn.net/files/7142/896/DungeonsAriseSevenSeas-1.21.x-1.0.4-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/923/415/256/256/638390067375153270.png",
    fileDate: "2025-10-24T02:08:25.84Z",
    fileSizeBytes: 244981,
    gameVersions: ["1.21","1.21.5","1.21.8","1.21.9","1.21.10","1.21.4","NeoForge","1.21.3","1.21.7","1.21.1","1.21.6","1.21.2"],
    dependencyCount: 0,
    sha1: "ac9edb266a1360e9e4c80ed0b2f931f1505307eb",
    md5: "827e9c4c003954c1d1a0ebccd1cbf2d9",
    blurb: "Mod by Aureljz. Installed file: DungeonsAriseSevenSeas-1.21.x-1.0.4-neoforge.jar. Game versions: 1.21, 1.21.5, 1.21.8, 1.21.9, 1.21.10, 1.21.4, NeoForge, 1.21.3, 1.21.7, 1.21.1, 1.21.6, 1.21.2.",
  },
  {
    name: "Wither Skeleton Tweaks",
    category: "QoL",
    contentType: "Mods",
    projectId: 255902,
    fileId: 6751432,
    fileName: "WitherSkeletonTweaks-1.21.1-10.1.1.jar",
    author: "Shadows_of_Fire",
    url: "https://www.curseforge.com/minecraft/mc-mods/wither-skeleton-tweaks",
    downloadUrl: "https://edge.forgecdn.net/files/6751/432/WitherSkeletonTweaks-1.21.1-10.1.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/99/482/256/256/636308385818104435.png",
    fileDate: "2025-07-10T06:43:08.38Z",
    fileSizeBytes: 21929,
    gameVersions: ["NeoForge","1.21.1"],
    dependencyCount: 1,
    sha1: "eda07efc2f5e47492abe205295b182c219c6199f",
    md5: "04da1e19a9d25a27c08cb382ca6cb5ea",
    blurb: "Mod by Shadows_of_Fire. Installed file: WitherSkeletonTweaks-1.21.1-10.1.1.jar. Game versions: NeoForge, 1.21.1. 1 required dependency.",
  },
  {
    name: "YetAnotherConfigLib",
    category: "Library",
    contentType: "Mods",
    projectId: 667299,
    fileId: 7437845,
    fileName: "yet_another_config_lib_v3-3.8.2+1.21.1-neoforge.jar",
    author: "isXander",
    url: "https://www.curseforge.com/minecraft/mc-mods/yacl",
    downloadUrl: "https://edge.forgecdn.net/files/7437/845/yet_another_config_lib_v3-3.8.2%2b1.21.1-neoforge.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/598/727/256/256/637977258872864320.png",
    fileDate: "2026-01-09T16:34:33.46Z",
    fileSizeBytes: 1118651,
    gameVersions: ["1.21","1.21.1","NeoForge"],
    dependencyCount: 0,
    sha1: "fe270c9f6e0a8142cf316944087f5109cef08bbb",
    md5: "c346120062c3364a0d215c228354030e",
    blurb: "Mod by isXander. Installed file: yet_another_config_lib_v3-3.8.2+1.21.1-neoforge.jar. Game versions: 1.21, 1.21.1, NeoForge.",
  },
  {
    name: "You Died",
    category: "QoL",
    contentType: "Mods",
    projectId: 582464,
    fileId: 5616376,
    fileName: "YouDied-neoforge-1.21-4.0.0.19.jar",
    author: "GoryMoon",
    url: "https://www.curseforge.com/minecraft/mc-mods/you-died",
    downloadUrl: "https://edge.forgecdn.net/files/5616/376/YouDied-neoforge-1.21-4.0.0.19.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/496/695/256/256/637811735967861165.png",
    fileDate: "2024-08-10T22:05:08.637Z",
    fileSizeBytes: 289031,
    gameVersions: ["1.21","Client","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "7ea75ae748f52a36ccaa61610bf69ef1aa53f485",
    md5: "544d6abd6df3f4aae0eba2743f90a3c8",
    blurb: "Mod by GoryMoon. Installed file: YouDied-neoforge-1.21-4.0.0.19.jar. Game versions: 1.21, Client, NeoForge, 1.21.1.",
  },
  {
    name: "YUNG's API (NeoForge)",
    category: "Library",
    contentType: "Mods",
    projectId: 1015100,
    fileId: 6715463,
    fileName: "YungsApi-1.21.1-NeoForge-5.1.6.jar",
    author: "YUNGNICKYOUNG",
    url: "https://www.curseforge.com/minecraft/mc-mods/yungs-api-neoforge",
    downloadUrl: "https://edge.forgecdn.net/files/6715/463/YungsApi-1.21.1-NeoForge-5.1.6.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/992/689/256/256/638507046020036984.png",
    fileDate: "2025-07-01T07:07:59.137Z",
    fileSizeBytes: 388678,
    gameVersions: ["1.21","NeoForge","1.21.1"],
    dependencyCount: 0,
    sha1: "e1c394779fb9e038e4f7a1b4558d0432607d263b",
    md5: "4a27558e0a2fd72512b051525c9abeaf",
    blurb: "Mod by YUNGNICKYOUNG. Installed file: YungsApi-1.21.1-NeoForge-5.1.6.jar. Game versions: 1.21, NeoForge, 1.21.1.",
  },
  {
    name: "Zombie Awareness",
    category: "Adventure",
    contentType: "Mods",
    projectId: 237754,
    fileId: 5731744,
    fileName: "zombieawareness-neoforge-1.21.0-1.13.2.jar",
    author: "Corosus",
    url: "https://www.curseforge.com/minecraft/mc-mods/zombie-awareness",
    downloadUrl: "https://edge.forgecdn.net/files/5731/744/zombieawareness-neoforge-1.21.0-1.13.2.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/52/495/256/256/636115230174450040.png",
    fileDate: "2024-09-17T15:28:04.81Z",
    fileSizeBytes: 304511,
    gameVersions: ["1.21","Client","NeoForge","1.21.1","Server"],
    dependencyCount: 1,
    sha1: "266a95f6fcdb7a629ed6e95d7b3d2b35724dc6a7",
    md5: "387b5dd0044a0d8869150d26bc45062d",
    blurb: "Mod by Corosus. Installed file: zombieawareness-neoforge-1.21.0-1.13.2.jar. Game versions: 1.21, Client, NeoForge, 1.21.1, Server. 1 required dependency.",
  },
  {
    name: "Zombies Eat Animals",
    category: "Adventure",
    contentType: "Mods",
    projectId: 1475936,
    fileId: 8047250,
    fileName: "zombieseatanimals-1.6.1-1.21.1.jar",
    author: "vomiter",
    url: "https://www.curseforge.com/minecraft/mc-mods/zombies-eat-animals",
    downloadUrl: "https://edge.forgecdn.net/files/8047/250/zombieseatanimals-1.6.1-1.21.1.jar",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1701/516/256/256/639080568388659478.png",
    fileDate: "2026-05-06T09:18:27.907Z",
    fileSizeBytes: 40970,
    gameVersions: ["Client","1.21.1","NeoForge","Server"],
    dependencyCount: 1,
    sha1: "b596f9d0ba9a3035454b74f2432dfd7222505e7e",
    md5: "db39f0623fc75169d1b8b5428c70b6c5",
    blurb: "Mod by vomiter. Installed file: zombieseatanimals-1.6.1-1.21.1.jar. Game versions: Client, 1.21.1, NeoForge, Server. 1 required dependency.",
  },
  {
    name: "Alternative Zombified Piglins",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1111960,
    fileId: 5837604,
    fileName: "Alternative Zombified Piglins.zip",
    author: "creep",
    url: "https://www.curseforge.com/minecraft/texture-packs/alternative-zombified-piglins",
    downloadUrl: "https://edge.forgecdn.net/files/5837/604/Alternative%20Zombified%20Piglins.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1089/282/256/256/638632250087781667.png",
    fileDate: "2024-10-23T14:48:06.117Z",
    fileSizeBytes: 100063,
    gameVersions: ["1.17.1","1.16.3","1.19.3","1.20.2","1.21","1.16.1","1.18.1","1.20.5","1.17","1.16","1.19.4","1.16.5","1.18.2","1.19.2","1.20.3","1.20.1","1.20","1.20.6","1.19.1","1.20.4","1.21.3","1.21.1","1.18","1.16.4","1.16.2","1.19","1.21.2"],
    dependencyCount: 0,
    sha1: "0d6d99c314092357073f6f3eeccc8cd7fef38dca",
    md5: "9a120d985ea6b65d773b5a5d2f0f5873",
    blurb: "Resource Pack by creep. Installed file: Alternative Zombified Piglins.zip. Game versions: 1.17.1, 1.16.3, 1.19.3, 1.20.2, 1.21, 1.16.1, 1.18.1, 1.20.5, 1.17, 1.16, 1.19.4, 1.16.5, 1.18.2, 1.19.2, 1.20.3, 1.20.1, 1.20, 1.20.6, 1.19.1, 1.20.4, 1.21.3, 1.21.1, 1.18, 1.16.4, 1.16.2, 1.19, 1.21.2.",
  },
  {
    name: "Better Mana Bar for Iron's Spells 'n Spellbooks",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1071368,
    fileId: 5903132,
    fileName: "Better Fitting XP Mana Bar for Iron's Spells 'n Spellbooks.zip",
    author: "SlayDigger",
    url: "https://www.curseforge.com/minecraft/texture-packs/better-mana-bar-for-irons-spells-n-spellbooks",
    downloadUrl: "https://edge.forgecdn.net/files/5903/132/Better%20Fitting%20XP%20Mana%20Bar%20for%20Iron%27s%20Spells%20%27n%20Spellbooks.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1047/267/256/256/638575559421720324.png",
    fileDate: "2024-11-14T19:06:35.24Z",
    fileSizeBytes: 89182,
    gameVersions: ["1.20.2","1.21","1.19.4","1.18.2","1.19.2","1.20.1","1.20","1.19.1","1.20.4","1.21.1","1.18","1.19"],
    dependencyCount: 0,
    sha1: "02e40ef4418d5d83a493c222ec948dfeb7ddf258",
    md5: "17ba99b3287ea9e76f5f2efb48bd40c1",
    blurb: "Resource Pack by SlayDigger. Installed file: Better Fitting XP Mana Bar for Iron's Spells 'n Spellbooks.zip. Game versions: 1.20.2, 1.21, 1.19.4, 1.18.2, 1.19.2, 1.20.1, 1.20, 1.19.1, 1.20.4, 1.21.1, 1.18, 1.19.",
  },
  {
    name: "Better Zombie Horse",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1317745,
    fileId: 6831018,
    fileName: "CW_Zombie_Horse.zip",
    author: "OnMod",
    url: "https://www.curseforge.com/minecraft/texture-packs/better-zombie-horse",
    downloadUrl: "https://edge.forgecdn.net/files/6831/18/CW_Zombie_Horse.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1380/263/256/256/638895266744387888.png",
    fileDate: "2025-07-31T02:46:32.113Z",
    fileSizeBytes: 12665,
    gameVersions: ["1.20.1"],
    dependencyCount: 0,
    sha1: "5a4f4d4610b6ae5e5423b28f04a1c498df33012c",
    md5: "98f1091dbd173dee8ebd6e3de9132b58",
    blurb: "Resource Pack by OnMod. Installed file: CW_Zombie_Horse.zip. Game versions: 1.20.1.",
  },
  {
    name: "Bits & Tweaks LITE",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 860996,
    fileId: 6582191,
    fileName: "IM-BT [1.21.x] LITE.zip",
    author: "ItsMemed_552",
    url: "https://www.curseforge.com/minecraft/texture-packs/bits-and-tweaks-lite",
    downloadUrl: "https://edge.forgecdn.net/files/6582/191/IM-BT%20%5b1.21.x%5d%20LITE.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/817/58/256/256/638194544950735239.png",
    fileDate: "2025-05-27T00:28:39.193Z",
    fileSizeBytes: 15483847,
    gameVersions: ["1.21","1.21.5","1.21.4","1.21.3","1.21.1","1.21.2"],
    dependencyCount: 0,
    sha1: "ad132ca15be6e42bb31631e723602996161fdc9e",
    md5: "96ed55e72aa1d66308cc3e629b24b8d3",
    blurb: "Resource Pack by ItsMemed_552. Installed file: IM-BT [1.21.x] LITE.zip. Game versions: 1.21, 1.21.5, 1.21.4, 1.21.3, 1.21.1, 1.21.2.",
  },
  {
    name: "Create Style Sophisticated Storages",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1282587,
    fileId: 7707570,
    fileName: "CreateSophiStorage.zip",
    author: "Luna",
    url: "https://www.curseforge.com/minecraft/texture-packs/create-sophisticated-storages",
    downloadUrl: "https://edge.forgecdn.net/files/7707/570/CreateSophiStorage.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1306/805/256/256/638849718833869346.png",
    fileDate: "2026-03-03T21:50:51.217Z",
    fileSizeBytes: 611818,
    gameVersions: ["1.16.3","1.17.1","1.21","1.18.1","1.16.5","1.21.8","1.17","1.18","1.21.4","1.20.1","1.21.1","1.21.3","1.19.1","1.20.4","1.18.2","1.19.2","1.16.4","1.19","1.21.10","1.21.11"],
    dependencyCount: 1,
    sha1: "999020af88b6a14aafc74f21687fcb6259789e11",
    md5: "7a8fed1ba4ddb7363e95fb8b49062936",
    blurb: "Resource Pack by Luna. Installed file: CreateSophiStorage.zip. Game versions: 1.16.3, 1.17.1, 1.21, 1.18.1, 1.16.5, 1.21.8, 1.17, 1.18, 1.21.4, 1.20.1, 1.21.1, 1.21.3, 1.19.1, 1.20.4, 1.18.2, 1.19.2, 1.16.4, 1.19, 1.21.10, 1.21.11. 1 required dependency.",
  },
  {
    name: "Cubic Leaves",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1252004,
    fileId: 7310666,
    fileName: "Cubic Leaves 2.3 (performance).zip",
    author: "zanderest",
    url: "https://www.curseforge.com/minecraft/texture-packs/cubic-leaves",
    downloadUrl: "https://edge.forgecdn.net/files/7310/666/Cubic%20Leaves%202.3%20(performance).zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1326/997/256/256/638862597914301552.png",
    fileDate: "2025-12-09T06:37:05.173Z",
    fileSizeBytes: 827328,
    gameVersions: ["1.16.3","1.13.1","1.17.1","1.21","1.16.1","1.18.1","1.14.3","1.15","1.16","1.13","1.16.5","1.19.3","1.20.2","1.19.4","1.21.8","1.14.4","1.14.1","1.17","1.20.5","1.21.5","1.18","1.21.4","1.20.1","1.20","1.20.6","1.21.1","1.21.6","1.21.3","1.21.7","1.15.2","1.14","1.19.1","1.20.4","1.18.2","1.19.2","1.20.3","1.16.2","1.13.2","1.15.1","1.16.4","1.14.2","1.19","1.21.2","1.21.9","1.21.10","1.21.11"],
    dependencyCount: 0,
    sha1: "3c5d75c2aeef02968276ac164a8eff5736047283",
    md5: "f2b7217e300b3237a3df7f42bc9c35f4",
    blurb: "Resource Pack by zanderest. Installed file: Cubic Leaves 2.3 (performance).zip. Game versions: 1.16.3, 1.13.1, 1.17.1, 1.21, 1.16.1, 1.18.1, 1.14.3, 1.15, 1.16, 1.13, 1.16.5, 1.19.3, 1.20.2, 1.19.4, 1.21.8, 1.14.4, 1.14.1, 1.17, 1.20.5, 1.21.5, 1.18, 1.21.4, 1.20.1, 1.20, 1.20.6, 1.21.1, 1.21.6, 1.21.3, 1.21.7, 1.15.2, 1.14, 1.19.1, 1.20.4, 1.18.2, 1.19.2, 1.20.3, 1.16.2, 1.13.2, 1.15.1, 1.16.4, 1.14.2, 1.19, 1.21.2, 1.21.9, 1.21.10, 1.21.11.",
  },
  {
    name: "Ender Dragon Reborn",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1365932,
    fileId: 7110897,
    fileName: "Ender_Dragon_Reborn-1.0.zip",
    author: "parrie43",
    url: "https://www.curseforge.com/minecraft/texture-packs/ender-dragon-reborn",
    downloadUrl: "https://edge.forgecdn.net/files/7110/897/Ender_Dragon_Reborn-1.0.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1479/422/256/256/638961533905803277.png",
    fileDate: "2025-10-15T19:33:07.307Z",
    fileSizeBytes: 378079,
    gameVersions: ["1.17.1","1.20.2","1.21","1.18.1","1.20.5","1.17","1.19.4","1.18.2","1.19.2","1.20.3","1.20.1","1.20","1.20.6","1.20.4","1.21.1","1.18","1.19"],
    dependencyCount: 0,
    sha1: "40ba70a78e42157c76900d6b47acd33ed6f70307",
    md5: "73951c5eb92e6b74137dc75999584286",
    blurb: "Resource Pack by parrie43. Installed file: Ender_Dragon_Reborn-1.0.zip. Game versions: 1.17.1, 1.20.2, 1.21, 1.18.1, 1.20.5, 1.17, 1.19.4, 1.18.2, 1.19.2, 1.20.3, 1.20.1, 1.20, 1.20.6, 1.20.4, 1.21.1, 1.18, 1.19.",
  },
  {
    name: "Fresh Animations",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 453763,
    fileId: 7670377,
    fileName: "FreshAnimations_v1.10.4.zip",
    author: "FreshLX",
    url: "https://www.curseforge.com/minecraft/texture-packs/fresh-animations",
    downloadUrl: "https://edge.forgecdn.net/files/7670/377/FreshAnimations_v1.10.4.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1402/911/256/256/638909354589974674.png",
    fileDate: "2026-02-24T00:55:14.383Z",
    fileSizeBytes: 850941,
    gameVersions: ["1.21","1.20.2","1.21.8","1.20.5","1.21.5","1.21.4","1.20.1","1.20","1.20.6","1.21.1","1.21.6","1.21.3","1.21.7","1.20.4","1.20.3","1.21.2","1.21.9","1.21.10","1.21.11"],
    dependencyCount: 0,
    sha1: "73db740a6868e043c5e615c036fca2c912615b6e",
    md5: "ab0e8cc3444e98f0fd51ac0d84533d52",
    blurb: "Resource Pack by FreshLX. Installed file: FreshAnimations_v1.10.4.zip. Game versions: 1.21, 1.20.2, 1.21.8, 1.20.5, 1.21.5, 1.21.4, 1.20.1, 1.20, 1.20.6, 1.21.1, 1.21.6, 1.21.3, 1.21.7, 1.20.4, 1.20.3, 1.21.2, 1.21.9, 1.21.10, 1.21.11.",
  },
  {
    name: "Motschen's Better Leaves",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 380969,
    fileId: 7556678,
    fileName: "Better-Leaves-9.5.zip",
    author: "Motschen",
    url: "https://www.curseforge.com/minecraft/texture-packs/motschens-better-leaves",
    downloadUrl: "https://edge.forgecdn.net/files/7556/678/Better-Leaves-9.5.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/317/448/256/256/637421878980974791.png",
    fileDate: "2026-01-31T18:47:21.357Z",
    fileSizeBytes: 1923769,
    gameVersions: ["1.21","1.20.2","1.21.8","1.20.5","1.21.5","1.21.4","1.20.1","1.20","1.20.6","1.21.1","1.21.6","1.21.3","1.21.7","1.20.4","1.20.3","1.21.2","1.21.9","1.21.10","1.21.11","26.1","26.1.1"],
    dependencyCount: 1,
    sha1: "78b7e6cbb1661716423429d2c46ab08266cdf1f8",
    md5: "160295900634077426b1261171d87f29",
    blurb: "Resource Pack by Motschen. Installed file: Better-Leaves-9.5.zip. Game versions: 1.21, 1.20.2, 1.21.8, 1.20.5, 1.21.5, 1.21.4, 1.20.1, 1.20, 1.20.6, 1.21.1, 1.21.6, 1.21.3, 1.21.7, 1.20.4, 1.20.3, 1.21.2, 1.21.9, 1.21.10, 1.21.11, 26.1, 26.1.1. 1 required dependency.",
  },
  {
    name: "Updated Mobs",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1144335,
    fileId: 6030916,
    fileName: "Updated Mobs v.1.1.zip",
    author: "caninegray",
    url: "https://www.curseforge.com/minecraft/texture-packs/updated-mobs",
    downloadUrl: "https://edge.forgecdn.net/files/6030/916/Updated%20Mobs%20v.1.1.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1121/381/256/256/638676717840009191.png",
    fileDate: "2024-12-28T18:26:26.757Z",
    fileSizeBytes: 1105273,
    gameVersions: ["1.20.2","1.21.2-Snapshot","1.21","1.19.4-Snapshot","1.20.5","1.20.2-Snapshot","1.20.5-Snapshot","1.19.4","1.21.1-Snapshot","1.20.3-Snapshot","1.20.3","1.20.1","1.20","1.20.4","1.21-Snapshot","1.20-Snapshot","1.21.1","1.21.2"],
    dependencyCount: 0,
    sha1: "becb6942b06a45c183ec6112b003d881eae938d5",
    md5: "b20281f504a675068e38e6f2b8e1eaf9",
    blurb: "Resource Pack by caninegray. Installed file: Updated Mobs v.1.1.zip. Game versions: 1.20.2, 1.21.2-Snapshot, 1.21, 1.19.4-Snapshot, 1.20.5, 1.20.2-Snapshot, 1.20.5-Snapshot, 1.19.4, 1.21.1-Snapshot, 1.20.3-Snapshot, 1.20.3, 1.20.1, 1.20, 1.20.4, 1.21-Snapshot, 1.20-Snapshot, 1.21.1, 1.21.2.",
  },
  {
    name: "ZombieGirls",
    category: "Resource Pack",
    contentType: "Resource Packs",
    projectId: 1572766,
    fileId: 8235322,
    fileName: "ZombieGirlsV1.zip",
    author: "Pato_taza",
    url: "https://www.curseforge.com/minecraft/texture-packs/zombiegirls",
    downloadUrl: "https://edge.forgecdn.net/files/8235/322/ZombieGirlsV1.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1860/290/256/256/639168402112825559.png",
    fileDate: "2026-06-12T05:50:54.993Z",
    fileSizeBytes: 176213,
    gameVersions: ["1.21","1.21.8","1.21.5","1.21.4","1.21.1","1.21.6","1.21.3","1.21.7","1.21.2","1.21.9","1.21.10","1.21.11","26.1","26.1.1"],
    dependencyCount: 0,
    sha1: "338371e92432e71a77f1aa71ae68e3bbedf853c8",
    md5: "52d7c4dea2657f79a01705ef67d1deee",
    blurb: "Resource Pack by Pato_taza. Installed file: ZombieGirlsV1.zip. Game versions: 1.21, 1.21.8, 1.21.5, 1.21.4, 1.21.1, 1.21.6, 1.21.3, 1.21.7, 1.21.2, 1.21.9, 1.21.10, 1.21.11, 26.1, 26.1.1.",
  },
  {
    name: "FastPBR Shader",
    category: "Shader",
    contentType: "Shaders",
    projectId: 855381,
    fileId: 6247584,
    fileName: "FastPBR_v2.0.zip",
    author: "RRe36",
    url: "https://www.curseforge.com/minecraft/shaders/fastpbr-shader",
    downloadUrl: "https://edge.forgecdn.net/files/6247/584/FastPBR_v2.0.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/810/455/256/256/638182218908856340.png",
    fileDate: "2025-02-28T15:49:28.65Z",
    fileSizeBytes: 1118279,
    gameVersions: ["1.19.3","1.20.2","1.21","1.20.5","1.19.4","1.21.4","1.18.2","1.19.2","1.20.3","1.20.1","1.20","1.20.6","1.19.1","1.20.4","1.21.3","1.21.1","Iris","1.19","1.21.2"],
    dependencyCount: 0,
    sha1: "dcf1d699eee388c08dedc5eaef039d58a8e0849d",
    md5: "8fa3ed95db13562ba00218dcdf785520",
    blurb: "Shader by RRe36. Installed file: FastPBR_v2.0.zip. Game versions: 1.19.3, 1.20.2, 1.21, 1.20.5, 1.19.4, 1.21.4, 1.18.2, 1.19.2, 1.20.3, 1.20.1, 1.20, 1.20.6, 1.19.1, 1.20.4, 1.21.3, 1.21.1, Iris, 1.19, 1.21.2.",
  },
  {
    name: "Mellow",
    category: "Shader",
    contentType: "Shaders",
    projectId: 1113130,
    fileId: 8131676,
    fileName: "Mellow Shader v3.2.zip",
    author: "TheCMK",
    url: "https://www.curseforge.com/minecraft/shaders/mellow",
    downloadUrl: "https://edge.forgecdn.net/files/8131/676/Mellow%20Shader%20v3.2.zip",
    thumbnailUrl: "https://media.forgecdn.net/avatars/thumbnails/1090/424/256/256/638633962792872199.png",
    fileDate: "2026-05-23T07:27:37.997Z",
    fileSizeBytes: 629784,
    gameVersions: ["1.16.3","1.13.1","1.9.3","1.8.7","1.17.1","1.9.1","1.21","1.16.1","1.18.1","1.14.3","1.15","1.16","1.13","1.16.5","1.10.2","1.19.3","1.20.2","1.19.4","1.21.8","1.8.8","1.9.4","1.9.2","1.8.4","1.14.4","1.14.1","1.12.1","1.17","1.12","1.20.5","1.21.5","1.18","1.21.4","1.8.3","1.11","1.20.1","1.20","OptiFine","1.20.6","1.10","1.10.1","1.21.1","1.21.6","1.8","1.21.3","1.21.7","1.8.6","1.15.2","1.14","1.19.1","1.20.4","1.18.2","1.19.2","1.20.3","1.11.1","1.16.2","1.11.2","1.8.9","1.8.1","1.13.2","1.15.1","1.8.5","1.12.2","Iris","1.8.2","1.16.4","1.14.2","1.19","1.21.2","1.9","1.21.9","1.21.10","1.21.11","26.1","26.1.1","26.1.2"],
    dependencyCount: 0,
    sha1: "1dafdeb90ea0ba507a27ecdd0217d0f6f44a2d77",
    md5: "e68d4c4567ad6335885afcf673934fa8",
    blurb: "Shader by TheCMK. Installed file: Mellow Shader v3.2.zip. Game versions: 1.16.3, 1.13.1, 1.9.3, 1.8.7, 1.17.1, 1.9.1, 1.21, 1.16.1, 1.18.1, 1.14.3, 1.15, 1.16, 1.13, 1.16.5, 1.10.2, 1.19.3, 1.20.2, 1.19.4, 1.21.8, 1.8.8, 1.9.4, 1.9.2, 1.8.4, 1.14.4, 1.14.1, 1.12.1, 1.17, 1.12, 1.20.5, 1.21.5, 1.18, 1.21.4, 1.8.3, 1.11, 1.20.1, 1.20, OptiFine, 1.20.6, 1.10, 1.10.1, 1.21.1, 1.21.6, 1.8, 1.21.3, 1.21.7, 1.8.6, 1.15.2, 1.14, 1.19.1, 1.20.4, 1.18.2, 1.19.2, 1.20.3, 1.11.1, 1.16.2, 1.11.2, 1.8.9, 1.8.1, 1.13.2, 1.15.1, 1.8.5, 1.12.2, Iris, 1.8.2, 1.16.4, 1.14.2, 1.19, 1.21.2, 1.9, 1.21.9, 1.21.10, 1.21.11, 26.1, 26.1.1, 26.1.2.",
  },
]

export default mods
